"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4817],{

/***/ 78063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLexusInfo = function SvgLexusInfo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 16.029A7.529 7.529 0 1 0 8.5.97a7.529 7.529 0 0 0 0 15.058Zm0 .971a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.971 6.885v6.678H8V6.885h.971ZM8.971 4v1.214H8V4h.971Z",
    fill: "#101010"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgLexusInfo);

/***/ }),

/***/ 26659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.846,
    d: "m.653 8.503 4.923 4.923M4.271 13.424 15.348 2.348"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgTick);

/***/ }),

/***/ 25991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgToyotaInfo = function SvgToyotaInfo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 16.029A7.529 7.529 0 1 0 8.5.97a7.529 7.529 0 0 0 0 15.058Zm0 .971a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z",
    fill: "#282830"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.59 4.857a.91.91 0 1 0 1.82 0 .91.91 0 0 0-1.82 0ZM7.59 8.025a.91.91 0 0 1 1.821 0v4.25a.91.91 0 0 1-1.821 0v-4.25Z",
    fill: "#282830"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgToyotaInfo);

/***/ }),

/***/ 28484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 15.086A7.086 7.086 0 1 0 8 .915a7.086 7.086 0 0 0 0 14.171zM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.6-7.142a.6.6 0 0 1-1.2 0l-.214-4.287a.815.815 0 1 1 1.629 0L8.6 8.858zM8 10.572a.857.857 0 1 1 0 1.714.857.857 0 0 1 0-1.714z",
    clipRule: "evenodd",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgWarning);

/***/ }),

/***/ 68113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I0": function() { return /* reexport */ baseInputs_checkbox; },
  "KN": function() { return /* reexport */ datepicker; },
  "_V": function() { return /* reexport */ day; },
  "U5": function() { return /* reexport */ email; },
  "il": function() { return /* reexport */ masked_text; },
  "xQ": function() { return /* reexport */ month; },
  "Y2": function() { return /* reexport */ number; },
  "EU": function() { return /* reexport */ radiobutton; },
  "lq": function() { return /* reexport */ baseInputs_select; },
  "z0": function() { return /* reexport */ baseInputs_button; },
  "RT": function() { return /* reexport */ tel; },
  "oi": function() { return /* reexport */ baseInputs_text; },
  "sJ": function() { return /* reexport */ baseInputs_textarea; },
  "sM": function() { return /* reexport */ toggle; },
  "R5": function() { return /* reexport */ year; }
});

// UNUSED EXPORTS: SwitchInput

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/assets/icons/lexusArrow.svg
var lexusArrow = __webpack_require__(34024);
// EXTERNAL MODULE: ./src/contexts/useBrand.tsx
var useBrand = __webpack_require__(25765);
;// CONCATENATED MODULE: ./src/components/form/baseInputs/button.tsx



const SubmitInput = (param)=>{
    let { children , isSubmitting , isSubmitSuccessful , ...rest } = param;
    const brand = (0,useBrand/* useBrand */.D)();
    if (brand === "lexus") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            ...rest,
            type: "submit",
            className: "group inline-flex items-center justify-center flex-none rounded-btn !leading-10 pl-4 uppercase !bg-secondary text-white outline-0 !hover:opacity-50 !active:opacity-50 !focus:opacity-50 !disabled:cursor-not-allowed !disabled:opacity-50 ".concat(isSubmitting || isSubmitSuccessful ? "!secondary-hover !opacity-50 !cursor-not-allowed !pointer-events-none" : ""),
            children: [
                isSubmitting && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loader",
                    children: "Loading..."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-sm text-center font-semibold !leading-[44px]",
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lexusArrow/* default */.Z, {
                    className: "ml-2 mr-4 group-hover:mx-3"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        type: "submit",
        className: "inline-flex items-center justify-center flex-none rounded-btn px-6 py-3 text-white !outline-0 bg-base hover:bg-base-hover active:bg-base-hover focus:bg-base-hover !disabled:cursor-not-allowed disabled:bg-base-hover ".concat(isSubmitting || isSubmitSuccessful ? "!bg-base-hover !cursor-not-allowed !pointer-events-none" : ""),
        children: [
            isSubmitting && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loader",
                children: "Loading..."
            }),
            children
        ]
    });
};
/* harmony default export */ var baseInputs_button = (SubmitInput);

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(75367);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(56572);
;// CONCATENATED MODULE: ./src/components/form/baseInputs/checkbox.tsx



const CheckboxInput = (param)=>{
    let { name , label , children , hideError =false , group , disabled , indent =false , ...rest } = param;
    const { register , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error  } = getFieldState(name, formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block ".concat(indent ? "ml-6" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mt-2",
            "data-gt-name": "componentevent",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "inline-flex items-baseline cursor-pointer ".concat(disabled ? "opacity-60 cursor-default" : ""),
                        htmlFor: group || name,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: group || name,
                                name: name,
                                className: (0,bundle_mjs/* twMerge */.m6)("rounded border-base text-base cursor-pointerfocus:border-blue focus:ring focus:ring-offset-0 focus:ring-blue group-checked:border-base", error && "border-red", disabled && "cursor-default"),
                                type: "checkbox",
                                disabled: disabled,
                                "aria-invalid": error ? "true" : "false",
                                "data-gt-action": "checkbox-input-interaction",
                                "data-gt-label": name,
                                ...register(name),
                                ...rest
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-2 normal-case",
                                children: label || children
                            })
                        ]
                    }),
                    error && !hideError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var baseInputs_checkbox = (CheckboxInput);

// EXTERNAL MODULE: ./src/assets/icons/tick.svg
var tick = __webpack_require__(26659);
// EXTERNAL MODULE: ./src/assets/icons/warning.svg
var warning = __webpack_require__(28484);
;// CONCATENATED MODULE: ./src/components/form/baseInputs/date/day.tsx




const DayInput = (param)=>{
    let { name , ...rest } = param;
    const { register , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lg:col-span-2 col-span-1",
        "data-gt-name": "componentevent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:col-span-2 lg:col-span-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "block",
                    htmlFor: name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: name,
                                className: "rounded-input block w-full p-[0.7rem] pr-12 ".concat(error && "border-red", " ").concat(!error && isTouched && isDirty && "border-green"),
                                type: "text",
                                placeholder: "DD",
                                "aria-invalid": error ? "true" : "false",
                                "data-gt-action": "text-input-interaction",
                                "data-gt-label": name,
                                ...register(name),
                                ...rest
                            }),
                            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red"
                            }),
                            !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green"
                            })
                        ]
                    })
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-red text-tiny mt-1",
                    role: "alert",
                    children: error.message
                })
            ]
        })
    });
};
/* harmony default export */ var day = (DayInput);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/date/month.tsx




const MonthInput = (param)=>{
    let { name , ...rest } = param;
    const { register , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lg:col-span-2 col-span-1",
        "data-gt-name": "componentevent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:col-span-2 lg:col-span-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "block",
                    htmlFor: name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: name,
                                className: "rounded-input block w-full p-[0.7rem] pr-12 ".concat(error && "border-red", " ").concat(!error && isTouched && isDirty && "border-green"),
                                type: "text",
                                placeholder: "MM",
                                "aria-invalid": error ? "true" : "false",
                                "data-gt-action": "text-input-interaction",
                                "data-gt-label": name,
                                ...register(name),
                                ...rest
                            }),
                            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red"
                            }),
                            !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green"
                            })
                        ]
                    })
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-red text-tiny mt-1",
                    role: "alert",
                    children: error.message
                })
            ]
        })
    });
};
/* harmony default export */ var month = (MonthInput);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/date/year.tsx




const YearInput = (param)=>{
    let { name , ...rest } = param;
    const { register , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lg:col-span-2 col-span-1",
        "data-gt-name": "componentevent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:col-span-2 lg:col-span-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "block",
                    htmlFor: name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: name,
                                className: "rounded-input block w-full p-[0.7rem] pr-12 ".concat(error && "border-red", " ").concat(!error && isTouched && isDirty && "border-green"),
                                type: "text",
                                placeholder: "YYYY",
                                "aria-invalid": error ? "true" : "false",
                                "data-gt-action": "text-input-interaction",
                                "data-gt-label": name,
                                ...register(name),
                                ...rest
                            }),
                            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red"
                            }),
                            !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green"
                            })
                        ]
                    })
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-red text-tiny mt-1",
                    role: "alert",
                    children: error.message
                })
            ]
        })
    });
};
/* harmony default export */ var year = (YearInput);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./src/assets/icons/calendar.svg
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8H2V6.8h12V8ZM6 0v4.667H4.8V0H6ZM11.335 0v4.667h-1.2V0h1.2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.467 2.533H2.534V14.8h10.933V2.533Zm-12.133-1.2V16h13.333V1.333H1.334Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var calendar = (SvgCalendar);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(67958);
// EXTERNAL MODULE: ./src/utils/helpers/tracking.ts + 1 modules
var tracking = __webpack_require__(68379);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(28544);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(51521);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(31558);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
;// CONCATENATED MODULE: ./src/components/form/baseInputs/select.tsx





const SelectInput = (param)=>{
    let { name , label , options , helper , optionsLabel , isChild , optional , extraOnChange , ...rest } = param;
    const { register , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    const { onChange , onBlur , name: registeredName , ref  } = register(name);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: isChild ? "items-start" : "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:col-span-2 lg:col-span-1 text-base-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "block",
                        htmlFor: name,
                        children: [
                            label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-base-text mb-1",
                                children: [
                                    label,
                                    " ",
                                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs lowercase whitespace-nowrap",
                                        children: "(optional)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        id: name,
                                        className: (0,bundle_mjs/* twMerge */.m6)("rounded-input block border-input-border w-full p-[0.7rem] pr-16", error && "border-red", !error && isTouched && isDirty && "border-green"),
                                        "aria-invalid": error ? "true" : "false",
                                        "data-gt-action": "select-input-interaction",
                                        "data-gt-label": name,
                                        onChange: (e)=>{
                                            onChange(e);
                                            if (extraOnChange) extraOnChange(e);
                                        },
                                        onBlur: onBlur,
                                        name: registeredName,
                                        ref: ref,
                                        ...rest,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "",
                                                children: optionsLabel || "Please select"
                                            }),
                                            options.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: item.value,
                                                    children: item.label
                                                }, item.value))
                                        ]
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                        className: "absolute inset-y-0 right-10 top-4 h-4 pointer-events-none text-red"
                                    }),
                                    !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                        className: "absolute inset-y-0 right-10 top-4 h-4 pointer-events-none text-green"
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            }),
            !isChild && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 md:mt-8 flex items-center md:min-h-[50px]",
                children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-tiny leading-5",
                    children: helper
                })
            })
        ]
    });
};
/* harmony default export */ var baseInputs_select = (SelectInput);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/switch.tsx


const SwitchInput = (param)=>{
    let { name  } = param;
    const { register  } = (0,index_esm/* useFormContext */.Gc)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block h-full",
        "data-gt-name": "componentevent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "grid w-full h-full grid-cols-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "radio",
                            id: "time-am",
                            value: "AM",
                            className: "hidden peer",
                            "data-gt-action": "switch-input-interaction",
                            "data-gt-label": name,
                            ...register(name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "time-am",
                            className: "flex items-center justify-center w-full h-full border border-secondary cursor-pointer peer-checked:bg-secondary peer-checked:text-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full",
                                    children: "AM"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "radio",
                            id: "time-pm",
                            value: "PM",
                            className: "hidden peer",
                            "data-gt-action": "switch-input-interaction",
                            "data-gt-label": name,
                            ...register(name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "time-pm",
                            className: "flex items-center justify-center w-full h-full border border-secondary cursor-pointer peer-checked:bg-secondary peer-checked:text-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full",
                                    children: "PM"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var baseInputs_switch = (SwitchInput);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/datepicker.tsx














const DatepickerInput = (param)=>{
    let { name , label , helper , showAmPm , showTime , availability , optional , uppercase , ...rest } = param;
    const { control , watch , setValue , resetField , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const brand = (0,useBrand/* useBrand */.D)();
    const { error , isTouched , isDirty  } = getFieldState("".concat(name, "_input"), formState);
    const watchDatepicker = watch("".concat(name, "_input"), "");
    const handleClear = ()=>{
        setValue(name, "");
        setValue("".concat(name, "_input"), "");
        resetField("".concat(name, "_input"));
    };
    const getBrandClass = ()=>{
        switch(brand){
            case "kinto":
                return "kinto-forms";
            case "lexus":
                return "lexus-forms";
            default:
                return "";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,bundle_mjs/* twMerge */.m6)("grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2 text-base-text", getBrandClass()),
        "data-gt-name": "componentevent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:col-span-2 lg:col-span-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "block",
                        htmlFor: name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "inline-block mb-1 text-base-text",
                            children: [
                                label,
                                " ",
                                optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-xs lowercase whitespace-nowrap",
                                    children: "(optional)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative grid gap-4 grid-cols-6 md:grid-cols-4 lg:grid-cols-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: showTime ? "relative col-span-3 md:col-span-2 lg:col-span-4" : "relative col-span-6 md:col-span-4 lg:col-span-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                        control: control,
                                        name: "".concat(name, "_input"),
                                        render: (param)=>/*#__PURE__*/ {
                                            let { field  } = param;
                                            return (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                                filterDate: availability,
                                                wrapperClassName: "forms-datepicker",
                                                className: (0,bundle_mjs/* twMerge */.m6)("rounded-input border-input-border block w-full p-[0.7rem] pr-12", error && "border-red", !error && isTouched && isDirty && "border-green", uppercase && "uppercase"),
                                                "aria-invalid": error ? "true" : "false",
                                                placeholderText: "Select date",
                                                onChange: (date)=>{
                                                    if (date) {
                                                        field.onChange(date);
                                                        setValue(name, (0,format["default"])(date, "dd/MM/yyyy"));
                                                    }
                                                },
                                                onBlur: (date)=>{
                                                    field.onBlur(date);
                                                },
                                                onCalendarOpen: ()=>{
                                                    (0,tracking/* customEvent */._H)({
                                                        name: "componentevent",
                                                        // componentName needs updating to include form name
                                                        componentName: tracking/* tracking.componentName */.UO.componentName(),
                                                        componentGroup: tracking/* tracking.componentGroup */.UO.componentGroup(),
                                                        action: "datepicker-input-interaction",
                                                        label: "date"
                                                    });
                                                },
                                                selected: field.value,
                                                dateFormat: "dd/MM/yyyy",
                                                minDate: (0,add/* default */.Z)(new Date(), {
                                                    days: 1
                                                }),
                                                maxDate: (0,add/* default */.Z)(new Date(), {
                                                    days: 90
                                                }),
                                                showPopperArrow: false,
                                                autocomplete: "off",
                                                ...rest
                                            });
                                        }
                                    }),
                                    watchDatepicker && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: handleClear,
                                        className: "absolute inset-y-0 right-16 top-3 h-[24px] z-9 text-base cursor-pointer hover:underline",
                                        "data-gt-componentgroup": tracking/* tracking.componentGroup */.UO.componentGroup(),
                                        "data-gt-componentname": tracking/* tracking.componentName */.UO.componentName(),
                                        "data-gt-name": "componentevent",
                                        "data-gt-action": "datepicker-click-cta",
                                        "data-gt-label": "clear",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-tiny",
                                            children: "clear"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar, {
                                        className: "kinto-forms absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-base-text cursor-pointer"
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                        className: "absolute inset-y-0 right-10 top-4 h-4 pointer-events-none text-red"
                                    }),
                                    !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                        className: "absolute inset-y-0 right-10 top-4 h-4 pointer-events-none text-green"
                                    })
                                ]
                            }),
                            showAmPm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-full col-span-2 md:col-span-1 lg:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs_switch, {
                                    name: "time"
                                })
                            }),
                            showTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-3 md:col-span-2 lg:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs_select, {
                                    options: constants/* TIMES */.yu,
                                    optionsLabel: "Select time",
                                    isChild: true,
                                    name: "time"
                                })
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 md:mt-8 flex items-center md:min-h-[50px]",
                children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-tiny leading-5",
                    dangerouslySetInnerHTML: {
                        __html: helper
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var datepicker = (DatepickerInput);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/email.tsx





const EmailInput = (param)=>{
    let { name , label , helper , ...rest } = param;
    const { register , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:col-span-2 lg:col-span-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "block",
                        htmlFor: name,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block mb-1 text-base-text",
                                children: label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: name,
                                        className: (0,bundle_mjs/* twMerge */.m6)("rounded-input border-input-border block w-full p-[0.7rem] pr-12", error && "border-red", !error && isTouched && isDirty && "border-green"),
                                        type: "email",
                                        maxLength: 254,
                                        "aria-invalid": error ? "true" : "false",
                                        "data-gt-action": "email-input-interaction",
                                        "data-gt-label": name,
                                        ...register(name),
                                        ...rest
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red"
                                    }),
                                    !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green"
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 md:mt-8 flex items-center md:min-h-[50px]",
                children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-tiny leading-5",
                    children: helper
                })
            })
        ]
    });
};
/* harmony default export */ var email = (EmailInput);

// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(15241);
;// CONCATENATED MODULE: ./src/components/form/baseInputs/masked-text.tsx





const MaskedText = (param)=>{
    let { name , label , helper , optional , format , mask , ...rest } = param;
    const { getFieldState , formState , control , setValue  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:col-span-2 lg:col-span-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "block",
                        htmlFor: name,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-base mb-1",
                                children: [
                                    label,
                                    " ",
                                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs lowercase whitespace-nowrap",
                                        children: "(optional)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                        name: name,
                                        control: control,
                                        render: (param)=>/*#__PURE__*/ {
                                            let { field  } = param;
                                            return (0,jsx_runtime.jsx)(react_number_format_es/* NumberFormatBase */.F7, {
                                                id: name,
                                                format: format,
                                                mask: mask,
                                                className: "block w-full p-[0.7rem] pr-12 ".concat(error && "border-red", " ").concat(!error && isTouched && isDirty && "border-green"),
                                                type: "text",
                                                "aria-invalid": error ? "true" : "false",
                                                "data-gt-action": "text-input-interaction",
                                                "data-gt-label": name,
                                                onValueChange: (e)=>{
                                                    field.onChange(e.formattedValue);
                                                    setValue(name, e.formattedValue);
                                                },
                                                onBlur: (e)=>{
                                                    field.onBlur(e);
                                                },
                                                value: field.value,
                                                ...rest
                                            });
                                        }
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red"
                                    }),
                                    !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green"
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 md:mt-8 flex items-center md:min-h-[50px]",
                children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-tiny",
                    children: helper
                })
            })
        ]
    });
};
/* harmony default export */ var masked_text = (MaskedText);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/number.tsx






const NumberInput = (param)=>{
    let { name , label , helper , uppercase , optional , ...rest } = param;
    const { getFieldState , formState , control , setValue  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:col-span-2 lg:col-span-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "block",
                        htmlFor: name,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-base-text mb-1",
                                children: [
                                    label,
                                    " ",
                                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs lowercase whitespace-nowrap",
                                        children: "(optional)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                        name: name,
                                        control: control,
                                        render: (param)=>/*#__PURE__*/ {
                                            let { field  } = param;
                                            return (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                id: name,
                                                className: (0,bundle_mjs/* twMerge */.m6)("rounded-input border-input-border block w-full p-[0.7rem] pr-12", error && "border-red", !error && isTouched && isDirty && "border-green", uppercase && "uppercase"),
                                                type: "text",
                                                "aria-invalid": error ? "true" : "false",
                                                "data-gt-action": "text-input-interaction",
                                                "data-gt-label": name,
                                                maxLength: 7,
                                                thousandSeparator: true,
                                                onValueChange: (e)=>{
                                                    field.onChange(e.formattedValue);
                                                    setValue(name, e.floatValue);
                                                },
                                                onBlur: (e)=>{
                                                    field.onBlur(e);
                                                },
                                                value: field.value,
                                                ...rest
                                            });
                                        }
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red"
                                    }),
                                    !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green"
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 md:mt-8 flex items-center md:min-h-[50px]",
                children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-tiny",
                    children: helper
                })
            })
        ]
    });
};
/* harmony default export */ var number = (NumberInput);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/radiobutton.tsx




const RadioButton = (param)=>{
    let { name , label , errorDisabled , ...rest } = param;
    const brand = (0,useBrand/* useBrand */.D)();
    const { register , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error  } = getFieldState(name, formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-gt-name": "componentevent",
        className: "flex items-center text-base-text",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: "".concat(name, "-").concat(rest.value),
                className: (0,bundle_mjs/* twMerge */.m6)("size-5 text-base-text cursor-pointer hover:bg-base-hover checked:border-base checked:bg-transparent ".concat(brand === "kinto" ? "checked:bg-[url('/img/kinto-circle.svg')]" : "checked:bg-[url('/img/circle.svg')]", " checked:hover:bg-transparent checked:hover:border-base checked:focus:bg-transparent checked:focus:border-base"), error && "border-red", errorDisabled && "cursor-default"),
                type: "radio",
                "data-gt-action": "radio-input-interaction",
                "data-gt-label": name,
                ...register(name),
                ...rest
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "".concat(name, "-").concat(rest.value),
                className: "flex items-center cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "pl-3 mr-8 ".concat(error && "text-red"),
                    children: label
                })
            }),
            error && !errorDisabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: error.message
            })
        ]
    });
};
/* harmony default export */ var radiobutton = (RadioButton);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/tel.tsx





const TelInput = (param)=>{
    let { name , label , helper , optional , ...rest } = param;
    const { register , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:col-span-2 lg:col-span-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "block",
                        htmlFor: name,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-base-text mb-1",
                                children: [
                                    label,
                                    " ",
                                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs lowercase whitespace-nowrap",
                                        children: "(optional)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: name,
                                        className: (0,bundle_mjs/* twMerge */.m6)("rounded-input border-input-border block w-full p-[0.7rem] pr-12", error && "border-red", !error && isTouched && isDirty && "border-green"),
                                        type: "tel",
                                        "aria-invalid": error ? "true" : "false",
                                        maxLength: 11,
                                        "data-gt-action": "tel-input-interaction",
                                        "data-gt-label": name,
                                        ...register(name),
                                        ...rest
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red"
                                    }),
                                    !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green"
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 md:mt-8 flex items-center md:min-h-[50px]",
                children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-tiny leading-5",
                    children: helper
                })
            })
        ]
    });
};
/* harmony default export */ var tel = (TelInput);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/text.tsx





const TextInput = (param)=>{
    let { name , label , helper , optional , uppercase , unpadded , ...rest } = param;
    const { register , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " ".concat(!unpadded ? "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2" : "", " md:gap-4 items-start justify-top mb-4 md:mb-2"),
        "data-gt-name": "componentevent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:col-span-2 lg:col-span-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "block",
                        htmlFor: name,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-base-text mb-1",
                                children: [
                                    label,
                                    " ",
                                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs lowercase whitespace-nowrap",
                                        children: "(optional)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: name,
                                        className: (0,bundle_mjs/* twMerge */.m6)("rounded-input border-input-border block w-full p-[0.7rem] pr-12", error && "border-red", !error && isTouched && isDirty && "border-green", uppercase && "uppercase"),
                                        type: "text",
                                        "aria-invalid": error ? "true" : "false",
                                        "data-gt-action": "text-input-interaction",
                                        "data-gt-label": name,
                                        ...register(name),
                                        ...rest
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red"
                                    }),
                                    !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green"
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            }),
            !unpadded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 md:mt-8 flex items-center md:min-h-[50px]",
                children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-tiny",
                    dangerouslySetInnerHTML: {
                        __html: helper
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var baseInputs_text = (TextInput);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/textarea.tsx






const TextareaInput = (param)=>{
    let { optional , name , label , helper , characterLimit =144 , ...rest } = param;
    const { register , watch , getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    const [count, setCount] = (0,react.useState)(characterLimit);
    (0,react.useEffect)(()=>{
        const subscription = watch((value)=>{
            var ref;
            setCount(characterLimit - (((ref = value[name]) === null || ref === void 0 ? void 0 : ref.length) || 0));
        });
        return ()=>subscription.unsubscribe();
    }, [
        watch,
        name
    ]);
    const CharacterCount = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: count <= 10 ? "text-red" : "",
            children: [
                count,
                " Character",
                count === 1 ? "" : "s",
                " left"
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:col-span-2 lg:col-span-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "block",
                        htmlFor: name,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-base-text mb-1",
                                children: [
                                    label,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-xs lowercase whitespace-nowrap",
                                        children: [
                                            " ",
                                            label && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    "(",
                                                    optional && "optional - ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CharacterCount, {}),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                        id: name,
                                        className: (0,bundle_mjs/* twMerge */.m6)("rounded-input border-input-border block w-full p-[0.7rem] pr-12", error && "border-red", !error && isTouched && isDirty && "border-green"),
                                        rows: 3,
                                        maxLength: characterLimit,
                                        "aria-invalid": error ? "true" : "false",
                                        "data-gt-action": "text-area-input-interaction",
                                        "data-gt-label": name,
                                        ...register(name),
                                        ...rest
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red"
                                    }),
                                    !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                        className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green"
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 md:mt-8 flex items-center md:min-h-[50px]",
                children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-tiny leading-5",
                    children: helper
                })
            })
        ]
    });
};
/* harmony default export */ var baseInputs_textarea = (TextareaInput);

// EXTERNAL MODULE: ./node_modules/upper-case-first/dist.es2015/index.js
var dist_es2015 = __webpack_require__(85298);
;// CONCATENATED MODULE: ./src/components/form/baseInputs/toggle.tsx



const ToggleInput = (param)=>{
    let { onChange  } = param;
    const brand = (0,useBrand/* useBrand */.D)();
    const handleChange = (e)=>{
        onChange(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block mb-4",
        "data-gt-name": "componentevent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mt-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    htmlFor: "auth",
                    className: "inline-flex relative items-center cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            value: "",
                            id: "auth",
                            className: "sr-only peer",
                            "data-gt-action": "toggle-input-interaction",
                            "data-gt-label": "autofill",
                            onChange: (e)=>{
                                handleChange(e);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative w-11 h-6 border-2 border-base peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] peer-checked:after:left-[6px] after:bg-base after:border-base after:border after:rounded-full after:h-[16px] after:w-[16px] after:transition-all"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "ml-2 font-medium",
                            children: [
                                "Fill in your details from My",
                                (0,dist_es2015/* upperCaseFirst */.l)(brand),
                                "?"
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var toggle = (ToggleInput);

;// CONCATENATED MODULE: ./src/components/form/baseInputs/index.ts



















/***/ }),

/***/ 72028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _baseInputs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68113);


const ClosestDealers = (param)=>{
    let { helper , dealers , label , optional , ...rest } = param;
    const name = "dealer";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_baseInputs__WEBPACK_IMPORTED_MODULE_1__/* .SelectInput */ .lq, {
        name: name,
        label: label,
        options: dealers,
        helper: helper,
        optional: optional,
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClosestDealers);


/***/ }),

/***/ 68143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ij": function() { return /* reexport */ fields_AddressLookup; },
  "Se": function() { return /* reexport */ fields_AgreementNo; },
  "Pl": function() { return /* reexport */ fields_AuthFill; },
  "cA": function() { return /* reexport */ fields_BookingReference; },
  "zx": function() { return /* reexport */ fields_Button; },
  "FF": function() { return /* reexport */ ClosestDealers/* default */.Z; },
  "Ek": function() { return /* reexport */ fields_Colour; },
  "HW": function() { return /* reexport */ fields_Comments; },
  "Ew": function() { return /* reexport */ fields_CommunicationsPreferences; },
  "zo": function() { return /* reexport */ fields_CompanyName; },
  "Q1": function() { return /* reexport */ fields_CompanyType; },
  "HN": function() { return /* reexport */ fields_ContactGrid; },
  "vV": function() { return /* reexport */ fields_ContactMirai; },
  "j8": function() { return /* reexport */ fields_ContactPreferences; },
  "rG": function() { return /* reexport */ fields_CustomRadio; },
  "fS": function() { return /* reexport */ fields_CustomerConsent; },
  "Ej": function() { return /* reexport */ fields_Date; },
  "PI": function() { return /* reexport */ fields_DateMask; },
  "nH": function() { return /* reexport */ fields_DateOfBirth; },
  "GJ": function() { return /* reexport */ fields_DateOfBirthMask; },
  "xd": function() { return /* reexport */ fields_DealerFinder; },
  "fD": function() { return /* reexport */ fields_Dealers; },
  "vb": function() { return /* reexport */ fields_DropDown; },
  "GT": function() { return /* reexport */ fields_Email; },
  "QL": function() { return /* reexport */ fields_FinancialTerms; },
  "$x": function() { return /* reexport */ Map_FindDealer; },
  "SW": function() { return /* reexport */ fields_FirstName; },
  "cK": function() { return /* reexport */ fields_FullName; },
  "GR": function() { return /* reexport */ fields_Grade; },
  "fC": function() { return /* reexport */ fields_IsCurrentOwner; },
  "Xq": function() { return /* reexport */ fields_JobTitle; },
  "uQ": function() { return /* reexport */ fields_LastName; },
  "nb": function() { return /* reexport */ fields_MarketingConsent; },
  "P": function() { return /* reexport */ fields_MarketingConsentKinto; },
  "Fz": function() { return /* reexport */ fields_MarketingConsentSimple; },
  "Jy": function() { return /* reexport */ fields_MarketingTerms; },
  "q1": function() { return /* reexport */ fields_MembershipNo; },
  "eB": function() { return /* reexport */ fields_Mileage; },
  "fZ": function() { return /* reexport */ fields_ModelGrid; },
  "kk": function() { return /* reexport */ fields_Models; },
  "Kq": function() { return /* reexport */ fields_MultiSelectModels; },
  "fi": function() { return /* reexport */ fields_Occupation; },
  "_u": function() { return /* reexport */ fields_PartEx; },
  "nf": function() { return /* reexport */ fields_PaymentConsent; },
  "vJ": function() { return /* reexport */ fields_PaymentDuration; },
  "w0": function() { return /* reexport */ fields_Postcode; },
  "fK": function() { return /* reexport */ fields_PreferenceTerms; },
  "Ty": function() { return /* reexport */ fields_PrivateOrCompanyCar; },
  "s_": function() { return /* reexport */ fields_RetentionCertificate; },
  "$r": function() { return /* reexport */ TGBCommonID; },
  "ki": function() { return /* reexport */ fields_Tel; },
  "oi": function() { return /* reexport */ TextInput; },
  "Dx": function() { return /* reexport */ fields_Title; },
  "gk": function() { return /* reexport */ fields_UnsubscribeTerms; },
  "Jp": function() { return /* reexport */ fields_UsedCarCard; },
  "Mb": function() { return /* reexport */ fields_VehicleRegNo; },
  "l": function() { return /* reexport */ fields_YesNo; }
});

// UNUSED EXPORTS: EmailConfirm, Map, MarketingUnsubscribe, ShowroomTerms

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/components/form/baseInputs/index.ts + 17 modules
var baseInputs = __webpack_require__(68113);
// EXTERNAL MODULE: ./src/contexts/useBrand.tsx
var contexts_useBrand = __webpack_require__(25765);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(46392);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(50195);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(75367);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(56572);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(67958);
// EXTERNAL MODULE: ./src/utils/helpers/tracking.ts + 1 modules
var helpers_tracking = __webpack_require__(68379);
;// CONCATENATED MODULE: ./src/components/form/fields/DropDown.tsx





const DropDown = (param)=>{
    let { name , optionsLabel , ...rest } = param;
    const { setValue  } = (0,index_esm/* useFormContext */.Gc)();
    const types = {
        model: {
            label: rest.label || "Model",
            options: [
                ...rest.options || []
            ].map((model)=>{
                var ref, ref1, ref2;
                return {
                    label: model.name + ((model === null || model === void 0 ? void 0 : (ref = model.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.fuel) === null || ref1 === void 0 ? void 0 : ref1.includes("Hybrid")) ? " HYBRID" : ""),
                    value: (ref2 = model.d4t4) === null || ref2 === void 0 ? void 0 : ref2.id
                };
            })
        },
        title: {
            label: "Title",
            options: constants/* TITLES */.$w
        },
        feet_size: {
            label: "Fleet size",
            options: constants/* FLEET_SIZE */.Po
        },
        type_of_enquiry: {
            label: rest.label || "What would you like to discuss?",
            options: rest.options
        }
    };
    const handleChange = (e)=>{
        setValue(name, e.target.value, {
            shouldDirty: true
        });
        if (name === "model") {
            const selectedModel = [
                ...rest.options || []
            ].filter((model)=>{
                return e.target.value === model.d4t4.id;
            });
            if (selectedModel.length > 0) {
                (0,helpers_tracking/* updateDatalayer */.WX)("model", {
                    name: selectedModel[0].name,
                    id: selectedModel[0].image.id
                });
            } else {
                (0,helpers_tracking/* updateDatalayer */.WX)("model", false);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* SelectInput */.lq, {
        optionsLabel: optionsLabel,
        name: name,
        ...types[name],
        onChange: handleChange,
        ...rest
    });
};
/* harmony default export */ var fields_DropDown = (DropDown);

;// CONCATENATED MODULE: ./src/components/form/fields/YearsMonths.tsx


const YearsMonths = (param)=>{
    let { historicLabel , optional , prefix , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "block mt-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "inline-block text-base-text mb-1",
                    children: [
                        historicLabel,
                        " ",
                        optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-xs lowercase whitespace-nowrap",
                            children: "(optional)"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid lg:grid-cols-4 grid-cols-2 md:grid-cols-3 gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
                        unpadded: true,
                        name: "".concat(prefix, "years"),
                        label: "Years",
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
                        unpadded: true,
                        name: "".concat(prefix, "months"),
                        label: "Months",
                        ...rest
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_YearsMonths = (YearsMonths);

;// CONCATENATED MODULE: ./src/components/form/fields/AddressLookup/index.tsx










const AddressLookup = (param)=>{
    let { prefix ="" , label ="Postcode" , optional , optionsLabel , helper , historic , historicLabel , ...rest } = param;
    const { getValues , setValue , formState , resetField  } = (0,index_esm/* useFormContext */.Gc)();
    const [suggestions, setSuggestions] = (0,react.useState)([]);
    const [manualInput, openManualInput] = (0,react.useState)(false);
    const [searchTerm, setSearchterm] = (0,react.useState)("");
    const [isSearching, setIsSearching] = (0,react.useState)(false);
    const [isDropdownSearching, setIsDropdownSearching] = (0,react.useState)(false);
    const [showSuggestions, setShowSuggestions] = (0,react.useState)(false);
    const brand = (0,contexts_useBrand/* useBrand */.D)();
    const { errors  } = formState;
    const handleShowManual = ()=>{
        openManualInput(!manualInput);
    };
    (0,react.useEffect)(()=>{
        if (getValues("".concat(prefix, "postcode"))) {
            openManualInput(true);
        }
    }, [
        manualInput
    ]);
    const handleAddress = (address)=>{
        setValue("".concat(prefix, "address_line1"), address.line_1, {
            shouldDirty: true,
            shouldTouch: true
        });
        setValue("".concat(prefix, "address_line2"), address.line_2, {
            shouldDirty: true,
            shouldTouch: true
        });
        setValue("".concat(prefix, "town"), address.town_or_city, {
            shouldDirty: true,
            shouldTouch: true
        });
        setValue("".concat(prefix, "county"), address.county, {
            shouldDirty: true,
            shouldTouch: true
        });
        setValue("".concat(prefix, "postcode"), address.postcode, {
            shouldDirty: true,
            shouldTouch: true
        });
        setValue("".concat(prefix, "full_address"), address);
        openManualInput(true);
    };
    const handleNewSearch = ()=>{
        resetField("".concat(prefix, "address_line1"));
        resetField("".concat(prefix, "address_line2"));
        resetField("".concat(prefix, "town"));
        resetField("".concat(prefix, "county"));
        resetField("".concat(prefix, "postcode"));
    };
    let apiToken;
    switch(brand){
        case "lexus":
            apiToken = "dtoken_hEDzcyiWMr3IjOzev9WM5UUyI1ADaRpOYddBfLLUcvE52gG5ABrUF41eyhADhPZyB5ACEJ89VEZA5idO995nZ8SsFDobTfRRsL_kAdBlERC2R6h4CLB5LxgGFxFO_SgqthrQJPivbkf7Ao60jiU-xaibo3DfvfKweiyftmcRbkYTyrN6UzIu8brm-O9jmRDi61F5v4qlyJ8";
            break;
        case "kinto":
            apiToken = "dtoken_hEDzcyiWMr3IjOzev9WM5UUyI1ADaRpOYddBfLLUcvE52gG5ABrUF41eyhADhPZyB5ACEJ89VEY8ROpJthBAcfLzYHTflVv19NlE8ca-wxqwv-QB0GUREJwBw7AuH0d0kLuVcyv6SbC40OZJxLmaegonABQaihMJ9Prdq-6skLnjeLfX3tGfa0qaCkz7rqZkeFc6qAj5EBmDjBdqNq0wyi8x60QlqsJi";
            break;
        default:
            apiToken = "dtoken_hEDzcyiWMr3IjOzev9WM5UUyI1ADaRpOYddBfLLUcvE52gG5ABrUF41eyhADhPZyB5ACEJ89VEYvs6nZoBt2vuVrp1jlx4w039rYOE2F1aG1jN0psTNtvHhuicZMg-998ZuJOgY_oEyxk3Aw4_ZrM48_Cu-UzYqGb4XY7Ji3hHb24yvAOAlo5jpAnxOhkYmWaMVXydISsOsyiCLtHZEylg";
            break;
    }
    const getAddressList = async ()=>{
        handleNewSearch();
        setIsSearching(true);
        await (0,axios/* default */.ZP)({
            method: "post",
            url: "https://api.getAddress.io/autocomplete/".concat(searchTerm, "?api-key=").concat(apiToken)
        }).then((res)=>{
            const parseAddresses = res.data.suggestions.map((suggestion)=>{
                return {
                    value: suggestion.id,
                    label: suggestion.address
                };
            });
            setSuggestions(parseAddresses);
        }).catch(()=>{
            throw new Error("Network response was not ok");
        }).finally(()=>{
            setIsSearching(false);
            if (searchTerm) {
                setShowSuggestions(true);
            }
        });
    };
    const onChange = async (e)=>{
        const addressId = e.target.value;
        setIsDropdownSearching(true);
        await (0,axios/* default */.ZP)({
            method: "get",
            url: "https://api.getAddress.io/get/".concat(addressId, "?api-key=").concat(apiToken)
        }).then((res)=>{
            handleAddress(res.data);
            setIsDropdownSearching(false);
        }).catch(()=>{
            throw new Error("Network response was not ok");
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 gap-4 items-start justify-top mb-4 md:mb-2",
                "data-gt-name": "componentevent",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:col-span-2 lg:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-base-text mb-1",
                                        children: [
                                            label,
                                            " ",
                                            optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs lowercase whitespace-nowrap",
                                                children: "(optional)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative grid grid-cols-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: (0,bundle_mjs/* twMerge */.m6)("rounded-input border-input-border col-span-3 sm:col-span-4 max-w-full mr-4 p-[0.7rem]"),
                                                type: "text",
                                                "aria-invalid": error["default"] ? "true" : "false",
                                                "data-gt-action": "text-input-interaction",
                                                value: searchTerm,
                                                onChange: (e)=>setSearchterm(e.target.value),
                                                ...rest
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                onClick: getAddressList,
                                                type: "button",
                                                className: "relative ".concat(isSearching ? "opacity-50" : "", " ").concat(brand === "lexus" ? "col-span-3 sm:col-span-2 inline-flex items-center justify-center flex-none uppercase !bg-secondary text-white" : "col-span-3 sm:col-span-2 inline-flex items-center justify-center flex-none rounded-btn px-4 sm:px-6 text-sm sm:text-base !text-white !outline-0 bg-base hover:bg-base-hover active:bg-base-hover focus:bg-base-hover !disabled:cursor-not-allowed disabled:bg-base-hover"),
                                                "data-gt-name": "componentevent",
                                                "data-gt-action": "address-lookup-click-cta",
                                                "data-gt-label": "find address",
                                                children: [
                                                    isSearching && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "loader",
                                                        children: "Loading..."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-tiny",
                                                        children: "Find Address"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: "mb-1 col-span-2 md:col-span-1 lg:col-span-2 text-base-text",
                                onClick: handleShowManual,
                                children: [
                                    manualInput ? "Find address" : "Enter address manually",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        strokeWidth: 1.5,
                                        stroke: "currentColor",
                                        className: "w-[16px] inline-block ml-2 ".concat(manualInput ? "rotate-180" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-1 md:mt-8 flex items-center md:min-h-[50px]",
                        children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-tiny leading-5",
                            dangerouslySetInnerHTML: {
                                __html: helper
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    isDropdownSearching && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "loader-container absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "loader dark",
                            children: "Loading..."
                        })
                    }),
                    showSuggestions && /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_DropDown, {
                        name: "".concat(prefix, "suggestions"),
                        options: suggestions,
                        optionsLabel: optionsLabel,
                        onChange: onChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(!manualInput && !("".concat(prefix, "postcode") in errors) ? "hidden" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
                        name: "".concat(prefix, "address_line1"),
                        label: "Address Line 1",
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
                        name: "".concat(prefix, "address_line2"),
                        label: "Address Line 2",
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
                        name: "".concat(prefix, "town"),
                        label: "Town/City",
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
                        name: "".concat(prefix, "county"),
                        label: "County",
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
                        name: "".concat(prefix, "postcode"),
                        label: "Postcode",
                        ...rest
                    })
                ]
            }),
            historic && /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_YearsMonths, {
                historicLabel: historicLabel,
                prefix: prefix
            })
        ]
    });
};
/* harmony default export */ var fields_AddressLookup = (AddressLookup);

;// CONCATENATED MODULE: ./src/components/form/fields/AgreementNo.tsx


const AgreementNo = (param)=>{
    let { name: inputName , helper , optional , label: inputLabel , ...rest } = param;
    const name = inputName || "agreement_or_reg_num";
    const label = inputLabel || "Agreement OR Registration number";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name,
        label: label,
        helper: helper,
        optional: optional,
        uppercase: true,
        ...rest
    });
};
/* harmony default export */ var fields_AgreementNo = (AgreementNo);

// EXTERNAL MODULE: ./src/contexts/index.tsx + 96 modules
var contexts = __webpack_require__(28798);
// EXTERNAL MODULE: ./node_modules/upper-case-first/dist.es2015/index.js
var dist_es2015 = __webpack_require__(85298);
;// CONCATENATED MODULE: ./src/components/form/fields/AuthFill.tsx





const AuthFill = ()=>{
    const { setValue , trigger  } = (0,index_esm/* useFormContext */.Gc)();
    const user = (0,contexts/* useAuth */.aC)();
    if (!user) {
        return null;
    }
    const handleChange = (e)=>{
        if (e.target.checked) {
            setValue("title", (0,dist_es2015/* upperCaseFirst */.l)(user === null || user === void 0 ? void 0 : user.title));
            setValue("first_name", user === null || user === void 0 ? void 0 : user.firstName);
            setValue("last_name", user === null || user === void 0 ? void 0 : user.lastName);
            setValue("email", user === null || user === void 0 ? void 0 : user.email);
            trigger("title");
            trigger("first_name");
            trigger("last_name");
            trigger("email");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* ToggleInput */.sM, {
        user: user,
        onChange: handleChange
    });
};
/* harmony default export */ var fields_AuthFill = (AuthFill);

;// CONCATENATED MODULE: ./src/components/form/fields/BookingReference.tsx


const BookingReference = (param)=>{
    let { helper , ...rest } = param;
    const name = "booking_ref";
    const label = "Booking reference number";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_BookingReference = (BookingReference);

;// CONCATENATED MODULE: ./src/components/form/fields/Button.tsx



const Button = (param)=>{
    let { children , submitResponse , ...rest } = param;
    const { formState: { isSubmitting , isSubmitSuccessful  }  } = (0,index_esm/* useFormContext */.Gc)();
    let celebrusID = "";
    if (submitResponse) {
        celebrusID = isSubmitSuccessful ? "form-submit" : "form-error";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex space-x-4 items-center mt-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* SubmitInput */.z0, {
                isSubmitting: isSubmitting,
                isSubmitSuccessful: isSubmitSuccessful,
                ...rest,
                children: children
            }),
            submitResponse && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                id: celebrusID,
                className: "font-medium",
                children: submitResponse
            })
        ]
    });
};
/* harmony default export */ var fields_Button = (Button);

// EXTERNAL MODULE: ./src/components/form/fields/ClosestDealers.tsx
var ClosestDealers = __webpack_require__(72028);
;// CONCATENATED MODULE: ./src/components/form/fields/Colour.tsx



const Colour = (param)=>{
    let { helper , grade , optional , ...rest } = param;
    const name = "colours";
    const label = "Colour";
    const colours = {
        Urban: constants/* LEXUS_URBAN_LBX */.ye,
        Premium: constants/* LEXUS_PREM_LBX */.M1,
        "Premium Plus": constants/* LEXUS_PREM_PLUS_LBX */.w7,
        "Premium Plus Design": constants/* LEXUS_PREM_PLUS_DESIGN_LBX */.eS,
        Takumi: constants/* LEXUS_TAKUMI_LBX */.TU,
        "Takumi Design": constants/* LEXUS_TAKUMI_DESIGN_LBX */.IG,
        "Original Edition": constants/* LEXUS_ORIGINAL_LBX */.vp
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* SelectInput */.lq, {
        name: name,
        label: label,
        options: colours[grade],
        helper: helper,
        optional: optional,
        ...rest
    });
};
/* harmony default export */ var fields_Colour = (Colour);

;// CONCATENATED MODULE: ./src/components/form/fields/Comments.tsx


const Comments = (param)=>{
    let { optional , helper , name , characterLimit =144 , ...rest } = param;
    const defaultName = name || "notes";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextareaInput */.sJ, {
        name: defaultName,
        helper: helper,
        characterLimit: characterLimit,
        optional: optional,
        ...rest
    });
};
/* harmony default export */ var fields_Comments = (Comments);

;// CONCATENATED MODULE: ./src/components/form/fields/CommunicationsPreferences.tsx



const CommunicationsPreferences = (param)=>{
    let { inputLabel , ...rest } = param;
    const label = inputLabel || "Communications Preferences";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-l md:text-xl lg:text-2xl mb-3 !leading-snug",
                    children: label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-tiny mb-4",
                    children: "Please select your communications options:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "",
                                    children: " Relevant Offers"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-tiny leading-snug",
                                    children: 'By selecting "Yes" we will send you communications and offers directly or through our dealerships about our and our partners\' products and services that are relevant or may be of interest to you such as communications about upgrades to your vehicle, finance arrangements and finance renewal, insurance and other products and services. This way you will never miss out.'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "radio-btn-container flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                                    errorDisabled: true,
                                    name: "communication_relevantoffers",
                                    label: "Yes",
                                    value: true,
                                    ...rest
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                                    errorDisabled: true,
                                    name: "communication_relevantoffers",
                                    label: "No",
                                    value: false,
                                    ...rest
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var fields_CommunicationsPreferences = (CommunicationsPreferences);

;// CONCATENATED MODULE: ./src/components/form/fields/CompanyName.tsx


const CompanyName = (param)=>{
    let { helper , ...rest } = param;
    const name = "company_name";
    const label = "Company name";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_CompanyName = (CompanyName);

;// CONCATENATED MODULE: ./src/components/form/fields/CompanyType.tsx




const CompanyType = (param)=>{
    let { optional , ...rest } = param;
    const { formState , getFieldState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error  } = getFieldState("company_type", formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "font-medium mt-5 mb-1",
                children: [
                    "How many vehicles does your company run?",
                    " ",
                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs lowercase whitespace-nowrap",
                        children: "(optional)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-btn-container flex gap-2 flex-col mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: "company_type",
                        label: "1 - 25 vehicles",
                        value: "sme",
                        errorDisabled: true,
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: "company_type",
                        label: "26+ vehicles",
                        value: "corporate",
                        errorDisabled: true,
                        ...rest
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_CompanyType = (CompanyType);

// EXTERNAL MODULE: ./src/assets/icons/lexusArrow.svg
var lexusArrow = __webpack_require__(34024);
;// CONCATENATED MODULE: ./src/components/form/fields/ContactGrid/card.tsx





const Card = (param)=>{
    let { form , setUser  } = param;
    const brand = (0,contexts_useBrand/* useBrand */.D)();
    const { setValue  } = (0,index_esm/* useFormContext */.Gc)();
    const handleClick = ()=>{
        setUser(true);
        setValue("form_name", form.id);
    };
    if (!form.active) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full md:w-1/2 lg:w-1/3 p-2 flex flex-col justify-start group-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,bundle_mjs/* twMerge */.m6)("cursor-pointer h-full flex flex-col rounded-card overflow-hidden", brand === "lexus" ? "bg-primary" : "bg-base text-white"),
            "data-gt-name": "componentevent",
            "data-gt-componentgroup": "forms",
            "data-gt-action": "click-type",
            "data-gt-label": form.name,
            onClick: ()=>{
                handleClick();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-64 overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://scene7.toyota.eu/is/image/toyotaeurope/".concat(form.card.img, "?qlt=80&wid=410&hei=300&fit=crop,1"),
                        className: "h-full w-full object-cover object-center",
                        alt: form.name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "font-semibold m-4",
                    children: form.name.toUpperCase()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "m-4 mt-0 grow",
                    children: form.card.desc
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center m-4",
                    children: brand === "lexus" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm text-center font-semibold",
                                children: form.card.cta.toUpperCase()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lexusArrow/* default */.Z, {
                                className: "ml-2 mr-4 group-card-hover:mx-3"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "group-card-hover:underline",
                        children: form.card.cta
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var card = (Card);

;// CONCATENATED MODULE: ./src/components/form/fields/ContactGrid/index.tsx


const ContactGrid = (param)=>{
    let { forms , setUser  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-gt-componentname": "type-grid",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-wrap mb-2 -mx-2 justify-center",
            children: Object.keys(forms).map((form)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(card, {
                    form: forms[form],
                    setUser: setUser
                }, form);
            })
        })
    });
};
/* harmony default export */ var fields_ContactGrid = (ContactGrid);

;// CONCATENATED MODULE: ./src/components/form/fields/ContactMirai.tsx


const ContactMirai = (param)=>{
    let { ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-8",
        "data-gt-componentname": "contact-mirai",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* CheckboxInput */.I0, {
            name: "notes",
            ...rest,
            children: "I would like to be contacted via phone or email to discuss purchasing the Mirai"
        })
    });
};
/* harmony default export */ var fields_ContactMirai = (ContactMirai);

;// CONCATENATED MODULE: ./src/components/form/fields/ContactPreferences.tsx



const ContactPreferences = (param)=>{
    let { inputLabel , ...rest } = param;
    const label = inputLabel || "Contact Preferences";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:col-span-2 lg:col-span-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: " mt-5 mb-1 ",
                    children: label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-tiny mb-4",
                    children: "Please select your contact methods:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-span-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "",
                                        children: "Phone "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "radio-btn-container flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                                            errorDisabled: true,
                                            name: "contact_phone",
                                            label: "Yes",
                                            value: true,
                                            ...rest
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                                            errorDisabled: true,
                                            name: "contact_phone",
                                            label: "No",
                                            value: false,
                                            ...rest
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-span-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "",
                                        children: "Email"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "radio-btn-container flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                                            errorDisabled: true,
                                            name: "contact_email",
                                            label: "Yes",
                                            value: true,
                                            ...rest
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                                            errorDisabled: true,
                                            name: "contact_email",
                                            label: "No",
                                            value: false,
                                            ...rest
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-span-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "",
                                        children: " SMS"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "radio-btn-container flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                                            errorDisabled: true,
                                            name: "contact_sms",
                                            label: "Yes",
                                            value: true,
                                            ...rest
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                                            errorDisabled: true,
                                            name: "contact_sms",
                                            label: "No",
                                            value: false,
                                            ...rest
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-span-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "",
                                        children: " Post"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "radio-btn-container flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                                            errorDisabled: true,
                                            name: "contact_post",
                                            label: "Yes",
                                            value: true,
                                            ...rest
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                                            errorDisabled: true,
                                            name: "contact_post",
                                            label: "No",
                                            value: false,
                                            ...rest
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var fields_ContactPreferences = (ContactPreferences);

;// CONCATENATED MODULE: ./src/components/form/fields/CustomerConsent.tsx



const CustomerConsent = ()=>{
    const brand = (0,contexts/* useBrand */.DY)();
    const privacyLink = "https://www.toyota.co.uk/footer/privacy-policy";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "".concat(brand === "lexus" ? "text-lg" : "font-medium ", " mb-4"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "CHECK: have you read/sent the data compliancy message to the customer?"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-8",
                children: [
                    "Just to let you know, we will pass on your details onto your local Centre to get that booked in for you. For more details, you can find our privacy notice",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline",
                        href: privacyLink,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "consent-click-link",
                        "data-gt-label": privacyLink,
                        children: "here."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* CheckboxInput */.I0, {
                name: "customer_cans_consent",
                value: "yes",
                children: "The customer is aware that their data is being transferred to the Centre"
            })
        ]
    });
};
/* harmony default export */ var fields_CustomerConsent = (CustomerConsent);

;// CONCATENATED MODULE: ./src/components/form/fields/CustomRadio.tsx




const CustomRadio = (param)=>{
    let { label , firstLabel , firstValue , secondLabel , secondValue , name , optional , onChange  } = param;
    const brand = (0,contexts_useBrand/* useBrand */.D)();
    return brand === "kinto" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: name,
                className: "block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-block text-base-text mb-1",
                    children: label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-btn-container flex text-base-text mb-3 min-h-[48px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: name,
                        label: firstLabel,
                        value: firstValue,
                        errorDisabled: true,
                        ...onChange && {
                            onChange
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: name,
                        label: secondLabel,
                        value: secondValue,
                        errorDisabled: true,
                        ...onChange && {
                            onChange
                        }
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "font-medium my-5",
                children: [
                    label,
                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs font-normal lowercase whitespace-nowrap",
                        children: "(optional)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-btn-container flex mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: name,
                        label: firstLabel,
                        value: firstValue,
                        errorDisabled: true,
                        ...onChange && {
                            onChange
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: name,
                        label: secondLabel,
                        value: secondValue,
                        errorDisabled: true,
                        ...onChange && {
                            onChange
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_CustomRadio = (CustomRadio);

;// CONCATENATED MODULE: ./src/components/form/fields/Date.tsx


const Date_Date = (param)=>{
    let { helper , showAmPm , showTime , ...rest } = param;
    const name = "date";
    const label = "Date";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* DatepickerInput */.KN, {
        name: name,
        label: label,
        helper: helper,
        showAmPm: showAmPm,
        showTime: showTime,
        ...rest
    });
};
/* harmony default export */ var fields_Date = (Date_Date);

// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(15241);
;// CONCATENATED MODULE: ./src/components/form/fields/DateMask.tsx



const DateMask = (param)=>{
    let { label: inputLabel , name: inputName , optional , helper , ...rest } = param;
    const name = inputName || "date";
    const label = inputLabel || "Date";
    const { format  } = (0,react_number_format_es/* usePatternFormat */.v5)({
        format: "##/##/####",
        mask: [
            "_"
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* MaskedText */.il, {
        format: format,
        name: name,
        label: label,
        optional: optional,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_DateMask = (DateMask);

;// CONCATENATED MODULE: ./src/components/form/fields/DateOfBirth.tsx


const DateOfBirth = (param)=>{
    let { optional , ...rest } = param;
    const label = "Date of Birth";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:col-span-2 lg:col-span-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "inline-block text-base-text mb-1",
                        children: [
                            label,
                            " ",
                            optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs lowercase whitespace-nowrap",
                                children: "(optional)"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid lg:grid-cols-6 grid-cols-3 gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* DayInput */._V, {
                            label: label,
                            name: "day",
                            ...rest
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* MonthInput */.xQ, {
                            name: "month",
                            ...rest
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* YearInput */.R5, {
                            name: "year",
                            ...rest
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var fields_DateOfBirth = (DateOfBirth);

;// CONCATENATED MODULE: ./src/components/form/fields/DateOfBirthMask.tsx



const DateOfBirthMask = (param)=>{
    let { helper , ...rest } = param;
    const name = "dob";
    const label = "Date of Birth";
    const { format  } = (0,react_number_format_es/* usePatternFormat */.v5)({
        format: "##/##/####",
        mask: [
            "_"
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* MaskedText */.il, {
        format: format,
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_DateOfBirthMask = (DateOfBirthMask);

;// CONCATENATED MODULE: ./src/components/form/fields/DealerFinder/SearchBar.tsx
/* eslint-disable no-console */ 


const SearchBar = (param)=>{
    let { value , hidden , onSearchDataUpdate  } = param;
    const searchInput = (0,react.useRef)(value);
    const [searchDealerName, setSearchDealerName] = (0,react.useState)(false);
    const [nameSearch, setNameSearch] = (0,react.useState)("");
    const [isSearching, setIsSearching] = (0,react.useState)(false);
    const [isDealerFound, setDealerFound] = (0,react.useState)(true);
    const [dealersCount, setDealersCount] = (0,react.useState)(0);
    const brand = (0,contexts/* useBrand */.DY)();
    const query = (0,contexts/* useQuery */.aM)();
    (0,react.useEffect)(()=>{
        if (!searchInput) {
            searchInput.current.value = value;
        }
    }, [
        value
    ]);
    const getDealersList = async (coords, callback)=>{
        setIsSearching(true);
        const url = (query === null || query === void 0 ? void 0 : query.group) ? "https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/".concat(brand, "/gb/en/drive/").concat(coords.lon, "/").concat(coords.lat, "?count=5000&isCurrentLocation=false&services=showroom") : "https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/".concat(brand, "/gb/en/drive/").concat(coords.lon, "/").concat(coords.lat, "?count=4&isCurrentLocation=false&services=showroom");
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();
            if (query === null || query === void 0 ? void 0 : query.group) {
                data.dealers = data.dealers.filter((i)=>i.parent === query.group).slice(0, 4);
                data.total = data.dealers.length;
            }
            data.dealers = data.dealers.filter((i)=>i.services.some((j)=>j.service === "ShowRoom"));
            callback(data);
        } catch (error) {
            console.error("Error:", error);
        } finally{
            setIsSearching(false);
        }
    };
    // SEARCH BY POSTCODE
    const searchByPostcode = (term)=>{
        window.customMap.geocoder.search(term, {
            countryCode: [
                "GB",
                "IM",
                "JE",
                "GG"
            ]
        }).then((geo)=>{
            if (geo.length) {
                const lon = geo[0].coordinates[0];
                const lat = geo[0].coordinates[1];
                getDealersList({
                    lat,
                    lon
                }, (result)=>{
                    setDealersCount(result.dealers.length);
                    setIsSearching(false);
                    setDealerFound(result.dealers.length > 0);
                    onSearchDataUpdate(result.dealers);
                });
            } else {
                setDealerFound(false);
            }
        });
    };
    (0,react.useEffect)(()=>{
        window.customMap = new mapsWrapper.DynamicMap(document.createElement("div"), {
            accessToken: brand === "lexus" ? "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtqZzM5ZTA0bjgzZXBiemJ1ZHYyNDcifQ.Yfrq8kataFBLbN293vWY9A" : "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtpY2R1YTA0YW8zb2xzMzNkaDNxaTMifQ.LHbDy1LeUYXAgS7FJG-VOQ",
            countryCode: [
                "GB",
                "IM",
                "JE",
                "GG"
            ],
            language: "en"
        });
        // add auto complete
        if (!searchDealerName) {
            window.customMapAutoComplete = new mapsWrapper.AutoComplete({
                autoCompleteInput: document.getElementById("postcodeSearch"),
                accessToken: brand === "lexus" ? "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtqZzM5ZTA0bjgzZXBiemJ1ZHYyNDcifQ.Yfrq8kataFBLbN293vWY9A" : "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtpY2R1YTA0YW8zb2xzMzNkaDNxaTMifQ.LHbDy1LeUYXAgS7FJG-VOQ",
                countryCode: [
                    "GB",
                    "IM",
                    "JE",
                    "GG"
                ],
                types: "place,locality,neighborhood,region,postcode",
                onLocationSelect: (location)=>{
                    if (location) {
                        const lon = location.coordinates[0];
                        const lat = location.coordinates[1];
                        getDealersList({
                            lat,
                            lon
                        }, (result)=>{
                            setDealersCount(result.dealers.length);
                            setIsSearching(false);
                            setDealerFound(result.dealers.length > 0);
                            onSearchDataUpdate(result.dealers);
                        });
                    }
                }
            });
        }
    }, [
        searchDealerName
    ]);
    // SEARCH BY DEALERNAME
    const searchByName = async ()=>{
        setIsSearching(true);
        const url = (query === null || query === void 0 ? void 0 : query.group) ? "https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/".concat(brand, "/gb/en/find/name/").concat(nameSearch, "?count=5000&extraCountries=&isCurrentLocation=false&services=showroom") : "https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/".concat(brand, "/gb/en/find/name/").concat(nameSearch, "?count=4&extraCountries=&isCurrentLocation=false&services=showroom");
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();
            if (query === null || query === void 0 ? void 0 : query.group) {
                data.dealers = data.dealers.filter((i)=>i.parent === query.group).slice(0, 4);
                data.total = data.dealers.length;
            }
            data.dealers = data.dealers.filter((i)=>i.services.some((j)=>j.service === "ShowRoom"));
            setDealersCount(data.dealers.length);
            setIsSearching(false);
            setDealerFound(data.dealers.length > 0);
            onSearchDataUpdate(data.dealers);
        } catch (error) {
            if (dealersCount < 0) console.error("Error:", error);
        } finally{
            setIsSearching(false);
        }
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            if (searchDealerName) {
                searchByName();
            } else {
                searchByPostcode(searchInput.current.value);
            }
        }
    };
    // SEARCH BY LOCATION
    const handleUseLocation = ()=>{
        setIsSearching(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(async (position)=>{
                const { latitude , longitude  } = position.coords;
                // Check if latitude and longitude are available
                if (latitude && longitude) {
                    const url = (query === null || query === void 0 ? void 0 : query.group) ? "https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/".concat(brand, "/gb/en/drive/").concat(longitude, "/").concat(latitude, "?count=5000&extraCountries=&isCurrentLocation=false&services=showroom") : "https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/".concat(brand, "/gb/en/drive/").concat(longitude, "/").concat(latitude, "?count=4&extraCountries=&isCurrentLocation=false&services=showroom");
                    try {
                        const response = await fetch(url);
                        if (!response.ok) {
                            throw new Error("Network response was not ok");
                        }
                        const data = await response.json();
                        if (query === null || query === void 0 ? void 0 : query.group) {
                            data.dealers = data.dealers.filter((i)=>i.parent === query.group).slice(0, 4);
                            data.total = data.dealers.length;
                        }
                        data.dealers = data.dealers.filter((i)=>i.services.some((j)=>j.service === "ShowRoom"));
                        setDealersCount(data.dealers.length);
                        setIsSearching(false);
                        setDealerFound(data.dealers.length > 0);
                        onSearchDataUpdate(data.dealers);
                    } catch (error) {
                        console.error("Error in searchByLocation:", error);
                    } finally{
                        setIsSearching(false);
                    }
                } else {
                    console.error("Latitude or Longitude is not available.");
                    // Handle the case where latitude or longitude is not available
                    setIsSearching(false);
                }
            }, (error)=>{
                console.error("Error getting location:", error.message);
                // Handle error if needed
                setIsSearching(false);
            });
        } else {
            console.error("Geolocation is not supported by your browser");
            // Handle lack of geolocation support if needed
            setIsSearching(false);
        }
    };
    const handleChangeSearchOption = (option)=>{
        setSearchDealerName(option);
        setDealerFound(true);
    };
    if (hidden) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative ".concat(isSearching ? "opacity-50" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col lg:flex-row items-start lg:items-center justify-between my-6 gap-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden lg:block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-xl",
                                children: "Find your ".concat(brand === "lexus" ? "centre" : "dealer")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Please fill in the required fields",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red",
                                        children: "*"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "items-start justify-top mb-4 md:mb-2",
                        "data-gt-name": "componentevent",
                        style: {
                            display: searchDealerName ? "block" : "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:col-span-2 lg:col-span-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "text-xs",
                                    children: "Search by ".concat(brand === "lexus" ? "centre" : "dealer", " name")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: "p-4 h-[48px] mt-2 pr-[52px] w-[100%] text-ellipsis overflow-hidden",
                                            "data-gt-action": "text-input-interaction",
                                            "data-gt-label": "places",
                                            value: nameSearch,
                                            onChange: (e)=>setNameSearch(e.target.value),
                                            onKeyDown: handleKeyDown
                                        }),
                                        isSearching && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loader-container absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "loader dark",
                                                children: "Loading..."
                                            })
                                        })
                                    ]
                                }),
                                !isDealerFound && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-red text-tiny flex justify-between pt-1 lg:absolute",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text-tiny",
                                            children: [
                                                "No ".concat(brand === "lexus" ? "Centres" : "Dealers", " found"),
                                                "."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "items-start justify-top mb-4 md:mb-2",
                        "data-gt-name": "componentevent",
                        style: {
                            display: searchDealerName ? "none" : "block"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:col-span-2 lg:col-span-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "text-xs",
                                    children: "Search by city or postcode"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            id: "postcodeSearch",
                                            ref: searchInput,
                                            className: "p-4 h-[48px] mt-2 pr-[52px] w-[100%] text-ellipsis overflow-hidden",
                                            "data-gt-action": "text-input-interaction",
                                            "data-gt-label": "places",
                                            onKeyDown: handleKeyDown
                                        }),
                                        isSearching && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loader-container absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "loader dark",
                                                children: "Loading..."
                                            })
                                        })
                                    ]
                                }),
                                !isDealerFound && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-red text-tiny flex justify-between pt-1 lg:absolute",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-tiny",
                                            children: "No location found."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "flex flex-row text-sm lg:ml-5 gap-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "w-5 h-5 text-base cursor-pointer hover:bg-base-hover checked:border-base checked:bg-transparent checked:bg-[url('/img/circle.svg')] checked:hover:bg-transparent checked:hover:border-base checked:focus:bg-transparent checked:focus:border-base",
                                type: "radio",
                                name: "searchOption",
                                value: "false",
                                checked: !searchDealerName,
                                onChange: ()=>handleChangeSearchOption(false),
                                "data-gt-name": "componentevent",
                                "data-gt-componentgroup": "forms",
                                "data-gt-action": "radio-input-interaction",
                                "data-gt-label": "search-postcode"
                            }),
                            "Search by city or postcode"
                        ]
                    }),
                    !(query === null || query === void 0 ? void 0 : query.group) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "flex flex-row text-sm lg:ml-5 gap-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "w-5 h-5 text-base cursor-pointer hover:bg-base-hover checked:border-base checked:bg-transparent checked:bg-[url('/img/circle.svg')] checked:hover:bg-transparent checked:hover:border-base checked:focus:bg-transparent checked:focus:border-base",
                                type: "radio",
                                name: "searchOption",
                                value: "true",
                                checked: searchDealerName,
                                onChange: ()=>handleChangeSearchOption(true),
                                "data-gt-name": "componentevent",
                                "data-gt-componentgroup": "forms",
                                "data-gt-action": "radio-input-interaction",
                                "data-gt-label": "search-name"
                            }),
                            "Search by ".concat(brand === "lexus" ? "centre" : "dealer", " name")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "text-xs inline-flex items-center",
                            onClick: ()=>handleUseLocation(),
                            "data-gt-name": "componentevent",
                            "data-gt-componentgroup": "forms",
                            "data-gt-action": "click-cta",
                            "data-gt-label": "use-location",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "inline-flex items-center underline",
                                children: [
                                    "Use my current location",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M3 8.79688L9.7 10.3969L11.6 17.2969L17 3.29688L3 8.79688Z",
                                                stroke: "#6C6F76",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                style: {
                    border: "1px solid #ddd"
                }
            })
        ]
    });
};
/* harmony default export */ var DealerFinder_SearchBar = (SearchBar);

;// CONCATENATED MODULE: ./src/components/form/fields/DealerFinder/Map.tsx



// import CurrentLocationIcon from '@assets/icons/currentLocation.svg'
const Map = (param)=>{
    let { searchData , triggerMarkers  } = param;
    const mapsElement = (0,react.useRef)();
    const brand = (0,contexts_useBrand/* useBrand */.D)();
    // const el = document.createElement('div')
    // el.innerHTML = <CurrentLocationIcon />
    (0,react.useEffect)(()=>{
        window.customMap = new mapsWrapper.DynamicMap(mapsElement.current, {
            accessToken: brand === "lexus" ? "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtqZzM5ZTA0bjgzZXBiemJ1ZHYyNDcifQ.Yfrq8kataFBLbN293vWY9A" : "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtpY2R1YTA0YW8zb2xzMzNkaDNxaTMifQ.LHbDy1LeUYXAgS7FJG-VOQ",
            countryCode: [
                "GB",
                "IM",
                "JE",
                "GG"
            ],
            language: "en",
            addCountryBoundaries: true,
            highResBoundary: true,
            maxZoom: 15,
            minZoom: 4,
            zoomControl: "bottom-right"
        });
        if (window.customMap && searchData.length > 0) {
            triggerMarkers(searchData[0].localDealerID, "markers set");
            if (navigator.permissions) {
                navigator.permissions.query({
                    name: "geolocation"
                }).then((permissionStatus)=>{
                    if (permissionStatus.state === "granted") {
                        navigator.geolocation.getCurrentPosition((position)=>{
                            const currentLocation = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            };
                            const currentLocationMarkerOptions = {
                                markerClick: ()=>{
                                    window.customMap.focusOn({
                                        coordinates: currentLocation
                                    });
                                }
                            };
                            window.customMap.addMarker(currentLocation, currentLocationMarkerOptions);
                        });
                    }
                });
            }
        }
    }, [
        searchData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " w-[100%] h-screen max-h-[565px] toyota-map  ".concat(searchData.length > 0 ? "" : " hidden "),
        ref: mapsElement
    });
};
/* harmony default export */ var DealerFinder_Map = (Map);

// EXTERNAL MODULE: ./node_modules/tippy.js/dist/tippy.css
var tippy = __webpack_require__(8887);
// EXTERNAL MODULE: ./node_modules/tippy.js/themes/light.css
var light = __webpack_require__(9547);
;// CONCATENATED MODULE: ./src/assets/icons/businessCentre.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBusinessCentre = function SvgBusinessCentre(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8 6h2.1c.5 0 .9.4.9.9v3c0 .5-.4.9-.9.9h-11c-.5 0-.9-.4-.9-.9v-3c0-.5.4-.9.9-.9H7V2.9c0-.5.4-.9.9-.9h5c.5 0 .9.4.9.9V6Zm-8.9 4H7V6.8H4.9a.1.1 0 0 0-.1.1v3c0 .014.002.027.007.039a.09.09 0 0 0 .015.028A.097.097 0 0 0 4.9 10Zm2.9 0H13V2.9a.1.1 0 0 0-.1-.1h-5a.1.1 0 0 0-.1.1V10Zm8.1 0a.1.1 0 0 0 .1-.1v-3a.1.1 0 0 0-.1-.1h-2.1V10h2.1Zm-4.5-6c-.22 0-.4.18-.4.4v1c0 .22.18.4.4.4.22 0 .4-.18.4-.4v-1c0-.22-.18-.4-.4-.4ZM9 7.4c0-.22.18-.4.4-.4.22 0 .4.18.4.4v1c0 .22-.18.4-.4.4-.22 0-.4-.18-.4-.4v-1ZM6.3 8.9c0 .22-.18.4-.4.4-.22 0-.4-.18-.4-.4v-1c0-.22.18-.4.4-.4.22 0 .4.18.4.4v1Zm9.7 3.7a.894.894 0 0 0-1.13-.28l-2.48 1.24s-.02.01-.03.02l-3.61-1.71a.884.884 0 0 0-.9.08l-2.98 2.1c-.41.29-.5.85-.21 1.26l1.25 1.75c.31.44.94.5 1.34.14l.76-.69s.06-.03.09-.02l3.05.74c.26.06.54 0 .75-.15l4.06-3.02c.39-.29.48-.85.19-1.25L16 12.6Zm-.52.81-4.06 3.02s-.017.007-.037.012a.246.246 0 0 1-.043.008l-3.05-.74c-.29-.07-.6 0-.82.21l-.76.69s-.11.03-.15-.02l-1.25-1.75s-.02-.11.02-.14l2.98-2.1s.07-.02.1 0l3.79 1.79c.05.02.07.09.05.14l-.2.37s-.024.018-.052.032a.214.214 0 0 1-.023.011.078.078 0 0 1-.045.007l-2.09-.8a.398.398 0 0 0-.52.23c-.08.21.03.44.23.52l2.09.8c.42.16.9-.02 1.11-.42l.2-.37c.13-.24.14-.51.05-.74l2.23-1.12s.1 0 .13.03l.15.21.002.013.002.025a.28.28 0 0 1 0 .047.124.124 0 0 1-.008.032.051.051 0 0 1-.016.023l-.01-.02ZM14.5 7.9c0-.22.18-.4.4-.4.22 0 .4.18.4.4v1c0 .22-.18.4-.4.4-.22 0-.4-.18-.4-.4v-1ZM11.4 7c-.22 0-.4.18-.4.4v1c0 .22.18.4.4.4.22 0 .4-.18.4-.4v-1c0-.22-.18-.4-.4-.4ZM9 4.4c0-.22.18-.4.4-.4.22 0 .4.18.4.4v1c0 .22-.18.4-.4.4-.22 0-.4-.18-.4-.4v-1Z",
    fill: "#282830"
  })));
};
/* harmony default export */ var businessCentre = (SvgBusinessCentre);
;// CONCATENATED MODULE: ./src/assets/icons/chevronDown.svg
var chevronDown_path;
function chevronDown_extends() { chevronDown_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevronDown_extends.apply(this, arguments); }

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/react.createElement("svg", chevronDown_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), chevronDown_path || (chevronDown_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.117 6.467a.4.4 0 0 1 .566 0l6.246 6.247a.1.1 0 0 0 .142 0l6.246-6.247a.4.4 0 1 1 .566.566l-6.247 6.246a.9.9 0 0 1-1.272 0L3.117 7.033a.4.4 0 0 1 0-.566Z",
    fill: "#282830"
  })));
};
/* harmony default export */ var chevronDown = (SvgChevronDown);
;// CONCATENATED MODULE: ./src/assets/icons/chevronRight.svg
var chevronRight_path;
function chevronRight_extends() { chevronRight_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevronRight_extends.apply(this, arguments); }

var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/react.createElement("svg", chevronRight_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), chevronRight_path || (chevronRight_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52 16.883a.4.4 0 0 1 0-.566l6.247-6.246a.1.1 0 0 0 0-.142L7.52 3.683a.4.4 0 1 1 .566-.566l6.247 6.247a.9.9 0 0 1 0 1.272l-6.247 6.247a.4.4 0 0 1-.566 0Z",
    fill: "#282830"
  })));
};
/* harmony default export */ var chevronRight = (SvgChevronRight);
;// CONCATENATED MODULE: ./src/assets/icons/chevronUp.svg
var chevronUp_path;
function chevronUp_extends() { chevronUp_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevronUp_extends.apply(this, arguments); }

var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/react.createElement("svg", chevronUp_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), chevronUp_path || (chevronUp_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.117 13.426a.4.4 0 0 0 .566 0l6.246-6.247a.1.1 0 0 1 .142 0l6.246 6.247a.4.4 0 1 0 .566-.566l-6.247-6.246a.9.9 0 0 0-1.272 0L3.117 12.86a.4.4 0 0 0 0 .566Z",
    fill: "#282830"
  })));
};
/* harmony default export */ var chevronUp = (SvgChevronUp);
;// CONCATENATED MODULE: ./src/assets/icons/GRLogo.svg
var _defs, GRLogo_path;
function GRLogo_extends() { GRLogo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return GRLogo_extends.apply(this, arguments); }

var SvgGrLogo = function SvgGrLogo(props) {
  return /*#__PURE__*/react.createElement("svg", GRLogo_extends({
    id: "GRLogo_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.98 49.23",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".GRLogo_svg__cls-3{fill-rule:evenodd;stroke-width:0;fill:#fefefe}"))), /*#__PURE__*/react.createElement("path", {
    d: "M57.63 0h-.94L44.3 49.23h46.3L102.98 0H57.63Z",
    style: {
      fill: "#e50113",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.38 0 0 49.23h45.04L57.43 0H12.38Z",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0,
      fill: "#231916"
    }
  }), GRLogo_path || (GRLogo_path = /*#__PURE__*/react.createElement("path", {
    className: "GRLogo_svg__cls-3",
    d: "M93.09 26.7c-.38 2.01-.8 3.17-1.47 4.5-1.24 2.48-3.75 3.83-7.28 4.31-1.38.18-3.23.12-3.23.12l7.38 10.48H77.55L67.3 31.53s8.92-.02 9.85-.02c2.13 0 4.96-.63 5.74-2.09.24-.45.58-1.2.59-1.99 0-.99-.96-1.82-2.59-1.82s-16.05-.01-16.05-.01l-5.08 20.24H49.41l6.5-25.22h29.64c5.55 0 8.15 2.8 7.51 6.11ZM45.76 31.02l-17.05.02-1.6 4.79h8.47l-1.38 4.62H20.54c-2.98 0-4.23-.73-3.93-2.82.33-2.37 1.22-4.38 2.03-6.58 1.64-4.45 4.01-5.58 13.89-5.58h14.79l1.56-5.01H31.12c-14.47 0-19.43 1.69-22.19 8.77-.94 2.4-2.34 6.83-2.97 10.49-.74 4.3 2.59 5.98 6.13 6.1 4.9.16 29.49.09 29.49.09l4.18-14.88Z"
  })));
};
/* harmony default export */ var GRLogo = (SvgGrLogo);
;// CONCATENATED MODULE: ./src/assets/icons/LCV.svg
var LCV_path;
function LCV_extends() { LCV_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return LCV_extends.apply(this, arguments); }

var SvgLcv = function SvgLcv(props) {
  return /*#__PURE__*/react.createElement("svg", LCV_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), LCV_path || (LCV_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.778 9.45c1.99 0 3.6-1.61 3.6-3.6s-1.61-3.6-3.6-3.6-3.6 1.61-3.6 3.6 1.61 3.6 3.6 3.6Zm0-6.4c1.55 0 2.8 1.25 2.8 2.8 0 1.55-1.25 2.8-2.8 2.8-1.55 0-2.8-1.25-2.8-2.8 0-1.55 1.25-2.8 2.8-2.8Zm9.17 6.08a.66.66 0 0 1-.55 0c-2.86-1.34-3.26-4.35-3.1-5.87.03-.35.32-.59.65-.59h5.44c.32 0 .61.24.65.59.16 1.52-.23 4.53-3.09 5.87Zm2.31-5.65h-5.18c-.1 1.4.32 3.8 2.59 4.9 2.27-1.1 2.69-3.51 2.59-4.9Zm-2.58 4.29V3.92h-2.15c-.1 2.2 1.39 3.48 2.15 3.85Zm3.37 6.99-.37-1.24a.88.88 0 0 0-.51-.57l-2.11-.89h-.02l-2.46-1.65a.89.89 0 0 0-.5-.15h-8.93c-.5 0-.9.4-.9.9v2.97s0 .04-.01.05l-.2.33c-.22.35-.17.8.11 1.1l.55.57s.08.07.12.09c.24.81.99 1.41 1.87 1.41.94 0 1.72-.66 1.91-1.54h6.76a1.953 1.953 0 0 0 3.82-.01l.52-.36c.32-.22.46-.62.35-1v-.01Zm-6.92-3.71h.96s.04 0 .06.02l1.97 1.32-.84.43s-.04.01-.07 0l-2-.45s-.08-.05-.08-.1v-1.22Zm-6.43 5.81c-.64 0-1.15-.52-1.15-1.15 0-.63.52-1.15 1.15-1.15.63 0 1.15.52 1.15 1.15 0 .63-.52 1.15-1.15 1.15Zm11.72-1.1c-.02.05-.02.11-.02.16a1.15 1.15 0 0 1-2.28-.22c0-.63.52-1.15 1.15-1.15.63 0 1.15.52 1.15 1.15V15.76Zm.82-.66-.1.07c-.23-.81-.99-1.41-1.87-1.41-.95 0-1.73.67-1.91 1.56h-6.75a1.952 1.952 0 0 0-3.78-.18l-.1-.1s-.04-.08-.01-.12l.2-.33c.09-.14.13-.31.13-.47v-2.97c0-.06.04-.1.1-.1h7.17v1.23c0 .42.29.79.7.88l2 .45c.21.05.42.02.61-.08l1.28-.66 1.94.82s.05.04.06.06l.37 1.24s0 .09-.04.11ZM4.878 6.55c.09.07.21.13.34.18l.02-.01c.13.05.27.08.42.1v-.79c-.26-.07-.46-.16-.62-.28-.15-.12-.23-.31-.23-.54 0-.23.08-.42.23-.57.15-.15.36-.24.62-.27v-.32h.37v.31c.14.01.28.03.41.07.13.04.25.08.35.13l-.15.46c-.21-.11-.41-.17-.6-.2v.75c.18.06.33.11.45.17.12.06.22.14.29.25.07.11.11.25.11.42 0 .25-.08.45-.23.61-.15.15-.37.25-.64.28v.33h-.37v-.32c-.17-.01-.34-.04-.5-.09-.16-.05-.3-.12-.42-.2l.15-.47Zm1.38-.26a.632.632 0 0 0-.25-.14v.68c.22-.04.33-.15.33-.34a.28.28 0 0 0-.08-.2Zm-.868-.948a.9.9 0 0 0 .238.128v-.64c-.21.04-.31.15-.31.32a.28.28 0 0 0 .072.192Z",
    fill: "#282830"
  })));
};
/* harmony default export */ var LCV = (SvgLcv);
;// CONCATENATED MODULE: ./src/assets/icons/lexusShowRoom.svg
var lexusShowRoom_path, _path2;
function lexusShowRoom_extends() { lexusShowRoom_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lexusShowRoom_extends.apply(this, arguments); }

var SvgLexusShowRoom = function SvgLexusShowRoom(props) {
  return /*#__PURE__*/react.createElement("svg", lexusShowRoom_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), lexusShowRoom_path || (lexusShowRoom_path = /*#__PURE__*/react.createElement("path", {
    d: "M5.542 10.116 4.48 9.769l.061-.24.862.321.138.266ZM14.458 10.116l1.061-.347-.061-.24-.861.321-.139.266ZM6 14.5h8",
    stroke: "#101010",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12.165 4.5H6.092c-.498.024-.812.394-.992.61l-.762 1.003c-.317-.064-1.02-.013-1.27.683-.252.695.263 1.17.548 1.327l-.615 1.763L3 15.5h3v-1l2-3-.5-1.5H12M7.835 4.5h6.073c.498.024.795.394.992.61l.762.971c.317-.064 1.02-.012 1.27.683.252.695-.262 1.17-.548 1.328l.615 1.762V15.5H14v-1l-2-3 .5-1.5H7.88",
    stroke: "#101010",
    strokeWidth: 0.8
  })));
};
/* harmony default export */ var lexusShowRoom = (SvgLexusShowRoom);
;// CONCATENATED MODULE: ./src/assets/icons/lexusUsedCars.svg
var lexusUsedCars_path;
function lexusUsedCars_extends() { lexusUsedCars_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lexusUsedCars_extends.apply(this, arguments); }

var SvgLexusUsedCars = function SvgLexusUsedCars(props) {
  return /*#__PURE__*/react.createElement("svg", lexusUsedCars_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), lexusUsedCars_path || (lexusUsedCars_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.94 8.42-.29-.74-1.07.42c.82-2.72 3.37-4.7 6.39-4.7 3.69 0 6.68 2.96 6.68 6.6h.8c0-4.09-3.35-7.4-7.48-7.4-3.37 0-6.23 2.21-7.16 5.26l-.64-.97-.67.44 1.29 1.94 2.15-.85Zm1.67.84-.18.7 1.57.52-.44-.86-.95-.36Zm7.82.64v3.85h-2.54v-.95h-3.9v.95H5.45V9.9l.28-.81a.7.7 0 0 1-.15-.19.935.935 0 0 1-.07-.83c.12-.33.35-.51.59-.6.1-.03.2-.06.29-.06l.38-.66c.08-.14.33-.52.83-.54H12.29c.5.03.75.4.83.55l.37.65a.998.998 0 0 1 .88.66c.12.32.06.61-.07.83-.05.07-.1.13-.15.19l.28.81Zm-5.26.94L8.39 12h3.09l-.78-1.16.18-.39H8.99l.18.39Zm2.97-1.18-.52 1.11.01-.01 1.07 1.58v.6h.94v-2.92l-.44-1.26.29-.16c.03-.02.09-.07.12-.12.02-.03.02-.05.02-.07.01-.02.01-.05-.01-.09l-.011-.024c-.014-.028-.023-.048-.039-.056-.01-.02-.03-.03-.06-.04-.06-.02-.16-.02-.16-.02l-.28.06-.64-1.11c-.03-.04-.06-.08-.09-.11-.03-.02-.09-.03-.09-.03H7.63c-.04.01-.06.02-.09.04s-.09.11-.09.11l-.64 1.11-.28-.06c-.03 0-.1 0-.16.02a.21.21 0 0 0-.06.04c-.016.008-.025.028-.038.056a1.138 1.138 0 0 1-.012.024c-.01.04-.01.07-.01.09 0 .02.01.05.02.07.03.06.12.12.12.12l.3.16-.44 1.26v2.92h.94v-.6l1.07-1.58-.52-1.11h4.4Zm5.14 1.03-2.13.89.31.74 1.1-.46c-.81 2.74-3.38 4.74-6.42 4.74-3.7 0-6.69-2.96-6.69-6.6h-.8c0 4.09 3.36 7.4 7.49 7.4 3.38 0 6.24-2.22 7.17-5.27l.64.93.66-.46-1.33-1.92v.01ZM12.3 9.62l.95-.36.18.7-1.57.52.44-.86Z",
    fill: "#101010"
  })));
};
/* harmony default export */ var lexusUsedCars = (SvgLexusUsedCars);
;// CONCATENATED MODULE: ./src/assets/icons/parts.svg
var _circle, parts_path, _circle2, _circle3, _circle4, parts_path2, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11;
function parts_extends() { parts_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return parts_extends.apply(this, arguments); }

var SvgParts = function SvgParts(props) {
  return /*#__PURE__*/react.createElement("svg", parts_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 4.875,
    cy: 4.275,
    r: 0.625,
    fill: "#101010"
  })), parts_path || (parts_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.35 4.275a1.475 1.475 0 1 1-2.95 0 1.475 1.475 0 0 1 2.95 0Z",
    stroke: "#101010",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/react.createElement("circle", {
    cx: 14.5,
    cy: 8.625,
    r: 0.75,
    fill: "#101010"
  })), _circle3 || (_circle3 = /*#__PURE__*/react.createElement("circle", {
    cx: 14.5,
    cy: 8.625,
    r: 2.1,
    stroke: "#101010",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/react.createElement("circle", {
    cx: 8.75,
    cy: 13.4,
    r: 4.1,
    stroke: "#101010",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), parts_path2 || (parts_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m3.75 6.65 1 3.25M7.5 3.65l5.25 2.25M14 12.9l1.011-.987",
    stroke: "#101010",
    strokeWidth: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/react.createElement("circle", {
    cx: 8.75,
    cy: 13.4,
    r: 1,
    fill: "#101010"
  })), _circle6 || (_circle6 = /*#__PURE__*/react.createElement("circle", {
    cx: 8.75,
    cy: 11.15,
    r: 0.5,
    fill: "#101010"
  })), _circle7 || (_circle7 = /*#__PURE__*/react.createElement("circle", {
    cx: 6.768,
    cy: 12.4,
    transform: "rotate(-60 6.768 12.4)",
    fill: "#101010",
    r: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/react.createElement("circle", {
    cx: 6.768,
    cy: 14.4,
    transform: "rotate(-120 6.768 14.4)",
    fill: "#101010",
    r: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/react.createElement("circle", {
    cx: 8.75,
    cy: 15.65,
    r: 0.5,
    transform: "rotate(-180 8.75 15.65)",
    fill: "#101010"
  })), _circle10 || (_circle10 = /*#__PURE__*/react.createElement("circle", {
    cx: 10.732,
    cy: 14.4,
    r: 0.5,
    transform: "rotate(120 10.732 14.4)",
    fill: "#101010"
  })), _circle11 || (_circle11 = /*#__PURE__*/react.createElement("circle", {
    cx: 10.732,
    cy: 12.4,
    r: 0.5,
    transform: "rotate(60 10.732 12.4)",
    fill: "#101010"
  })));
};
/* harmony default export */ var parts = (SvgParts);
;// CONCATENATED MODULE: ./src/assets/icons/phone.svg
var phone_path;
function phone_extends() { phone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_extends.apply(this, arguments); }

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/react.createElement("svg", phone_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), phone_path || (phone_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2h8c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1Zm8 15.2a.2.2 0 0 0 .2-.2v-1.6H5.8V17c0 .11.09.2.2.2h8Zm-8.2-2.6h8.4V4.4H5.8v10.2Zm0-11h8.4V3a.2.2 0 0 0-.2-.2H6a.2.2 0 0 0-.2.2v.6Zm5.7 13.05h-3c-.22 0-.4-.18-.4-.4 0-.22.18-.4.4-.4h3c.22 0 .4.18.4.4 0 .22-.18.4-.4.4Z",
    fill: "#282830"
  })));
};
/* harmony default export */ var phone = (SvgPhone);
;// CONCATENATED MODULE: ./src/assets/icons/pin.svg
var pin_path;
function pin_extends() { pin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pin_extends.apply(this, arguments); }

var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/react.createElement("svg", pin_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), pin_path || (pin_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.43C4 5.15 6.69 2.5 10 2.5s6 2.66 6 5.93c0 1.31 0 2.07-1 3.57s-3.28 4.39-4.44 5.27l-.03.02c-.17.14-.26.21-.54.21-.261 0-.357-.07-.515-.185a6.572 6.572 0 0 0-.035-.025l-.02-.02C8.26 16.4 6 13.5 5 12c-1-1.5-1-2.26-1-3.57Zm8.22 5.94c.83-1.01 1.63-2.09 2.11-2.81h.01c.46-.69.66-1.17.76-1.59.1-.44.1-.87.1-1.54 0-2.83-2.32-5.13-5.2-5.13-2.88 0-5.2 2.3-5.21 5.15 0 .67 0 1.09.1 1.53.1.42.3.89.76 1.59.48.73 1.28 1.8 2.1 2.81.84 1.02 1.64 1.9 2.13 2.27l.03.02.04.04h.03l.02-.02.04-.03.03-.02c.5-.37 1.31-1.24 2.15-2.27ZM7 8c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3Zm.8 0c0 1.22.98 2.2 2.2 2.2 1.22 0 2.2-.98 2.2-2.2 0-1.22-.98-2.2-2.2-2.2-1.22 0-2.2.98-2.2 2.2Z",
    fill: "#282830"
  })));
};
/* harmony default export */ var pin = (SvgPin);
;// CONCATENATED MODULE: ./src/assets/icons/servicing.svg
var servicing_path;
function servicing_extends() { servicing_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return servicing_extends.apply(this, arguments); }

var SvgServicing = function SvgServicing(props) {
  return /*#__PURE__*/react.createElement("svg", servicing_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), servicing_path || (servicing_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.15 13.613c.236.203.603.52.78.967l.02-.02c.1.27.14.57.05.9-.09.32-.29.65-.6.96-.31.31-.63.51-.95.59-.33.09-.64.05-.9-.05-.5-.19-.85-.62-1.03-.86l-2.44-2.93a.531.531 0 0 1-.1-.55l-.8-.85-1.65 1.65c.28.98.03 2.09-.74 2.86a2.903 2.903 0 0 1-4.1 0 2.903 2.903 0 0 1 2.86-4.84l1.66-1.66-2.42-2.51-1.06-.15a.597.597 0 0 1-.43-.29L2.93 4.55a.62.62 0 0 1 .09-.73l.39-.39.39-.39c.19-.2.49-.23.73-.09l2.28 1.36c.16.09.26.25.29.43l.15 1.06 1.31 1.26 1.21 1.16 1.67-1.67a2.92 2.92 0 0 1 .74-2.86c.75-.76 1.81-1.01 2.77-.76.48.12.55.69.26.98L13.9 5.22l-.12.83h.99l1.29-1.29c.29-.29.86-.22.98.26.24.96-.01 2.02-.76 2.77-.78.78-1.88 1.02-2.86.74l-1.66 1.66.85.8c.18-.07.39-.03.55.1l2.91 2.46.03.02.05.043ZM5.97 6.49c.13.02.26.08.35.18v.01l2.45 2.54.43-.43L8 7.64 6.64 6.33a.594.594 0 0 1-.18-.35l-.14-1.03-2.07-1.24-.28.28-.28.28 1.25 2.08 1.03.14Zm1.72 6.98a.417.417 0 0 1 .1-.44l5.14-5.14a.6.6 0 0 1 .62-.14c.73.24 1.57.07 2.15-.51.44-.44.64-1.02.61-1.6l-1.05 1.05a.56.56 0 0 1-.42.18h-1.31c-.36 0-.64-.33-.59-.69l.16-1.12c.02-.13.08-.25.17-.34l1.06-1.06c-.57-.03-1.16.17-1.6.61a2.11 2.11 0 0 0-.51 2.15c.07.2.03.45-.14.62l-5.14 5.14c-.11.12-.28.16-.44.1a2.1 2.1 0 1 0 1.19 1.19Zm8.13 2.39c.24-.24.34-.44.38-.59.03-.15.02-.28-.03-.4-.1-.27-.37-.5-.61-.7l-2.78-2.35c-.2.08-.43.04-.59-.11l-1-.95-.45.45.95 1c.15.17.19.4.11.59l2.33 2.81c.18.24.42.5.69.61a.6.6 0 0 0 .4.03c.15-.04.36-.15.6-.39Zm-10.94-.72a1.25 1.25 0 0 1 0-1.77 1.25 1.25 0 0 1 1.77 0c.49.49.49 1.28 0 1.77s-1.28.49-1.77 0Zm.56-.57c.18.18.46.18.64 0s.18-.46 0-.64a.447.447 0 0 0-.64 0c-.18.18-.18.46 0 .64Z",
    fill: "#282830"
  })));
};
/* harmony default export */ var servicing = (SvgServicing);
// EXTERNAL MODULE: ./src/assets/icons/toyotaInfo.svg
var toyotaInfo = __webpack_require__(25991);
;// CONCATENATED MODULE: ./src/assets/icons/toyotaShowroom.svg
var toyotaShowroom_path;
function toyotaShowroom_extends() { toyotaShowroom_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return toyotaShowroom_extends.apply(this, arguments); }

var SvgToyotaShowroom = function SvgToyotaShowroom(props) {
  return /*#__PURE__*/react.createElement("svg", toyotaShowroom_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), toyotaShowroom_path || (toyotaShowroom_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.88 6.2h1.22c.5 0 .9.4.9.9v.25c0 .5-.4.9-.9.9h-1.13l1.12.97c.2.17.31.41.31.67v2.8c0 .35-.2.66-.51.82h-.03l-.46.14v1.05c0 .5-.4.9-.9.9H14c-.5 0-.9-.4-.9-.9v-.2H6.8v.2c0 .5-.4.9-.9.9H4.5c-.5 0-.9-.4-.9-.9v-1.05l-.46-.16h-.03a.872.872 0 0 1-.51-.8v-2.8c0-.26.11-.5.31-.67l1.12-.97H2.9c-.5 0-.9-.4-.9-.9V7.1c0-.5.4-.9.9-.9h1.25c.31 0 .61.17.77.44l.1.17.91-1.9v-.02c.01-.01.01-.02.01-.02l.008-.012c.093-.146.293-.458.692-.458h6.75c.399 0 .599.312.692.458a2.765 2.765 0 0 1 .018.032v.02l.91 1.9.1-.17c.16-.27.45-.44.77-.44Zm-9.23-.98c-.01.02-.04.07-.04.07L5.57 7.45h8.83l-1.04-2.16a.197.197 0 0 0-.016-.026c-.008-.01-.014-.018-.014-.024-.01-.01-.01-.02-.01-.02V5.2H6.66c-.01.01-.01.02-.01.02ZM2.8 7.35c0 .06.04.1.1.1h1.37c.09 0 .13-.08.09-.15l-.15-.25C4.19 7.02 4.12 7 4.12 7H2.9c-.06 0-.1.04-.1.1v.25Zm3.1 7.45c.06 0 .1-.04.1-.1v-.3l-1.6-.5v.8c0 .06.04.1.1.1h1.4Zm9.6 0c.06 0 .1-.04.1-.1v-.8l-1.7.53v.27c0 .06.04.1.1.1h1.5Zm1.07-4.98h-.01l-1.57-1.36a.962.962 0 0 1-.18-.22H5.19c-.05.08-.11.16-.18.22L3.44 9.82c-.02.02-.03.07-.03.07v2.8c0 .02.04.07.04.07l2.99.93h7.13l2.99-.93c.03-.02.04-.07.04-.07v-2.8c0-.03-.03-.07-.03-.07Zm.53-2.37c.06 0 .1-.04.1-.1V7.1c0-.06-.04-.1-.1-.1h-1.22c-.04 0-.09.05-.09.05l-.15.25c-.04.07.01.15.09.15h1.37Zm-4 2.84h.02l1.51-.71c.59-.29 1.28.15 1.28.81v.71c0 .5-.4.9-.9.9h-2.88c-.01 0-.04.01-.04.01l-.79.39c-.12.07-.26.1-.4.1H9.14a.91.91 0 0 1-.4-.1l-.79-.39C7.94 12 7.91 12 7.91 12H5.03c-.5 0-.9-.4-.9-.9v-.71c0-.66.68-1.09 1.28-.81l1.51.71c.4.18.55.56.51.91h.47c.14 0 .28.04.4.1l.79.39c.01.01.04.01.04.01h1.76c.01 0 .04-.01.04-.01l.79-.39c.12-.07.26-.1.4-.1h.47a.87.87 0 0 1 .51-.91Zm-6.53.89c0-.01.02-.05.02-.05v-.07c0-.02-.05-.05-.05-.05l-1.51-.71c-.06-.03-.14.02-.14.09v.71c0 .06.04.1.1.1H6.5c.04 0 .07-.02.07-.02Zm8.52-.8h-.01c0-.07-.07-.12-.14-.09l-1.51.71c-.03.02-.05.05-.05.05v.07c0 .019.012.034.02.045.006.006.01.011.01.015.01.01.07.02.07.02h1.51c.06 0 .1-.04.1-.1v-.72Z",
    fill: "#282830"
  })));
};
/* harmony default export */ var toyotaShowroom = (SvgToyotaShowroom);
;// CONCATENATED MODULE: ./src/assets/icons/website.svg
var website_path;
function website_extends() { website_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return website_extends.apply(this, arguments); }

var SvgWebsite = function SvgWebsite(props) {
  return /*#__PURE__*/react.createElement("svg", website_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), website_path || (website_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.283 3.532a.4.4 0 0 0-.566-.565L12.92 4.763a4.9 4.9 0 0 0-6.907 6.907l-1.796 1.797a.4.4 0 0 0 .566.566l.578-.579a6.62 6.62 0 0 0 3.889 1.44v.95H8.8a.4.4 0 1 0 0 .8h1.7a.4.4 0 0 0 0-.8h-.45v-.967A6.65 6.65 0 0 0 14.705 4.11l.578-.578ZM14.135 4.68l-.649.649a4.9 4.9 0 0 1-6.907 6.907l-.648.648a5.85 5.85 0 0 0 8.205-8.205ZM9.75 4.4a4.1 4.1 0 1 0 0 8.2 4.1 4.1 0 0 0 0-8.2Z",
    fill: "#282830"
  })));
};
/* harmony default export */ var website = (SvgWebsite);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 7 modules
var ui = __webpack_require__(20388);
// EXTERNAL MODULE: ./node_modules/@tippyjs/react/dist/tippy-react.esm.js + 1 modules
var tippy_react_esm = __webpack_require__(31865);
;// CONCATENATED MODULE: ./src/components/form/fields/DealerFinder/Card.tsx
























const OpeningTimes = (param)=>{
    let { openingDays , serviceType  } = param;
    const brand = (0,contexts_useBrand/* useBrand */.D)();
    const filteredOpeningDays = openingDays.filter((day)=>day.service === serviceType);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-[90%]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "".concat(brand === "lexus" ? "test-tiny" : "text-base", " font-medium mb-2"),
                children: serviceType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: filteredOpeningDays.map((day, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    day.startDay,
                                    day.startDay !== day.endDay ? " - ".concat(day.endDay) : ""
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    day.hours[0].startTime,
                                    "-",
                                    day.hours[0].endTime
                                ]
                            })
                        ]
                    }, index))
            })
        ]
    });
};
const Card_Card = (param)=>{
    let { dealer , setDealer , cardNumber , isSelected , onSelectDealerID , scrollRef  } = param;
    const brand = (0,contexts_useBrand/* useBrand */.D)();
    const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
    const [isExpanded, setIsExpanded] = (0,react.useState)(false);
    const [userLocation, setUserLocation] = (0,react.useState)({
        userLatitude: "",
        userLongitude: ""
    });
    const cardResultRef = (0,react.useRef)(null);
    const toggleExpanded = ()=>{
        setIsExpanded((prevExpanded)=>!prevExpanded);
    };
    (0,react.useEffect)(()=>{
        var ref;
        function closeOnScroll() {
            setIsModalOpen(false);
        }
        scrollRef === null || scrollRef === void 0 ? void 0 : (ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", closeOnScroll, false);
        return ()=>{
            var ref;
            scrollRef === null || scrollRef === void 0 ? void 0 : (ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", closeOnScroll, false);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (isSelected) {
            cardResultRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        isSelected
    ]);
    (0,react.useEffect)(()=>{
        if (navigator.permissions) {
            navigator.permissions.query({
                name: "geolocation"
            }).then((permissionStatus)=>{
                if (permissionStatus.state === "granted") {
                    navigator.geolocation.getCurrentPosition((position)=>{
                        const { latitude , longitude  } = position.coords;
                        setUserLocation({
                            userLatitude: latitude,
                            userLongitude: longitude
                        });
                    });
                }
            });
        }
    }, []);
    const dealerObject = {
        id: dealer.localDealerID,
        name: dealer.name,
        address: dealer.address,
        phone: dealer.phone,
        distance: dealer.distance
    };
    const handleCardClick = ()=>{
        onSelectDealerID(dealer.localDealerID);
        window.customMap.focusOn({
            coordinates: dealer.address.geo
        });
    };
    if (!dealer) {
        return null;
    }
    const { address  } = dealer;
    const directionsLink = "https://www.google.com/maps/dir/".concat(userLocation.userLatitude && userLocation.userLongitude ? "".concat(userLocation.userLatitude, ",").concat(userLocation.userLongitude) : "", "/").concat(address.geo.lat, ",").concat(address.geo.lon);
    const handleDistance = (distance)=>{
        const miles = distance * 0.621371;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
            value: miles,
            displayType: "text",
            decimalScale: 1,
            suffix: " MILES",
            thousandSeparator: true
        });
    };
    const showRoomIcon = brand === "toyota" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(toyotaShowroom, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lexusShowRoom, {});
    const serviceMapping = {
        icon: {
            WorkShop: /*#__PURE__*/ (0,jsx_runtime.jsx)(servicing, {}),
            ShowRoom: showRoomIcon,
            LCVCentre: /*#__PURE__*/ (0,jsx_runtime.jsx)(LCV, {}),
            BusinessCenter: /*#__PURE__*/ (0,jsx_runtime.jsx)(businessCentre, {}),
            ToyotaGazooRacing: /*#__PURE__*/ (0,jsx_runtime.jsx)(GRLogo, {}),
            PartsShop: /*#__PURE__*/ (0,jsx_runtime.jsx)(parts, {}),
            UsedCars: /*#__PURE__*/ (0,jsx_runtime.jsx)(lexusUsedCars, {})
        },
        tooltip: {
            WorkShop: "Can carry out Service, MOT and Maintenance on your ".concat((0,dist_es2015/* upperCaseFirst */.l)(brand), " through our fully trained, expert technicians."),
            ShowRoom: "".concat(brand === "lexus" ? "Sells new Lexus Vehicles." : "Sells new Toyota and Approved Used Vehicles."),
            LCVCentre: "Light Commercial Vehicle Specialist.",
            BusinessCenter: "Ready to support you and your business in choosing the right vehicles for your fleet.",
            ToyotaGazooRacing: "Has expert knowledge of the Toyota Gazoo Racing product range.",
            PartsShop: "Sells and fits parts for your ".concat((0,dist_es2015/* upperCaseFirst */.l)(brand)),
            UsedCars: "Sells used ".concat((0,dist_es2015/* upperCaseFirst */.l)(brand), " vehicles")
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: cardResultRef,
        id: "card-result",
        "data-card-index": cardNumber,
        "data-dealer-id": dealer.localDealerID,
        className: "m-2 mb-8 flex flex-col justify-start shadow-lg text-tiny cursor-pointer",
        onClick: handleCardClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full flex flex-col m-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "text-lg mt-4 font-medium",
                            children: dealer.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-".concat(isSelected ? "base" : "white", " text-").concat(isSelected ? "white" : "base", " rounded-full w-8 h-8 p-2 flex items-center justify-center z-10 ").concat(isSelected ? "" : "border-2 border-base"),
                            children: cardNumber
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    style: {
                        border: "1px solid #ddd"
                    },
                    className: "my-6"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: address.address1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: address.city
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: address.region
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: address.zip
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "font-semibold flex flex-row align-baseline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(pin, {
                            className: "mr-1"
                        }),
                        handleDistance(dealer.distance)
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "overflow-hidden transition-max-height duration-300 ease-in-out ".concat(isExpanded ? "max-h-screen" : "max-h-0"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            style: {
                                border: "1px solid #ddd"
                            },
                            className: "my-6"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "text-lg my-2 font-medium",
                            children: "Contact"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Phone:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:".concat(dealer.phone),
                                    "data-gt-name": "componentevent",
                                    "data-gt-componentgroup": "forms",
                                    "data-gt-action": "click-type",
                                    "data-gt-label": dealer.phone,
                                    className: "text-blue",
                                    children: dealer.phone
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "truncate",
                            children: [
                                "Website:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "truncate text-blue",
                                    href: dealer.url,
                                    "data-gt-name": "componentevent",
                                    "data-gt-componentgroup": "forms",
                                    "data-gt-action": "click-type",
                                    "data-gt-label": dealer.url,
                                    children: dealer.url
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "my-6",
                            children: dealer.services.map((service)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mx-1",
                                                    children: serviceMapping.icon[service.service]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mx-1",
                                                    children: service.label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: serviceMapping.tooltip[service.service]
                                                    }),
                                                    placement: "top",
                                                    arrow: true,
                                                    theme: "black-tooltip",
                                                    className: "p-2 rounded-none border border-white",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mx-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(toyotaInfo/* default */.Z, {
                                                            "data-gt-name": "componentevent",
                                                            "data-gt-componentgroup": "forms",
                                                            "data-gt-action": "click-type",
                                                            "data-gt-label": "info"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, service.service))
                        }),
                        brand === "lexus" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpeningTimes, {
                                        openingDays: dealer.openingDays,
                                        serviceType: "Showroom"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpeningTimes, {
                                        openingDays: dealer.openingDays,
                                        serviceType: "Workshop"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpeningTimes, {
                                        openingDays: dealer.openingDays,
                                        serviceType: "Approved After Sales"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpeningTimes, {
                                        openingDays: dealer.openingDays,
                                        serviceType: "Approved Sales"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CTA */.MV, {
                            className: "w-[90%] m-4",
                            href: directionsLink,
                            target: "_blank",
                            "data-gt-name": "componentevent",
                            "data-gt-action": "dealer-list-click-cta",
                            "data-gt-label": "directions",
                            style: {
                                backgroundColor: "white",
                                border: "1px solid black",
                                color: "black"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr-2 pointer-events-none",
                                children: "Get Directions"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            style: {
                                border: "1px solid #ddd"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid md:grid-cols-2 gap-4 overflow-hidden transition-max-height duration-300 ease-in-out max-h-".concat(!isExpanded ? "full" : "0"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(phone, {
                                                className: "mr-1"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Call:",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "tel:".concat(dealer.phone),
                                                        "data-gt-name": "componentevent",
                                                        "data-gt-componentgroup": "forms",
                                                        "data-gt-action": "click-type",
                                                        "data-gt-label": dealer.phone,
                                                        className: "text-blue",
                                                        children: dealer.phone
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(website, {
                                                className: "mr-1"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "truncate text-blue",
                                                href: dealer.url,
                                                rel: "noreferrer",
                                                "data-gt-name": "componentevent",
                                                "data-gt-componentgroup": "forms",
                                                "data-gt-action": "click-type",
                                                "data-gt-label": dealer.url,
                                                style: {
                                                    display: "inline-block",
                                                    maxWidth: "calc(100% - 30px)"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "".concat(dealer.url)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "flex flex-row text-blue",
                                        "data-gt-name": "componentevent",
                                        "data-gt-componentgroup": "forms",
                                        "data-gt-action": "click-type",
                                        "data-gt-label": "directions",
                                        href: directionsLink,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(pin, {
                                                className: "mr-1"
                                            }),
                                            "Get Directions"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-medium mb-1",
                                        children: "Services"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-row",
                                        children: dealer.services.map((service)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                                    content: service.label,
                                                    placement: "top",
                                                    arrow: true,
                                                    theme: "black-tooltip",
                                                    className: "p-2 rounded-none border border-white",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "service-icon mx-[2px] focus:outline-none",
                                                        title: service.label,
                                                        children: serviceMapping.icon[service.service]
                                                    })
                                                })
                                            }, service.service))
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CTA */.MV, {
                            className: "w-[90%] m-4",
                            onClick: ()=>setDealer(dealerObject),
                            "data-gt-name": "componentevent",
                            "data-gt-action": "dealer-list-click-cta",
                            "data-gt-label": "Select",
                            style: {
                                backgroundColor: isSelected ? "black" : "white",
                                border: isSelected ? "none" : "1px solid black",
                                color: isSelected ? "white" : "black"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr-2 pointer-events-none",
                                children: "Select"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "w-[90%] m-4 md:",
                            onClick: toggleExpanded,
                            children: isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "flex flex-row justify-center items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevronUp, {
                                    className: "mt-1 ml-1"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flex flex-row justify-center items-center",
                                children: [
                                    "View more ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chevronDown, {
                                        className: "mt-1 ml-1"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid md:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(phone, {
                                                className: "mr-1"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Call:",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "tel:".concat(dealer.phone),
                                                        "data-gt-name": "componentevent",
                                                        "data-gt-componentgroup": "forms",
                                                        "data-gt-action": "click-type",
                                                        "data-gt-label": dealer.phone,
                                                        className: "text-blue",
                                                        children: dealer.phone
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(website, {
                                                className: "mr-1"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "truncate text-blue",
                                                href: dealer.url,
                                                rel: "noreferrer",
                                                "data-gt-name": "componentevent",
                                                "data-gt-componentgroup": "forms",
                                                "data-gt-action": "click-type",
                                                "data-gt-label": dealer.url,
                                                style: {
                                                    display: "inline-block",
                                                    maxWidth: "calc(100% - 30px)"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "".concat(dealer.url)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "flex flex-row text-blue",
                                        "data-gt-name": "componentevent",
                                        "data-gt-componentgroup": "forms",
                                        "data-gt-action": "click-type",
                                        "data-gt-label": "directions",
                                        href: directionsLink,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(pin, {
                                                className: "mr-1"
                                            }),
                                            "Get Directions"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-medium mb-1",
                                        children: "Services"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-row",
                                        children: dealer.services.map((service)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                                    content: service.label,
                                                    placement: "top",
                                                    arrow: true,
                                                    theme: "black-tooltip",
                                                    className: "p-2 rounded-none border border-white",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "service-icon mx-[2px] focus:outline-none",
                                                        title: service.label,
                                                        children: serviceMapping.icon[service.service]
                                                    })
                                                })
                                            }, service.service))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CTA */.MV, {
                                    className: "w-full !mx-4 !my-2 col-span-2 ",
                                    onClick: ()=>setDealer(dealerObject),
                                    "data-gt-name": "componentevent",
                                    "data-gt-action": "dealer-list-click-cta",
                                    "data-gt-label": "Select",
                                    style: {
                                        backgroundColor: isSelected ? "black" : "white",
                                        border: isSelected ? "none" : "1px solid black",
                                        color: isSelected ? "white" : "black"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mr-2 pointer-events-none",
                                        children: "Select"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:flex flex-row justify-end pl-4 w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "m-4 z-100 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                className: "text-lg my-2 font-medium",
                                                children: "Contact"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Phone:",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "tel:".concat(dealer.phone),
                                                        "data-gt-name": "componentevent",
                                                        "data-gt-componentgroup": "forms",
                                                        "data-gt-action": "click-type",
                                                        "data-gt-label": dealer.phone,
                                                        className: "text-blue",
                                                        children: dealer.phone
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "truncate",
                                                children: [
                                                    "Website:",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "truncate text-blue",
                                                        href: dealer.url,
                                                        "data-gt-name": "componentevent",
                                                        "data-gt-componentgroup": "forms",
                                                        "data-gt-action": "click-type",
                                                        "data-gt-label": dealer.url,
                                                        children: dealer.url
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "my-6",
                                                children: dealer.services.map((service)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "relative",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex flex-row items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "mx-1",
                                                                        children: serviceMapping.icon[service.service]
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "mx-1",
                                                                        children: service.label
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                                                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: serviceMapping.tooltip[service.service]
                                                                        }),
                                                                        placement: "top",
                                                                        arrow: true,
                                                                        theme: "black-tooltip",
                                                                        className: "p-2 rounded-none border border-white",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "mx-1",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(toyotaInfo/* default */.Z, {
                                                                                "data-gt-name": "componentevent",
                                                                                "data-gt-componentgroup": "forms",
                                                                                "data-gt-action": "click-type",
                                                                                "data-gt-label": "info"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }, service.service))
                                            }),
                                            brand === "lexus" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "grid grid-cols-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpeningTimes, {
                                                            openingDays: dealer.openingDays,
                                                            serviceType: "Showroom"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpeningTimes, {
                                                            openingDays: dealer.openingDays,
                                                            serviceType: "Workshop"
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "grid grid-cols-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpeningTimes, {
                                                            openingDays: dealer.openingDays,
                                                            serviceType: "Approved After Sales"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpeningTimes, {
                                                            openingDays: dealer.openingDays,
                                                            serviceType: "Approved Sales"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CTA */.MV, {
                                                className: "w-[90%] m-4",
                                                href: directionsLink,
                                                rel: "noreferrer",
                                                "data-gt-name": "componentevent",
                                                "data-gt-action": "dealer-list-click-cta",
                                                "data-gt-label": "directions",
                                                target: "_blank",
                                                style: {
                                                    backgroundColor: "white",
                                                    border: "1px solid black",
                                                    color: "black"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mr-2 pointer-events-none",
                                                    children: "Get Directions"
                                                })
                                            })
                                        ]
                                    }),
                                    interactive: true,
                                    placement: "right-end",
                                    arrow: true,
                                    theme: "light",
                                    onShow: ()=>setIsModalOpen(true),
                                    onHide: ()=>setIsModalOpen(false),
                                    maxWidth: 350,
                                    visible: isModalOpen,
                                    onClickOutside: ()=>setIsModalOpen(false),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "justify-end",
                                        onClick: ()=>setIsModalOpen(!isModalOpen),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "flex flex-row items-center",
                                            children: [
                                                isModalOpen ? "View less" : "View more",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chevronRight, {
                                                    className: "mt-1 ml-1"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var DealerFinder_Card = (Card_Card);

;// CONCATENATED MODULE: ./src/components/form/fields/DealerFinder/ResultsList.tsx


const ResultsList = (param)=>{
    let { searchData , setDealer , onSelectDealerID , scrollRef , selectedDealerId  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "resultsList",
        className: "max-h-[565px] mx-auto md:overflow-auto",
        ref: scrollRef,
        children: searchData.map((dealer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DealerFinder_Card, {
                dealer: dealer,
                setDealer: setDealer,
                isSelected: selectedDealerId === dealer.localDealerID,
                cardNumber: index + 1,
                onSelectDealerID: onSelectDealerID,
                scrollRef: scrollRef
            }, dealer.id))
    });
};
/* harmony default export */ var DealerFinder_ResultsList = (ResultsList);

;// CONCATENATED MODULE: ./src/components/form/fields/DealerFinder/SearchResults.tsx




const SearchResults = (param)=>{
    let { searchData , setDealer  } = param;
    const [selectedDealerId, setSelectedDealerId] = (0,react.useState)("");
    const scrollRef = (0,react.useRef)(null);
    const handleSelectedDealerId = (dealerId)=>{
        if (window.customMap && dealerId) {
            setSelectedDealerId(dealerId);
            window.customMap.clearMarkers();
            const addMarkers = (dealers)=>{
                dealers.forEach((d, index)=>{
                    const markerIndex = index + 1;
                    const markerOptions = {
                        markerAttributes: {
                            "data-dealer-id": d.localDealerID
                        },
                        fitToBounds: true,
                        boundsPreservePaddingLeft: 50,
                        boundsPreservePaddingTop: 50,
                        boundsPreservePaddingBottom: 50,
                        boundsPreservePaddingRight: 50,
                        markerImage: "".concat(dealerId === d.localDealerID ? "toyota-black-innericon-text-dark" : "toyota-white-innericon-text-dark"),
                        markerClick: (i)=>{
                            var ref, ref1, ref2;
                            const cardRef = (ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.querySelector('[data-card-index="'.concat(markerIndex, '"]'));
                            if (cardRef) {
                                cardRef.scrollIntoView({
                                    behavior: "smooth"
                                });
                            }
                            const markerDealer = (ref1 = document.querySelectorAll(".mapboxgl-marker")[i]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.dataset) === null || ref2 === void 0 ? void 0 : ref2.dealerId;
                            handleSelectedDealerId(markerDealer, "markerclick");
                        }
                    };
                    window.customMap.addMarker(d.address.geo, markerOptions);
                });
            };
            if (navigator.permissions) {
                navigator.permissions.query({
                    name: "geolocation"
                }).then((permissionStatus)=>{
                    if (permissionStatus.state === "granted") {
                        navigator.geolocation.getCurrentPosition((position)=>{
                            const currentLocation = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            };
                            const currentLocationMarkerOptions = {
                                // element: el,
                                // markerImage: 'toyota-marker',
                                markerClick: ()=>{
                                    window.customMap.focusOn({
                                        coordinates: currentLocation
                                    });
                                }
                            };
                            window.customMap.addMarker(currentLocation, currentLocationMarkerOptions);
                        });
                    }
                });
            }
            addMarkers(searchData);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col lg:flex-row my-6 gap-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "order-last lg:order-first",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DealerFinder_ResultsList, {
                        searchData: searchData,
                        setDealer: setDealer,
                        selectedDealerId: selectedDealerId,
                        onSelectDealerID: (id)=>handleSelectedDealerId(id),
                        scrollRef: scrollRef
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DealerFinder_Map, {
                    searchData: searchData,
                    scrollRef: scrollRef,
                    triggerMarkers: (id)=>handleSelectedDealerId(id)
                })
            ]
        })
    });
};
/* harmony default export */ var DealerFinder_SearchResults = (SearchResults);

;// CONCATENATED MODULE: ./src/components/form/fields/DealerFinder/index.tsx




const DealerFinder = (param)=>{
    let { setDealer , noPadding =false  } = param;
    const [searchData, setSearchData] = (0,react.useState)([]);
    const updateSearchData = (data)=>{
        setSearchData(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "dealer-finder ".concat(noPadding ? "" : "container"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DealerFinder_SearchBar, {
                onSearchDataUpdate: updateSearchData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DealerFinder_SearchResults, {
                searchData: searchData,
                setDealer: setDealer
            })
        ]
    });
};
/* harmony default export */ var fields_DealerFinder = (DealerFinder);

// EXTERNAL MODULE: ./src/utils/helpers/index.ts + 9 modules
var helpers = __webpack_require__(45911);
;// CONCATENATED MODULE: ./src/components/form/fields/Dealers.tsx




const Dealers = (param)=>{
    let { helper , label , optional , ...rest } = param;
    const [dealers, setDealers] = (0,react.useState)([
        {
            label: "loading...",
            value: ""
        }
    ]);
    const name = "dealer";
    (0,react.useEffect)(()=>{
        async function getDealerList() {
            let list = await (0,helpers/* getDealers */.lf)();
            list = list.map((dealer)=>({
                    label: dealer._source.name.trim(),
                    value: "".concat(dealer._source.name.trim(), " :: ").concat(dealer._source.applications.NMSC.externalID)
                }));
            setDealers([
                ...list
            ]);
        }
        getDealerList();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* SelectInput */.lq, {
        name: name,
        label: label,
        options: dealers,
        helper: helper,
        optional: optional,
        ...rest
    });
};
/* harmony default export */ var fields_Dealers = (Dealers);

;// CONCATENATED MODULE: ./src/components/form/fields/Email.tsx


const Email = (param)=>{
    let { helper , ...rest } = param;
    const name = "email";
    const label = "Email";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* EmailInput */.U5, {
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_Email = (Email);

;// CONCATENATED MODULE: ./src/components/form/fields/EmailConfirm.tsx


const EmailConfirm = (param)=>{
    let { helper , ...rest } = param;
    const name = "confirm_email";
    const label = "Confirm email";
    return /*#__PURE__*/ _jsx(EmailInput, {
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_EmailConfirm = ((/* unused pure expression or super */ null && (EmailConfirm)));

;// CONCATENATED MODULE: ./src/components/form/fields/FinancialTerms.tsx


const FinancialTerms = ()=>{
    const brand = (0,contexts/* useBrand */.DY)();
    const privacyLink = brand === "lexus" ? "https://www.lexus.co.uk/customer-data/privacy-policy" : "https://www.toyota.co.uk/footer/privacy-policy";
    const unsubscribeLink = brand === "lexus" ? "https://forms2.lexus.co.uk/unsubscribe" : "https://forms.toyota.co.uk/unsubscribe";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "my-8",
        "data-gt-componentname": "terms",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We will endeavour to respond to your email within 2 working days."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Please note that we are only able to discuss details of an agreement with the agreement holder. If you wish to discuss a partner/family member's agreement with us, we will need the customer's expressed authority to do this. We will require the customer to contact us on",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline whitespace-nowrap",
                        href: brand === "lexus" ? "tel:+443708507788" : "tel:+443708505533",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "terms-click-tel",
                        "data-gt-label": brand === "lexus" ? "0370 850 7788" : "0370 850 5533",
                        children: brand === "lexus" ? "0370 850 7788" : "0370 850 5533"
                    }),
                    " ",
                    "and provide details of the third party's name, date of birth and a password, which will be used to identify them."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "If you’re finding it stressful or difficult to make your current payments, or have concerns about making them in future, please let us know as we’re here to help. We have a range of options available to support your individual circumstances. At",
                            " ",
                            brand === "lexus" ? "Lexus" : "Toyota",
                            " Financial Services, we are committed to supporting you and helping you find the best solution."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "pb-2",
                        children: "To get in touch, contact us by:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "pl-4 pb-2",
                                children: "• Typing ’Speak to an Agent’ in the live messenger located at the bottom right of this screen to be directed to one of the team"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "pl-4 pb-2",
                                children: [
                                    "• Phone",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "underline whitespace-nowrap",
                                        href: brand === "lexus" ? "tel:+443702430805" : "tel:+443702430804",
                                        "data-gt-name": "ctaevent",
                                        "data-gt-action": "terms-click-tel",
                                        "data-gt-label": brand === "lexus" ? "03702430805" : "03702430804",
                                        children: brand === "lexus" ? "0370 243 0805" : "0370 243 0804"
                                    }),
                                    " ",
                                    "(our opening hours are Monday to Friday 9am-5.30pm)"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "pl-4 pb-2 ",
                                children: [
                                    "• Email",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "underline",
                                        href: "mailto:Customeroutcomes@uk.toyota-fs.com ".concat(brand === "lexus" ? "Customeroutcomes@uk.lexus-fs.com" : "Customeroutcomes@uk.toyota-fs.com"),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "data-gt-name": "ctaevent",
                                        "data-gt-action": "email-click-link",
                                        "data-gt-label": brand === "lexus" ? "Customeroutcomes@uk.lexus-fs.com" : "Customeroutcomes@uk.toyota-fs.com",
                                        children: brand === "lexus" ? "Customeroutcomes@uk.lexus-fs.com" : "Customeroutcomes@uk.toyota-fs.com"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Remember, the earlier you get in touch the sooner we can help. It’s worth noting, missed or late payments may negatively impact your credit score and this could make it more difficult for you to obtain credit in the future"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: " Helpful Links"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "If you’re in need of free and impartial help and debt advice, there are several not for profit organisations who can support, such as",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "underline whitespace-nowrap",
                                href: "https://www.citizensadvice.org.uk",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                "data-gt-name": "ctaevent",
                                "data-gt-action": "help-click-link",
                                "data-gt-label": "www.citizensadvice.org.uk",
                                children: "www.citizensadvice.org.uk"
                            }),
                            ",",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "underline whitespace-nowrap",
                                href: "https://www.nationaldebtline.org",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                "data-gt-name": "ctaevent",
                                "data-gt-action": "help-click-link",
                                "data-gt-label": " www.nationaldebtline.org",
                                children: "www.nationaldebtline.org"
                            }),
                            ",",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "underline whitespace-nowrap",
                                href: "https://www.moneyhelper.org.uk",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                "data-gt-name": "ctaevent",
                                "data-gt-action": "help-click-link",
                                "data-gt-label": "www.moneyhelper.org.uk",
                                children: "www.moneyhelper.org.uk"
                            }),
                            " ",
                            "and",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "underline whitespace-nowrap",
                                href: "https://www.stepchange.org",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                "data-gt-name": "ctaevent",
                                "data-gt-action": "help-click-link",
                                "data-gt-label": "www.stepchange.org",
                                children: "www.stepchange.org"
                            }),
                            "."
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    brand === "lexus" ? "Lexus Financial Services " : "Toyota Financial Services (UK) PLC ",
                    "will use and process your personal data to assist you with and manage the matter that you have contacted us about."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Information about our use and handling of personal information, your data protection rights and how to contact us is provided in our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline whitespace-nowrap",
                        href: privacyLink,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "terms-click-link",
                        "data-gt-label": privacyLink,
                        children: "privacy notice"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "You can withdraw or change any of your communications preferences at any time. To do this please contact our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline",
                        href: "tel:+443708505533",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "terms-click-link",
                        "data-gt-label": "03708505533",
                        children: "Customer Experience Team"
                    }),
                    " ",
                    "or complete our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline",
                        href: unsubscribeLink,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "terms-click-link",
                        "data-gt-label": unsubscribeLink,
                        children: "form"
                    }),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_FinancialTerms = (FinancialTerms);

;// CONCATENATED MODULE: ./src/components/form/fields/FirstName.tsx


const FirstName = (param)=>{
    let { helper , name , label , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name || "first_name",
        label: label || "First name",
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_FirstName = (FirstName);

;// CONCATENATED MODULE: ./src/components/form/fields/FullName.tsx


const FullName = (param)=>{
    let { helper , ...rest } = param;
    const name = "full_name";
    const label = "Full name";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_FullName = (FullName);

;// CONCATENATED MODULE: ./src/components/form/fields/Grade.tsx



const Grade = (param)=>{
    let { helper , optional , ...rest } = param;
    const name = "grade";
    const label = "Grade";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* SelectInput */.lq, {
        name: name,
        label: label,
        options: constants/* LEXUS_GRADE_LBX */.eK,
        helper: helper,
        optional: optional,
        ...rest
    });
};
/* harmony default export */ var fields_Grade = (Grade);

;// CONCATENATED MODULE: ./src/components/form/fields/IsCurrentOwner.tsx





const IsCurrentOwner = (param)=>{
    let { inputLabel , ...rest } = param;
    const brand = (0,contexts_useBrand/* useBrand */.D)();
    const label = inputLabel || "Do you drive a ".concat((0,dist_es2015/* upperCaseFirst */.l)(brand), "?");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-medium my-5",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-btn-container flex mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: "toyota_owner",
                        label: "Yes",
                        value: true,
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: "toyota_owner",
                        label: "No",
                        value: false,
                        ...rest
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_IsCurrentOwner = (IsCurrentOwner);

;// CONCATENATED MODULE: ./src/components/form/fields/JobTitle.tsx


const JobTitle = (param)=>{
    let { helper , ...rest } = param;
    const name = "job_title";
    const label = "Job title";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_JobTitle = (JobTitle);

;// CONCATENATED MODULE: ./src/components/form/fields/LastName.tsx


const LastName = (param)=>{
    let { helper , name , label , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name || "last_name",
        label: label || "Last name",
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_LastName = (LastName);

// EXTERNAL MODULE: ./src/assets/icons/warning.svg
var warning = __webpack_require__(28484);
;// CONCATENATED MODULE: ./src/components/form/fields/Map/index.tsx
/* eslint-disable */ 






const Map_Map = (param)=>{
    let { search , label , toggleListView  } = param;
    const brand = useBrand();
    const [dealers, setDealers] = useState([]);
    const [selectedDealer, selectDealer] = useState(null);
    //const [maps, setMaps] = useState(null);
    const [isMapView, setMapView] = useState(!toggleListView);
    const mapsElement = useRef();
    const searchInput = useRef("");
    const [pinnedDealer, pinDealer] = useState(null);
    const [isSearching, setIsSearching] = useState(false);
    const [isDealerFound, setDealerFound] = useState(true);
    useEffect(()=>{
        //if (maps) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
        window.customMap = new mapsWrapper.DynamicMap(mapsElement.current, {
            accessToken: brand === "lexus" ? "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtqZzM5ZTA0bjgzZXBiemJ1ZHYyNDcifQ.Yfrq8kataFBLbN293vWY9A" : "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtpY2R1YTA0YW8zb2xzMzNkaDNxaTMifQ.LHbDy1LeUYXAgS7FJG-VOQ",
            countryCode: [
                "GB"
            ],
            language: "en",
            addCountryBoundaries: true,
            highResBoundary: true,
            boundsPreservePaddingLeft: document.documentElement.clientWidth < 900 ? 50 : 400,
            boundsPreservePaddingTop: document.documentElement.clientWidth < 900 ? 250 : 50,
            boundsPreservePaddingBottom: 50,
            boundsPreservePaddingRight: 50,
            maxZoom: 15,
            minZoom: 10,
            fitToBounds: "recalc"
        });
        // add boundaries
        // window.customMap.addCountryBoundaries(["GB"], { highResBoundary: true })
        // add auto complete
        new mapsWrapper.AutoComplete({
            autoCompleteInput: document.getElementById("places"),
            accessToken: brand === "lexus" ? "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtqZzM5ZTA0bjgzZXBiemJ1ZHYyNDcifQ.Yfrq8kataFBLbN293vWY9A" : "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtpY2R1YTA0YW8zb2xzMzNkaDNxaTMifQ.LHbDy1LeUYXAgS7FJG-VOQ",
            countryCode: [
                "GB",
                "IM",
                "JE",
                "GG"
            ],
            types: "place,locality,neighborhood,region,postcode",
            onLocationSelect: (location)=>{
                if (location) {
                    const lon = location.coordinates[0];
                    const lat = location.coordinates[1];
                    getDealersList({
                        lat,
                        lon
                    }, (result)=>{
                        // const radiusResult = result.dealers.filter(dealer =>  dealer.distance < 50)
                        setIsSearching(false);
                        setDealers(result.dealers);
                        addMarkers(result.dealers);
                        setDealerFound(result.dealers.length > 0);
                    });
                }
            }
        });
    //}
    }, []);
    useEffect(()=>{
        search(selectedDealer);
        updateDatalayer("dealer", selectedDealer);
    }, [
        selectedDealer
    ]);
    const addMarkers = (dealers)=>{
        window.customMap.clearMarkers();
        dealers.map((d, index)=>{
            window.customMap.addMarker(d.address.geo, {
                fitToBounds: true,
                boundsPreservePaddingLeft: document.documentElement.clientWidth < 900 ? 50 : 400,
                boundsPreservePaddingTop: document.documentElement.clientWidth < 900 ? 250 : 50,
                boundsPreservePaddingBottom: 50,
                boundsPreservePaddingRight: 50,
                markerImage: "toyota-black-innericon-text-dark",
                markerClick: ()=>{
                    window.customMap.focusOn({
                        coordinates: d.address.geo
                    });
                    pinDealer(index + 1);
                    customEvent({
                        name: "componentevent",
                        componentName: tracking.componentName(),
                        componentGroup: tracking.componentGroup(),
                        action: "map-click-icon",
                        label: "".concat(d.name)
                    });
                    // expand dealer on click on
                    const expandedDealer = dealers.map((dealer, i)=>({
                            ...dealer,
                            isDetailsExpanded: i === index ? true : dealer.isDetailsExpanded,
                            isOpeningExpanded: i === index ? true : dealer.isOpeningExpanded
                        }));
                    setDealers(expandedDealer);
                    setTimeout(()=>{
                        document.querySelector(".dealer-".concat(index)).scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                    }, 50);
                }
            });
        });
    };
    const getDeviceGeoLocation = ()=>{
        navigator.geolocation.getCurrentPosition(function(position) {
            const lon = position.coords.longitude;
            const lat = position.coords.latitude;
            // reverse search
            window.customMap.geocoder.reverse([
                lon,
                lat
            ]).then((address)=>{
                var ref;
                if (address.length > 0) searchInput.current.value = (ref = address[0]) === null || ref === void 0 ? void 0 : ref.postcode;
            });
            // find dealers
            getDealersList({
                lat,
                lon
            }, (result)=>{
                // const radiusResult = result.dealers.filter(dealer =>  dealer.distance < 50)
                setIsSearching(false);
                setDealers(result.dealers);
                addMarkers(result.dealers);
                setDealerFound(result.dealers.length > 0);
            });
        });
    };
    const searchByPostcode = (term)=>{
        setDealers([]);
        window.customMap.geocoder.search(term, {
            countryCode: [
                "GB",
                "IM",
                "JE",
                "GG"
            ]
        }).then((geo)=>{
            if (geo.length) {
                const lon = geo[0].coordinates[0];
                const lat = geo[0].coordinates[1];
                getDealersList({
                    lat,
                    lon
                }, (result)=>{
                    // const radiusResult = result.dealers.filter(dealer =>  dealer.distance < 50)
                    setIsSearching(false);
                    setDealers(result.dealers);
                    addMarkers(result.dealers);
                    setDealerFound(result.dealers.length > 0);
                });
            } else setDealerFound(false);
        });
    };
    const getDealersList = function(coords, callback) {
        setIsSearching(true);
        fetch("https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/".concat(brand, "/gb/en/drive/").concat(coords.lon, "/").concat(coords.lat, "?count=10&extraCountries=&isCurrentLocation=false&services=ShowRoom")).then((response)=>response.json()).then(callback).catch((error)=>{
            console.error("Error:", error);
            setIsSearching(false);
        });
    };
    const getOpeningDays = (opening)=>{
        const services = [
            ...new Set(opening.map((service)=>service.service))
        ];
        const days = services.map((service)=>{
            let times = opening.map((el, index)=>{
                var ref, ref1, ref2, ref3;
                if (el.service === service) return /*#__PURE__*/ _jsxs("div", {
                    className: " flex justify-between leading-[22px] ",
                    children: [
                        ((ref = el === null || el === void 0 ? void 0 : el.hours[0]) === null || ref === void 0 ? void 0 : ref.startTime) && /*#__PURE__*/ _jsxs("div", {
                            children: [
                                el === null || el === void 0 ? void 0 : el.startDay,
                                (el === null || el === void 0 ? void 0 : el.endDay) !== (el === null || el === void 0 ? void 0 : el.startDay) ? " - " + (el === null || el === void 0 ? void 0 : el.endDay) : ""
                            ]
                        }),
                        ((ref1 = el === null || el === void 0 ? void 0 : el.hours[0]) === null || ref1 === void 0 ? void 0 : ref1.startTime) && /*#__PURE__*/ _jsxs("div", {
                            children: [
                                (ref2 = el === null || el === void 0 ? void 0 : el.hours[0]) === null || ref2 === void 0 ? void 0 : ref2.startTime,
                                " - ",
                                (ref3 = el === null || el === void 0 ? void 0 : el.hours[0]) === null || ref3 === void 0 ? void 0 : ref3.endTime
                            ]
                        })
                    ]
                }, index);
            });
            times = times.filter((el)=>el);
            return /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: " flex justify-between font-medium mt-4 leading-[30px] ",
                        children: service.toUpperCase()
                    }),
                    times
                ]
            }, service);
        });
        return days;
    };
    const ratingStars = (rating)=>{
        const stars = [];
        for(var i = 0; i < Math.floor(rating); i++){
            stars.push(/*#__PURE__*/ _jsx("svg", {
                "aria-hidden": "true",
                className: "w-5 h-5 text-black ",
                fill: "currentColor",
                viewBox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                })
            }, i));
        }
        return stars;
    };
    const dealerList = (dealers)=>{
        return dealers.map((el, index)=>{
            /*#__PURE__*/ return _jsxs("div", {
                className: "dealer-".concat(index, " ").concat(isMapView ? pinnedDealer !== index + 1 ? " hidden shadow-md lg:shadow-none lg:block" : "block" : "", " ").concat(isMapView ? " bg-white " : " bg-grey ", " text-base-text mb-[10px] py-[17px]  px-[20px] w-[100%] "),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: " flex justify-between",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: " flex items-center ",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "w-[22px] title h-[22px] bg-base text-white text-sm rounded-full leading-[22px] flex justify-center items-center pb-[2px]",
                                        children: index + 1
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: " pl-2",
                                        children: [
                                            (el.distance * 0.62137119).toFixed(2),
                                            " miles"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                className: "".concat(isMapView ? " block lg:hidden" : "hidden"),
                                onClick: ()=>{
                                    pinDealer(null);
                                    window.customMap.fitBoundsToMarkers({
                                        boundsPreservePaddingLeft: document.documentElement.clientWidth < 900 ? 50 : 400,
                                        boundsPreservePaddingTop: document.documentElement.clientWidth < 900 ? 250 : 50,
                                        boundsPreservePaddingBottom: 50,
                                        boundsPreservePaddingRight: 50
                                    });
                                },
                                children: /*#__PURE__*/ _jsx("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    strokeWidth: 1.5,
                                    stroke: "currentColor",
                                    className: "w-6 h-6",
                                    children: /*#__PURE__*/ _jsx("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        d: "M6 18L18 6M6 6l12 12"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: " flex mt-[10px] ",
                        children: el.name
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "".concat(!isMapView ? "flex" : "", " "),
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: " font-medium leading-[27px] ",
                                children: el.address.address
                            }),
                            (el === null || el === void 0 ? void 0 : el.isDetailsExpanded) && /*#__PURE__*/ _jsxs("div", {
                                className: " font-medium leading-[27px] ",
                                children: [
                                    el.address.address1,
                                    "".concat(!isMapView ? ",\xa0" : "")
                                ]
                            }),
                            (el === null || el === void 0 ? void 0 : el.isDetailsExpanded) && /*#__PURE__*/ _jsxs("div", {
                                className: " font-medium leading-[27px]",
                                children: [
                                    el.address.city,
                                    ", ",
                                    el.address.zip
                                ]
                            })
                        ]
                    }),
                    !(el === null || el === void 0 ? void 0 : el.isDetailsExpanded) && /*#__PURE__*/ _jsxs("div", {
                        className: " flex justify-between mt-4 ",
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                className: " text-md underline ",
                                onClick: (e)=>{
                                    const editedDealer = dealers.map((dealer, i)=>({
                                            ...dealer,
                                            isDetailsExpanded: i === index ? true : el.isDetailsExpanded
                                        }));
                                    window.customMap.focusOn({
                                        coordinates: el.address.geo
                                    });
                                    setDealers(editedDealer);
                                },
                                "data-gt-name": "componentevent",
                                "data-gt-componentgroup": tracking.componentGroup(),
                                "data-gt-componentname": tracking.componentName(),
                                "data-gt-action": "map-toggle",
                                "data-gt-label": "more details",
                                children: brand === "lexus" ? "Full details" : "More details"
                            }),
                            /*#__PURE__*/ _jsx(CTA, {
                                onClick: (e)=>{
                                    selectDealer(el);
                                },
                                "data-gt-name": "componentevent",
                                "data-gt-componentgroup": tracking.componentGroup(),
                                "data-gt-componentname": tracking.componentName(),
                                "data-gt-action": "map-click-cta",
                                "data-gt-label": "choose dealer",
                                children: brand === "lexus" ? "Choose centre" : "Choose Dealer"
                            })
                        ]
                    }),
                    (el === null || el === void 0 ? void 0 : el.isDetailsExpanded) && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs("button", {
                                onClick: (e)=>{
                                    const editedDealer = dealers.map((dealer, i)=>({
                                            ...dealer,
                                            isDetailsExpanded: i === index ? false : dealer.isDetailsExpanded
                                        }));
                                    setDealers(editedDealer);
                                },
                                className: " flex justify-between items-center mt-[16px] w-[100%] text-md underline ",
                                "data-gt-name": "componentevent",
                                "data-gt-componentgroup": tracking.componentGroup(),
                                "data-gt-componentname": tracking.componentName(),
                                "data-gt-action": "map-toggle",
                                "data-gt-label": "less details",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        children: "Less details"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        children: /*#__PURE__*/ _jsx("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 1.5,
                                            stroke: "currentColor",
                                            className: "w-4 h-4",
                                            children: /*#__PURE__*/ _jsx("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M4.5 15.75l7.5-7.5 7.5 7.5"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mt-3 ",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: " flex mt-[22px] ",
                                        children: [
                                            "Call:",
                                            " ",
                                            /*#__PURE__*/ _jsxs("a", {
                                                className: " ".concat(brand === "lexus" ? "" : "font-medium ", "  ml-[2px]"),
                                                href: "tel:".concat(el.phone.trim()),
                                                "data-gt-name": "componentevent",
                                                "data-gt-componentgroup": tracking.componentGroup(),
                                                "data-gt-componentname": tracking.componentName(),
                                                "data-gt-action": "map-click-cta",
                                                "data-gt-label": "".concat(el.phone.trim()),
                                                children: [
                                                    " ",
                                                    el.phone
                                                ]
                                            })
                                        ]
                                    }),
                                    el.rating && /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mt-2 ",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "relative flex ",
                                                children: ratingStars(el.rating.fivestar)
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "ml-2 text-sm font-medium text-gray-500 dark:text-gray-400",
                                                children: el.rating.fivestar
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("button", {
                                        onClick: (e)=>{
                                            const editedDealer = dealers.map((dealer, i)=>{
                                                return {
                                                    ...dealer,
                                                    isOpeningExpanded: i === index ? !(dealer === null || dealer === void 0 ? void 0 : dealer.isOpeningExpanded) : dealer === null || dealer === void 0 ? void 0 : dealer.isOpeningExpanded
                                                };
                                            });
                                            setDealers(editedDealer);
                                        },
                                        className: " ".concat(brand === "lexus" ? "" : "font-medium ", "   flex justify-between items-center mt-3 w-[100%]"),
                                        "data-gt-name": "componentevent",
                                        "data-gt-componentgroup": tracking.componentGroup(),
                                        "data-gt-componentname": tracking.componentName(),
                                        "data-gt-action": "map-toggle",
                                        "data-gt-label": "opening hours",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: "Services and Opening Hours"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    (el === null || el === void 0 ? void 0 : el.isOpeningExpanded) && /*#__PURE__*/ _jsx("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        strokeWidth: 1.5,
                                                        stroke: "currentColor",
                                                        className: "w-4 h-4",
                                                        children: /*#__PURE__*/ _jsx("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            d: "M4.5 15.75l7.5-7.5 7.5 7.5"
                                                        })
                                                    }),
                                                    !(el === null || el === void 0 ? void 0 : el.isOpeningExpanded) && /*#__PURE__*/ _jsx("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        strokeWidth: 1.5,
                                                        stroke: "currentColor",
                                                        className: "w-4 h-4",
                                                        children: /*#__PURE__*/ _jsx("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    el.isOpeningExpanded && getOpeningDays(el.openingDays),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mt-[20px] mb-[10px]",
                                        children: /*#__PURE__*/ _jsx(CTA, {
                                            className: "".concat(brand === "lexus" ? "group flex items-center w-full justify-center !leading-10 pl-4 uppercase rounded bg-secondary text-white outline-0 hover:opacity-50 active:opacity-50 focus:opacity-50 disabled:cursor-not-allowed disabled:opacity-50" : "inline-flex items-center justify-center px-6 py-3 bg-base text-white outline-0 w-full hover:bg-base-hover active:bg-base-hover focus:bg-base-hover disabled:cursor-not-allowed disabled:bg-base-hover"),
                                            onClick: (e)=>{
                                                selectDealer(el);
                                            },
                                            "data-gt-name": "componentevent",
                                            "data-gt-componentgroup": tracking.componentGroup(),
                                            "data-gt-componentname": tracking.componentName(),
                                            "data-gt-action": "map-click-cta",
                                            "data-gt-label": "choose dealer",
                                            children: brand === "lexus" ? "Choose centre" : "Choose Dealer"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, index);
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            search && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: " ".concat(isMapView ? "  lg:max-w-[353px] lg:left-[20px] lg:top-[20px] top-20 " : " top-[85px]  lg:max-w-[100%] ", " absolute  mb-[10px]  left-[20px] right-[20px] z-[9]  max-h-[100%] "),
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "group  ".concat(isMapView ? " bg-white " : " bg-grey ", "  p-6 leading-[32px]  "),
                            children: [
                                label,
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ _jsx("input", {
                                            type: "text",
                                            id: "places",
                                            ref: searchInput,
                                            className: "relative p-4 h-[48px] pl-[40px] mt-2 pr-[88px] w-[100%] text-ellipsis overflow-hidden",
                                            "data-gt-name": "componentevent",
                                            "data-gt-componentgroup": tracking.componentGroup(),
                                            "data-gt-componentname": tracking.componentName(),
                                            "data-gt-action": "text-input-interaction",
                                            "data-gt-label": "postcode location"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "pointer-events-none absolute inset-y-0 bottom-[-5px] left-[2px] flex items-center pl-3",
                                            children: /*#__PURE__*/ _jsx("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                strokeWidth: 1.5,
                                                stroke: "currentColor",
                                                className: "w-5 h-5 ",
                                                children: /*#__PURE__*/ _jsx("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: " z-9 absolute inset-y-0 ".concat(brand === "lexus" ? " " : "   ", " bottom-[-9px] right-[60px] flex items-center pl-3"),
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: (e)=>{
                                                    getDeviceGeoLocation();
                                                },
                                                className: " ".concat(brand === "lexus" ? " text-base-text " : " h-full text-sm ", " flex text-base-text h-full  "),
                                                "data-gt-name": "componentevent",
                                                "data-gt-componentgroup": tracking.componentGroup(),
                                                "data-gt-componentname": tracking.componentName(),
                                                "data-gt-action": "map-click-icon",
                                                "data-gt-label": "geo location",
                                                children: /*#__PURE__*/ _jsx("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    viewBox: "0 0 24 24",
                                                    className: "w-6 h-6 ".concat(brand === "lexus" ? "" : "   ", " m-auto "),
                                                    children: /*#__PURE__*/ _jsx("path", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        stroke: "currentColor",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        strokeWidth: "2",
                                                        d: "M5 11l14-6-6 14-2-6-6-2z"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("button", {
                                            onClick: (e)=>{
                                                searchInput.current.value !== "" && searchByPostcode(searchInput.current.value);
                                                searchInput.current.focus();
                                            },
                                            className: "absolute right-1 bottom-1 h-10 ".concat(brand === "lexus" ? "!uppercase" : "", " px-4 py-1 p-4  text-sm text-gray capitalize flex items-center justify-center "),
                                            "data-gt-name": "componentevent",
                                            "data-gt-componentgroup": tracking.componentGroup(),
                                            "data-gt-componentname": tracking.componentName(),
                                            "data-gt-action": "map-click-cta",
                                            "data-gt-label": "find",
                                            children: [
                                                isSearching && /*#__PURE__*/ _jsx("div", {
                                                    className: "loader dark",
                                                    children: "Loading..."
                                                }),
                                                "Find"
                                            ]
                                        })
                                    ]
                                }),
                                !isDealerFound && /*#__PURE__*/ _jsxs("div", {
                                    className: "text-red text-tiny flex justify-between pt-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "No location found"
                                        }),
                                        /*#__PURE__*/ _jsx(Warning, {
                                            className: " h-4 mt-2"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    dealers && /*#__PURE__*/ _jsx("div", {
                        className: " ".concat(isMapView ? "  search-list lg:max-h-[calc(100vh-370px)] h-auto ".concat(pinnedDealer ? " z-[10]" : "shadow-md lg:shadow-none  z-1 lg:z-[10]", " top-[80px] lg:top-[165px]  lg:max-w-[353px] lg:left-[20px]") : " top-[230px] lg:max-w-[100%]  lg:top-[230px]  ", " absolute  left-[20px] right-[20px]     overflow-y-auto    "),
                        children: dealerList(dealers)
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: " absolute right-[20px] top-[20px] flex",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: " bg-white text-[15px] leading-[50px] w-[131px] h-[50px] z-10 flex",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            className: "w-[100%] text-center ".concat(isMapView ? " underline " : ""),
                            onClick: (e)=>{
                                setMapView(true);
                            },
                            "data-gt-name": "componentevent",
                            "data-gt-componentgroup": tracking.componentGroup(),
                            "data-gt-componentname": tracking.componentName(),
                            "data-gt-action": "map-click-cta",
                            "data-gt-label": "map view",
                            children: "Map"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "w-[100%] text-center ".concat(isMapView ? "" : " underline "),
                            onClick: (e)=>{
                                setMapView(false);
                            },
                            "data-gt-name": "componentevent",
                            "data-gt-componentgroup": tracking.componentGroup(),
                            "data-gt-componentname": tracking.componentName(),
                            "data-gt-action": "map-click-cta",
                            "data-gt-label": "list view",
                            children: "List"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                // removed overflow-auto to fix map bug
                className: "absolute  w-full h-screen md:h-full left-0 toyota-map ".concat(isMapView ? "" : " hidden ", " "),
                ref: mapsElement
            })
        ]
    });
};
/* harmony default export */ var fields_Map = ((/* unused pure expression or super */ null && (Map_Map)));

// EXTERNAL MODULE: ./src/assets/icons/tick.svg
var tick = __webpack_require__(26659);
;// CONCATENATED MODULE: ./src/components/form/fields/Map/FindDealer.tsx
/* eslint-disable */ 




const FindDealer = (param)=>{
    let { search , label , infoText , isError , value , optional , hidden  } = param;
    const searchInput = (0,react.useRef)(value);
    const brand = (0,contexts/* useBrand */.DY)();
    const query = (0,contexts/* useQuery */.aM)();
    const [isSearching, setIsSearching] = (0,react.useState)(false);
    const [isDealerFound, setDealerFound] = (0,react.useState)(true);
    const [dealersCount, setDealersCount] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        searchInput.current.value = value;
    }, [
        value
    ]);
    (0,react.useEffect)(()=>{
        // if (!maps) return;
        window.customMap = new mapsWrapper.DynamicMap(document.createElement("div"), {
            accessToken: brand === "lexus" ? "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtqZzM5ZTA0bjgzZXBiemJ1ZHYyNDcifQ.Yfrq8kataFBLbN293vWY9A" : "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtpY2R1YTA0YW8zb2xzMzNkaDNxaTMifQ.LHbDy1LeUYXAgS7FJG-VOQ",
            countryCode: [
                "GB",
                "IM",
                "JE",
                "GG"
            ],
            language: "en"
        });
        // add auto complete
        new mapsWrapper.AutoComplete({
            autoCompleteInput: searchInput.current,
            accessToken: brand === "lexus" ? "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtqZzM5ZTA0bjgzZXBiemJ1ZHYyNDcifQ.Yfrq8kataFBLbN293vWY9A" : "pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtpY2R1YTA0YW8zb2xzMzNkaDNxaTMifQ.LHbDy1LeUYXAgS7FJG-VOQ",
            countryCode: [
                "GB",
                "IM",
                "JE",
                "GG"
            ],
            types: "place,locality,neighborhood,region,postcode",
            onLocationSelect: (location)=>{
                if (location) {
                    const lon = location.coordinates[0];
                    const lat = location.coordinates[1];
                    getDealersList({
                        lat,
                        lon
                    }, (result)=>{
                        setDealersCount(result.dealers.length);
                        setIsSearching(false);
                        search(result.dealers, searchInput.current.value);
                        setDealerFound(result.dealers.length > 0);
                    });
                }
            }
        });
    }, []);
    const searchByPostcode = (term)=>{
        window.customMap.geocoder.search(term, {
            countryCode: [
                "GB",
                "IM",
                "JE",
                "GG"
            ]
        }).then((geo)=>{
            if (geo.length) {
                const lon = geo[0].coordinates[0];
                const lat = geo[0].coordinates[1];
                getDealersList({
                    lat,
                    lon
                }, (result)=>{
                    setDealersCount(result.dealers.length);
                    setIsSearching(false);
                    search(result.dealers, term);
                    setDealerFound(result.dealers.length > 0);
                });
            } else setDealerFound(false);
        });
    };
    const getDealersList = async (coords, callback)=>{
        setIsSearching(true);
        const url = (query === null || query === void 0 ? void 0 : query.group) ? "https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/".concat(brand, "/gb/en/drive/").concat(coords.lon, "/").concat(coords.lat, "?count=5000&extraCountries=&isCurrentLocation=false&services=ShowRoom") : "https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/".concat(brand, "/gb/en/drive/").concat(coords.lon, "/").concat(coords.lat, "?count=10&extraCountries=&isCurrentLocation=false&services=ShowRoom");
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();
            if (query === null || query === void 0 ? void 0 : query.group) {
                data.dealers = data.dealers.filter((i)=>i.parent === query.group);
                data.total = data.dealers.length;
            }
            data.dealers = data.dealers.filter((i)=>i.services.some((j)=>j.service === "ShowRoom"));
            callback(data);
        } catch (error) {
            console.error("Error:", error);
        } finally{
            setIsSearching(false);
        }
    };
    if (hidden) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:col-span-2 lg:col-span-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    children: label
                }),
                "              ",
                optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-xs lowercase whitespace-nowrap",
                    children: "(optional)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-xs whitespace-nowrap",
                    children: infoText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "text",
                            id: "places",
                            ref: searchInput,
                            className: " ".concat(isError && "border-red", " ").concat(dealersCount > 0 && "border-green", " relative p-4 h-[48px] mb-[6px] pl-[40px] mt-2 pr-[52px] w-[100%] text-ellipsis overflow-hidden"),
                            "data-gt-action": "text-input-interaction",
                            "data-gt-label": "places"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pointer-events-none absolute inset-y-0 bottom-0 left-[2px] flex items-center pl-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 1.5,
                                stroke: "currentColor",
                                className: "w-5 h-5 ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " z-9 absolute inset-y-0 bottom-[-9px] right-[60px] flex items-center pl-3"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " z-9 absolute inset-y-0  top-2 right-[40px] flex items-center pl-3",
                            children: [
                                isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                    className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red"
                                }),
                                dealersCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                    className: "absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            disabled: isSearching,
                            onClick: (e)=>{
                                e.preventDefault();
                                searchInput.current.value !== "" && searchByPostcode(searchInput.current.value);
                                searchInput.current.value === "" && searchInput.current.focus();
                            },
                            className: "absolute right-1 bottom-1  ".concat(brand === "lexus" ? " h-12 text-[11px] !uppercase mb-[3px]" : " h-10", " px-4 py-1 mb-[6px] p-4  text-sm text-gray capitalize flex items-center justify-center "),
                            "data-gt-action": "find-dealer-cta-click",
                            "data-gt-label": "find",
                            children: [
                                isSearching && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "loader dark",
                                    children: "Loading..."
                                }),
                                "Find"
                            ]
                        })
                    ]
                }),
                !isDealerFound && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-red text-tiny flex justify-between pt-1",
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "No location found."
                        })
                    ]
                }),
                isError && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-red text-tiny flex justify-between ",
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "Please search for your nearest",
                                " ",
                                brand === "lexus" ? "Lexus centre" : "Toyota dealer",
                                "."
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Map_FindDealer = (FindDealer);

// EXTERNAL MODULE: ./src/assets/icons/lexusInfo.svg
var lexusInfo = __webpack_require__(78063);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(59595);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/components/form/fields/MarketingConsent.tsx










const TooltipIcon = (param)=>{
    let { brand , ...rest } = param;
    if (brand === "lexus") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(lexusInfo/* default */.Z, {
            ...rest
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(toyotaInfo/* default */.Z, {
        ...rest
    });
};
const MarketingConsent = (param)=>{
    let { ...rest } = param;
    const brand = (0,contexts/* useBrand */.DY)();
    const [personalisedModalIsOpen, personalisedSetIsOpen] = (0,react.useState)(false);
    const [unsubscribeModalIsOpen, unsubscribeSetIsOpen] = (0,react.useState)(false);
    lib_default().setAppElement("#__next");
    function closePersonalisedModal() {
        personalisedSetIsOpen(false);
        (0,helpers_tracking/* customEvent */._H)({
            name: "componentevent",
            componentName: helpers/* tracking.componentName */.UO.componentName(),
            componentGroup: helpers/* tracking.componentGroup */.UO.componentGroup(),
            action: "consent-close-modal",
            label: "personalisation"
        });
    }
    function openUnsubscribeModal() {
        unsubscribeSetIsOpen(true);
    }
    function closeUnsubscribeModal() {
        unsubscribeSetIsOpen(false);
        (0,helpers_tracking/* customEvent */._H)({
            name: "componentevent",
            componentName: helpers/* tracking.componentName */.UO.componentName(),
            componentGroup: helpers/* tracking.componentGroup */.UO.componentGroup(),
            action: "consent-close-modal",
            label: "unsubscribe"
        });
    }
    const privacyLink = brand === "lexus" ? "https://www.lexus.co.uk/customer-data/privacy-policy" : "https://www.toyota.co.uk/footer/privacy-policy";
    const unsubscribeLink = brand === "lexus" ? "https://forms2.lexus.co.uk/unsubscribe" : "https://forms.toyota.co.uk/unsubscribe";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-8 text-base-text",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-8",
                children: [
                    "We'd like to keep you updated on our latest news, offers and events. We will send these communications by email, phone, SMS or post. Be assured that ",
                    (0,dist_es2015/* upperCaseFirst */.l)(brand),
                    " will only share your personal information with companies that are an integral part of fulfilling the services we deliver. If you would like to find out more about how we process your data please visit our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline",
                        href: privacyLink,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "consent-click-link",
                        "data-gt-label": privacyLink,
                        children: "privacy notice"
                    }),
                    " ",
                    "for details."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "".concat(brand === "lexus" ? "text-lg" : "font-medium ", " mb-3"),
                children: "Yes, I'd like to receive:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(baseInputs/* CheckboxInput */.I0, {
                name: "consent.user",
                ...rest,
                children: [
                    "Latest news, offers and events from ",
                    (0,dist_es2015/* upperCaseFirst */.l)(brand)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mt-2",
                children: [
                    "I understand that I can",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline",
                        href: unsubscribeLink,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "consent-click-link",
                        "data-gt-label": unsubscribeLink,
                        children: "unsubscribe"
                    }),
                    " ",
                    "at any",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "whitespace-nowrap",
                        children: [
                            "time.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipIcon, {
                                brand: brand,
                                className: "inline-block ml-2 h-[17px] mt-[-5px] cursor-pointer text-base-text",
                                "data-tip": true,
                                "data-for": "unsubscribeTooltip",
                                "data-gt-name": "componentevent",
                                "data-gt-action": "consent-open-modal",
                                "data-gt-label": "unsubscribe",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    openUnsubscribeModal();
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                className: "".concat(brand === "toyota" ? "rounded" : "", " absolute bg-base text-white top-1/2 left-1/2 right-auto bottom-auto mr-[-50%] -translate-y-1/2 -translate-x-1/2 max-w-[90%] md:max-w-screen-sm max-h-[60%] p-8 overflow-y-auto w-full focus:border-opacity/0 outline-none"),
                overlayClassName: "fixed top-0 left-0 right-0 bottom-0 z-20 bg-[#FFF]/75",
                id: "personalisedModal",
                isOpen: personalisedModalIsOpen,
                onRequestClose: closePersonalisedModal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "absolute top-3 right-4 text-3xl leading-none",
                        onClick: closePersonalisedModal,
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-medium mb-3",
                        children: "Our Marketing Communications"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "We want to make our communications as relevant as possible to your interests. To do that we will use data we hold about you to create an individual customer profile. This profile is created using data you have provided to us, for example, contact details, preferences, vehicle information, and online activity. Our policy at",
                            " ",
                            (0,dist_es2015/* upperCaseFirst */.l)(brand),
                            " (GB) plc is to never share your personal information with companies unless they have a direct connection with us and help us to deliver the best possible products, services and offers based on your requirements and preference. You can unsubscribe at any time. Find more information on how we handle your data in our",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "underline",
                                href: privacyLink,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                "data-gt-name": "ctaevent",
                                "data-gt-action": "consent-click-link",
                                "data-gt-label": privacyLink,
                                children: "privacy notice"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                className: "".concat(brand === "toyota" ? "rounded" : "", " absolute bg-base text-white top-1/2 left-1/2 right-auto bottom-auto mr-[-50%] -translate-y-1/2 -translate-x-1/2 max-w-[90%] md:max-w-screen-sm max-h-[50%] p-8 overflow-y-auto w-full focus:border-opacity/0 outline-none"),
                overlayClassName: "fixed top-0 left-0 right-0 bottom-0 z-20 bg-[#FFF]/75",
                id: "unsubscribeModal",
                isOpen: unsubscribeModalIsOpen,
                onRequestClose: closeUnsubscribeModal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "absolute top-3 right-4 text-3xl leading-none",
                        onClick: closeUnsubscribeModal,
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-3",
                        children: "To amend or withdraw your consent at any time:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "list-disc pl-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "mb-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "underline",
                                        href: unsubscribeLink,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "data-gt-name": "ctaevent",
                                        "data-gt-action": "consent-click-link",
                                        "data-gt-label": unsubscribeLink,
                                        children: "Unsubscribe"
                                    }),
                                    " ",
                                    "here"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "mb-1",
                                children: [
                                    "Log into your My",
                                    (0,dist_es2015/* upperCaseFirst */.l)(brand),
                                    " account and update your preferences"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "mb-1",
                                children: [
                                    "Click on the",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "underline",
                                        href: unsubscribeLink,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "data-gt-name": "ctaevent",
                                        "data-gt-action": "consent-click-link",
                                        "data-gt-label": unsubscribeLink,
                                        children: "unsubscribe"
                                    }),
                                    " ",
                                    "link in any future communication we send you"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_MarketingConsent = (MarketingConsent);

;// CONCATENATED MODULE: ./src/components/form/fields/MarketingConsentKinto.tsx


const MarketingConsentKinto = (param)=>{
    let { ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-8 text-base-text",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* CheckboxInput */.I0, {
                name: "consent",
                ...rest,
                children: "Yes, I would like to receive updates about products & services from KINTO"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mt-2",
                children: [
                    "We are committed to protecting your data; find out more in our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline",
                        href: "https://www.kinto-mobility.co.uk/privacy-policy",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "consent-click-link",
                        "data-gt-label": "https://www.kinto-mobility.co.uk/privacy-policy",
                        children: "Privacy Notice"
                    }),
                    ". You may unsubscribe at any time by clicking on the link in each email we send to you or by contacting us at",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline",
                        href: "mailto:DPO@kinto-uk.com",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "consent-click-link",
                        "data-gt-label": "mailto:DPO@kinto-uk.com",
                        children: "DPO@kinto-uk.com"
                    }),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_MarketingConsentKinto = (MarketingConsentKinto);

;// CONCATENATED MODULE: ./src/components/form/fields/MarketingConsentSimple.tsx










const MarketingConsentSimple_TooltipIcon = (param)=>{
    let { brand , ...rest } = param;
    if (brand === "lexus") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(lexusInfo/* default */.Z, {
            ...rest
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(toyotaInfo/* default */.Z, {
        ...rest
    });
};
const MarketingConsentSimple = (param)=>{
    let { ...rest } = param;
    const brand = (0,contexts/* useBrand */.DY)();
    const [unsubscribeModalIsOpen, unsubscribeSetIsOpen] = (0,react.useState)(false);
    lib_default().setAppElement("#__next");
    function openUnsubscribeModal() {
        unsubscribeSetIsOpen(true);
    }
    function closeUnsubscribeModal() {
        unsubscribeSetIsOpen(false);
        (0,helpers_tracking/* customEvent */._H)({
            name: "componentevent",
            componentName: helpers/* tracking.componentName */.UO.componentName(),
            componentGroup: helpers/* tracking.componentGroup */.UO.componentGroup(),
            action: "consent-close-modal",
            label: "unsubscribe"
        });
    }
    const privacyLink = brand === "lexus" ? "https://www.lexus.co.uk/customer-data/privacy-policy" : "https://www.toyota.co.uk/footer/privacy-policy";
    const unsubscribeLink = brand === "lexus" ? "https://forms2.lexus.co.uk/unsubscribe" : "https://forms.toyota.co.uk/unsubscribe";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-4",
                children: [
                    "We'd like to keep you updated on our latest news, offers and events. We will send these communications by email, phone, SMS or post. Be assured that Toyota and Lexus will only share your personal information with companies that are an integral part of fulfilling the services we deliver. If you would like to find out more about how we process your data please visit our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline",
                        href: privacyLink,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "consent-click-link",
                        "data-gt-label": privacyLink,
                        children: "privacy notice"
                    }),
                    " ",
                    "for details."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mt-2 mb-4",
                children: [
                    "I understand that I can",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "underline",
                        href: unsubscribeLink,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "consent-click-link",
                        "data-gt-label": unsubscribeLink,
                        children: "unsubscribe"
                    }),
                    " ",
                    "at any",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "whitespace-nowrap",
                        children: [
                            "time.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingConsentSimple_TooltipIcon, {
                                brand: brand,
                                className: "inline-block ml-2 h-[17px] mt-[-5px] cursor-pointer",
                                "data-tip": true,
                                "data-for": "unsubscribeTooltip",
                                "data-gt-name": "componentevent",
                                "data-gt-action": "consent-open-modal",
                                "data-gt-label": "unsubscribe",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    openUnsubscribeModal();
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* CheckboxInput */.I0, {
                name: "consent",
                ...rest,
                children: "Yes, please keep me informed"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                className: "".concat(brand === "toyota" ? "rounded" : "", " absolute bg-base text-white top-1/2 left-1/2 right-auto bottom-auto mr-[-50%] -translate-y-1/2 -translate-x-1/2 max-w-[90%] md:max-w-screen-sm max-h-[50%] p-8 overflow-y-auto w-full focus:border-opacity/0 outline-none"),
                overlayClassName: "fixed top-0 left-0 right-0 bottom-0 z-20 bg-[#FFF]/75",
                id: "unsubscribeModal",
                isOpen: unsubscribeModalIsOpen,
                onRequestClose: closeUnsubscribeModal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "absolute top-3 right-4 text-3xl leading-none",
                        onClick: closeUnsubscribeModal,
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-3",
                        children: "To amend or withdraw your consent at any time:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "list-disc pl-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "mb-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "underline",
                                        href: unsubscribeLink,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "data-gt-name": "ctaevent",
                                        "data-gt-action": "consent-click-link",
                                        "data-gt-label": unsubscribeLink,
                                        children: "Unsubscribe"
                                    }),
                                    " ",
                                    "here"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "mb-1",
                                children: [
                                    "Log into your My",
                                    (0,dist_es2015/* upperCaseFirst */.l)(brand),
                                    " account and update your preferences"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "mb-1",
                                children: [
                                    "Click on the",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "underline",
                                        href: unsubscribeLink,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "data-gt-name": "ctaevent",
                                        "data-gt-action": "consent-click-link",
                                        "data-gt-label": unsubscribeLink,
                                        children: "unsubscribe"
                                    }),
                                    " ",
                                    "link in any future communication we send you"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_MarketingConsentSimple = (MarketingConsentSimple);

;// CONCATENATED MODULE: ./src/components/form/fields/MarketingTerms.tsx



const getPrivacyLink = (brand)=>{
    switch(brand){
        case "lexus":
            return "https://www.lexus.co.uk/customer-data/privacy-policy";
        case "kinto":
            return "https://www.kinto-uk.com/privacy-notice/";
        case "toyota":
        default:
            return "https://www.toyota.co.uk/footer/privacy-policy";
    }
};
const MarketingTerms = ()=>{
    const brand = (0,contexts/* useBrand */.DY)();
    const privacyLink = getPrivacyLink(brand);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "Be assured that ",
                (0,dist_es2015/* upperCaseFirst */.l)(brand),
                " will only share your personal information with companies that are an integral part of fulfilling the services we deliver. If you would like to find out more about how we process your data please visit our",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "underline",
                    href: privacyLink,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "data-gt-name": "ctaevent",
                    "data-gt-action": "terms-click-link",
                    "data-gt-label": privacyLink,
                    children: "privacy notice"
                }),
                " ",
                "for details."
            ]
        })
    });
};
/* harmony default export */ var fields_MarketingTerms = (MarketingTerms);

;// CONCATENATED MODULE: ./src/components/form/fields/MarketingUnsubscribe.tsx




const MarketingUnsubscribe = ()=>{
    const brand = useBrand();
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-8",
        children: [
            /*#__PURE__*/ _jsxs("p", {
                className: "mt-8 mb-4",
                children: [
                    "Please note this does not unsubscribe you from any",
                    " ",
                    upperCaseFirst(brand),
                    " dealership databases as they operate as independent legal entities. Please contact any ",
                    upperCaseFirst(brand),
                    " ",
                    brand === "lexus" ? "Centre" : "dealerships",
                    " you may have contacted previously to unsubscribe directly."
                ]
            }),
            /*#__PURE__*/ _jsx("h5", {
                className: "".concat(brand === "lexus" ? "text-lg" : "font-medium ", " mb-4"),
                children: "I'd like to unsubscribe from:"
            }),
            /*#__PURE__*/ _jsx(CheckboxInput, {
                name: "consent.user",
                children: "Communications - do not send me news, offers and events"
            })
        ]
    });
};
/* harmony default export */ var fields_MarketingUnsubscribe = ((/* unused pure expression or super */ null && (MarketingUnsubscribe)));

;// CONCATENATED MODULE: ./src/components/form/fields/MembershipNo.tsx


const MembershipNo = (param)=>{
    let { helper , optional , ...rest } = param;
    const name = "urn";
    const label = "Membership number";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name,
        label: label,
        helper: helper,
        optional: optional,
        ...rest
    });
};
/* harmony default export */ var fields_MembershipNo = (MembershipNo);

;// CONCATENATED MODULE: ./src/components/form/fields/Mileage.tsx


const Mileage = (param)=>{
    let { helper , ...rest } = param;
    const name = "mileage";
    const label = "Mileage";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* NumberInput */.Y2, {
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_Mileage = (Mileage);

;// CONCATENATED MODULE: ./src/assets/icons/external.svg
var external_path;
function external_extends() { external_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return external_extends.apply(this, arguments); }

var SvgExternal = function SvgExternal(props) {
  return /*#__PURE__*/react.createElement("svg", external_extends({
    fill: "none",
    width: 17,
    height: 17,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), external_path || (external_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.1a.4.4 0 0 0 0 .8h3.034l-7.317 7.317a.4.4 0 0 0 .565.566L16.1 4.466V7.5a.4.4 0 0 0 .8 0v-4a.4.4 0 0 0-.4-.4h-4Zm-8 2.8a.6.6 0 0 0-.6.6v9a.6.6 0 0 0 .6.6h9a.6.6 0 0 0 .6-.6V11a.4.4 0 0 1 .8 0v4.5a1.4 1.4 0 0 1-1.4 1.4h-9a1.4 1.4 0 0 1-1.4-1.4v-9a1.4 1.4 0 0 1 1.4-1.4H9a.4.4 0 1 1 0 .8H4.5Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var external = (SvgExternal);
;// CONCATENATED MODULE: ./src/assets/icons/lexus24hour.svg
var lexus24hour_path, lexus24hour_path2, _path3, _path4;
function lexus24hour_extends() { lexus24hour_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lexus24hour_extends.apply(this, arguments); }

var SvgLexus24Hour = function SvgLexus24Hour(props) {
  return /*#__PURE__*/react.createElement("svg", lexus24hour_extends({
    width: 93,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), lexus24hour_path || (lexus24hour_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.041 2C12.764 2 2 12.764 2 26.041 2 39.32 12.764 50.082 26.041 50.082a1 1 0 1 1 0 2C11.66 52.082 0 40.423 0 26.042 0 11.658 11.659 0 26.041 0s26.041 11.659 26.041 26.041a1 1 0 0 1-2 0C50.082 12.764 39.32 2 26.042 2Z",
    fill: "#282830"
  })), lexus24hour_path2 || (lexus24hour_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.812 19.017a1 1 0 0 1 .124 1.408l-5.143 6.129a1 1 0 0 1-1.408.123l-6.129-5.142a1 1 0 0 1 1.286-1.532l5.362 4.5 4.5-5.363a1 1 0 0 1 1.408-.123Z",
    fill: "#282830"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "m12.105 30.428 3.606-3.958c.585-.638 1.005-1.175 1.26-1.611.256-.447.384-.878.384-1.293 0-.457-.15-.824-.447-1.1-.287-.277-.697-.416-1.229-.416-.947 0-1.856.468-2.728 1.404l-.91-1.643a4.921 4.921 0 0 1 1.66-1.213 5.064 5.064 0 0 1 2.138-.447c.723 0 1.356.139 1.899.415.553.277.979.654 1.276 1.133.298.479.447 1.016.447 1.612 0 .713-.186 1.378-.558 1.994-.373.607-.942 1.325-1.708 2.155l-2.09 2.345h4.723v1.836h-7.723v-1.213ZM26.129 29.407h-4.9v-1.405l4.98-7.691h1.978v7.388h1.388v1.708h-1.388v2.234H26.13v-2.234Zm0-1.708v-4.5l-2.873 4.5h2.873ZM36.354 23.39c.937 0 1.644.267 2.123.799.49.531.734 1.303.734 2.313v5.139h-1.995v-4.373c0-.713-.138-1.24-.415-1.58-.266-.34-.675-.51-1.229-.51-.617 0-1.111.197-1.483.59-.362.383-.543.904-.543 1.564v4.309H31.55v-12h1.995v5.202a2.742 2.742 0 0 1 1.133-1.07c.49-.255 1.048-.382 1.675-.382Z",
    fill: "#282830"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M37.604 44.368V52h-1.2v-7.632h-1.788V43.24h4.848v1.128h-1.86ZM40.826 52v-8.76h4.896v1.128h-3.696v2.796h3.612v1.128h-3.612v2.58h3.924V52h-5.124Zm11.529-2.316c0 .392-.072.74-.216 1.044-.144.304-.34.564-.588.78-.24.208-.524.368-.852.48a3.32 3.32 0 0 1-1.032.156c-.448 0-.888-.064-1.32-.192-.424-.128-.84-.36-1.248-.696l.684-.924c.12.104.252.196.396.276a3.453 3.453 0 0 0 .948.336c.168.024.328.036.48.036.448 0 .808-.1 1.08-.3.28-.2.42-.508.42-.924a.996.996 0 0 0-.12-.492 1.43 1.43 0 0 0-.324-.408 2.159 2.159 0 0 0-.468-.348 8.97 8.97 0 0 0-.552-.3c-.312-.16-.62-.32-.924-.48a4.461 4.461 0 0 1-.804-.552 2.532 2.532 0 0 1-.576-.756c-.144-.296-.216-.652-.216-1.068 0-.32.056-.616.168-.888.12-.28.288-.52.504-.72.224-.208.492-.368.804-.48a3.111 3.111 0 0 1 1.056-.168c.44 0 .856.064 1.248.192.4.128.772.312 1.116.552l-.648.984c-.272-.2-.536-.34-.792-.42a2.9 2.9 0 0 0-.936-.132c-.344 0-.64.084-.888.252-.248.168-.372.42-.372.756 0 .24.048.444.144.612.104.168.24.32.408.456.176.128.38.252.612.372.232.112.484.236.756.372.248.12.492.256.732.408.248.144.468.32.66.528.2.2.36.436.48.708.12.264.18.58.18.948Zm3.706-5.316V52h-1.2v-7.632h-1.788V43.24h4.848v1.128h-1.86ZM68 47.596c0 .608-.108 1.18-.323 1.716a4 4 0 0 1-.948 1.404 4.51 4.51 0 0 1-1.5.936c-.593.232-1.264.348-2.016.348h-2.125v-8.76h2.232c.745 0 1.409.116 1.992.348a4.042 4.042 0 0 1 1.464.936c.4.392.704.852.912 1.38.209.528.313 1.092.313 1.692Zm-1.248.012c0-.448-.084-.868-.252-1.26a2.99 2.99 0 0 0-.695-1.044 3.196 3.196 0 0 0-1.08-.72 3.693 3.693 0 0 0-1.429-.264h-1.008v6.6h.78c.648 0 1.205-.096 1.669-.288a3.265 3.265 0 0 0 1.14-.756 2.83 2.83 0 0 0 .66-1.056c.144-.4.215-.804.215-1.212ZM74.183 52l-3.54-4.092V52h-1.2v-8.76h2.832c.408 0 .776.068 1.104.204.336.136.624.324.864.564.24.232.424.504.552.816.128.312.192.644.192.996s-.068.68-.204.984c-.136.304-.32.572-.552.804-.232.224-.5.4-.804.528a2.333 2.333 0 0 1-.936.192L75.719 52h-1.536Zm-.444-6.228c0-.152-.036-.308-.108-.468a1.225 1.225 0 0 0-.312-.456 1.602 1.602 0 0 0-.516-.336 1.763 1.763 0 0 0-.744-.144h-1.416v3.012h1.392c.544 0 .964-.148 1.26-.444.296-.304.444-.692.444-1.164ZM76.767 52v-8.76h1.2V52h-1.2Zm6.228 0h-.744l-3.084-8.76h1.164l2.22 6.324.024.096.024.096.024.108.024-.108a.395.395 0 0 0 .012-.096.469.469 0 0 1 .036-.096l2.232-6.324h1.14L82.995 52Zm4.272 0v-8.76h4.896v1.128h-3.696v2.796h3.612v1.128h-3.612v2.58h3.924V52h-5.124Z",
    fill: "#19191F"
  })));
};
/* harmony default export */ var lexus24hour = (SvgLexus24Hour);
;// CONCATENATED MODULE: ./src/assets/icons/toyota24hour.svg
var toyota24hour_path, toyota24hour_path2, toyota24hour_path3, toyota24hour_path4;
function toyota24hour_extends() { toyota24hour_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return toyota24hour_extends.apply(this, arguments); }

var SvgToyota24Hour = function SvgToyota24Hour(props) {
  return /*#__PURE__*/react.createElement("svg", toyota24hour_extends({
    width: 93,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), toyota24hour_path || (toyota24hour_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.041 2C12.764 2 2 12.764 2 26.041 2 39.32 12.764 50.082 26.041 50.082a1 1 0 1 1 0 2C11.66 52.082 0 40.423 0 26.042 0 11.658 11.659 0 26.041 0s26.041 11.659 26.041 26.041a1 1 0 0 1-2 0C50.082 12.764 39.32 2 26.042 2Z",
    fill: "#282830"
  })), toyota24hour_path2 || (toyota24hour_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.812 19.017a1 1 0 0 1 .124 1.408l-5.143 6.129a1 1 0 0 1-1.408.123l-6.129-5.142a1 1 0 0 1 1.286-1.532l5.362 4.5 4.5-5.363a1 1 0 0 1 1.408-.123Z",
    fill: "#282830"
  })), toyota24hour_path3 || (toyota24hour_path3 = /*#__PURE__*/react.createElement("path", {
    d: "m12.105 30.428 3.606-3.958c.585-.638 1.005-1.175 1.26-1.611.256-.447.384-.878.384-1.293 0-.457-.15-.824-.447-1.1-.287-.277-.697-.416-1.229-.416-.947 0-1.856.468-2.728 1.404l-.91-1.643a4.921 4.921 0 0 1 1.66-1.213 5.064 5.064 0 0 1 2.138-.447c.723 0 1.356.139 1.899.415.553.277.979.654 1.276 1.133.298.479.447 1.016.447 1.612 0 .713-.186 1.378-.558 1.994-.373.607-.942 1.325-1.708 2.155l-2.09 2.345h4.723v1.836h-7.723v-1.213ZM26.129 29.407h-4.9v-1.405l4.98-7.691h1.978v7.388h1.388v1.708h-1.388v2.234H26.13v-2.234Zm0-1.708v-4.5l-2.873 4.5h2.873ZM36.354 23.39c.937 0 1.644.267 2.123.799.49.531.734 1.303.734 2.313v5.139h-1.995v-4.373c0-.713-.138-1.24-.415-1.58-.266-.34-.675-.51-1.229-.51-.617 0-1.111.197-1.483.59-.362.383-.543.904-.543 1.564v4.309H31.55v-12h1.995v5.202a2.742 2.742 0 0 1 1.133-1.07c.49-.255 1.048-.382 1.675-.382Z",
    fill: "#282830"
  })), toyota24hour_path4 || (toyota24hour_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M45.055 42.48v1.416h-2.232V51h-1.632v-7.104h-2.256V42.48h6.12Zm5.569 5.58v.228h-4.452c.096 1.02.792 1.572 1.848 1.572.792 0 1.488-.276 1.956-.636l.372 1.176c-.552.408-1.404.72-2.484.72-1.932 0-3.216-1.332-3.216-3.144 0-1.872 1.32-3.168 3.06-3.168 1.752 0 2.916 1.296 2.916 3.252Zm-4.404-.792h2.88c-.108-.768-.66-1.296-1.392-1.296-.744 0-1.308.516-1.488 1.296Zm7.647 3.852c-.84 0-1.752-.24-2.28-.624l.36-1.2a3.392 3.392 0 0 0 1.992.696c.552 0 .912-.204.912-.624 0-.444-.48-.588-1.308-.852-.96-.324-1.788-.672-1.788-1.788 0-1.212.948-1.932 2.352-1.932.756 0 1.488.228 1.98.516l-.276 1.152c-.444-.276-1.116-.54-1.728-.54-.492 0-.864.192-.864.576 0 .432.504.588 1.128.756 1.236.312 1.968.768 1.968 1.848 0 1.212-.888 2.016-2.448 2.016Zm6.018 0c-1.164 0-1.86-.648-1.86-1.992v-2.94h-.936v-1.26h.936v-1.704l1.5-.192v1.896h1.644v1.26h-1.644v2.736c0 .576.264.84.72.84.396 0 .792-.18 1.044-.324l.24 1.212c-.372.252-.96.468-1.644.468Zm9.84-9.144h1.5v9.036h-1.5v-.96c-.42.732-1.14 1.068-2.028 1.068-1.692 0-2.928-1.32-2.928-3.156s1.236-3.156 2.928-3.156c.888 0 1.632.36 2.028 1.02v-3.852Zm-1.716 7.776c1.032 0 1.764-.756 1.764-1.788 0-1.044-.732-1.788-1.752-1.788-1.008 0-1.704.72-1.704 1.788s.684 1.788 1.692 1.788Zm7.913-4.956c.288 0 .552.06.78.144l-.24 1.44c-.18-.06-.42-.12-.636-.12-.948 0-1.392.66-1.392 1.872V51h-1.488v-6.072h1.488v.972c.348-.804.888-1.104 1.488-1.104Zm2.456-.888a.91.91 0 0 1-.924-.924.9.9 0 0 1 .924-.912c.516 0 .912.396.912.912a.907.907 0 0 1-.912.924ZM77.61 51v-6.072h1.5V51h-1.5Zm7.098-6.072h1.536L83.892 51h-1.5l-2.376-6.072h1.644l1.524 4.296 1.524-4.296Zm7.88 3.132v.228h-4.451c.096 1.02.792 1.572 1.848 1.572.792 0 1.488-.276 1.956-.636l.372 1.176c-.552.408-1.404.72-2.484.72-1.932 0-3.216-1.332-3.216-3.144 0-1.872 1.32-3.168 3.06-3.168 1.752 0 2.916 1.296 2.916 3.252Zm-4.403-.792h2.88c-.108-.768-.66-1.296-1.392-1.296-.744 0-1.308.516-1.488 1.296Z",
    fill: "#000"
  })));
};
/* harmony default export */ var toyota24hour = (SvgToyota24Hour);
;// CONCATENATED MODULE: ./src/components/form/fields/ModelGrid/card.tsx
/* eslint-disable no-nested-ternary */ /* eslint-disable @next/next/no-img-element */ 








const card_Card = (param)=>{
    let { model , setModel , isChecked , checkedModel , type  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const brand = (0,contexts/* useBrand */.DY)();
    const modelString = (0,contexts/* useModel */.tT)();
    const fuel = (model === null || model === void 0 ? void 0 : (ref = model.filters) === null || ref === void 0 ? void 0 : ref.fuel) || undefined;
    const [isTestDrive, setIsTestDrive] = (0,react.useState)(false);
    const img = (0,helpers/* getModelImage */.gU)(brand, model === null || model === void 0 ? void 0 : (ref1 = model.image) === null || ref1 === void 0 ? void 0 : ref1.id, model === null || model === void 0 ? void 0 : (ref2 = model.image) === null || ref2 === void 0 ? void 0 : ref2.grade, model === null || model === void 0 ? void 0 : (ref3 = model.image) === null || ref3 === void 0 ? void 0 : ref3.color, null, model === null || model === void 0 ? void 0 : (ref4 = model.image) === null || ref4 === void 0 ? void 0 : ref4.fallback);
    const imgWebp = (0,helpers/* getModelImage */.gU)(brand, model === null || model === void 0 ? void 0 : (ref5 = model.image) === null || ref5 === void 0 ? void 0 : ref5.id, model === null || model === void 0 ? void 0 : (ref6 = model.image) === null || ref6 === void 0 ? void 0 : ref6.grade, model === null || model === void 0 ? void 0 : (ref7 = model.image) === null || ref7 === void 0 ? void 0 : ref7.color, "webp", model === null || model === void 0 ? void 0 : (ref8 = model.image) === null || ref8 === void 0 ? void 0 : ref8.fallback);
    const Label = ()=>{
        if (!fuel) {
            return null;
        }
        for(let i = 0; i < fuel.length; i += 1){
            if (brand === "toyota" && (fuel[i] === undefined || fuel[i].toLowerCase() === "petrol" || fuel[i].toLowerCase() === "diesel")) {
                return null;
            }
            if (fuel[i] === undefined || fuel[i].toLowerCase() === "diesel") {
                return null;
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "".concat(brand === "lexus" ? "" : "text-blue font-medium", " uppercase "),
            children: "".concat(brand === "toyota" ? "".concat(fuel[0]) : "".concat(fuel[0], " ").concat(fuel[1] ? "& ".concat(fuel[1]) : ""))
        });
    };
    (0,react.useEffect)(()=>{
        if (window.location.pathname === "/test-drive") {
            setIsTestDrive(true);
        }
        if (window.location.pathname === "/brochure") {
            setIsTestDrive(false);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (isChecked) {
            (0,helpers_tracking/* updateDatalayer */.WX)("model", {
                name: model.name,
                id: model.image.id
            });
        } else {
            (0,helpers_tracking/* updateDatalayer */.WX)("model", false);
        }
    }, [
        isChecked
    ]);
    (0,react.useEffect)(()=>{
        if (modelString && model.rangecode.toLowerCase() === modelString.toLowerCase() || model.name.toLowerCase() === modelString.toLowerCase() || model.image.id.toLowerCase() === modelString.toLowerCase()) {
            if (type === "brochure") {
                checkedModel(model.rangecode);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        modelString,
        model
    ]);
    const holdClasses = model.hold && type !== "brochure" ? "opacity-50 cursor-default" : "";
    const checkedOpacity = "opacity-0";
    const checkedColour = isChecked && brand === "lexus" ? "bg-primary" : "";
    const checkedClasses = isChecked ? checkedOpacity : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        htmlFor: "input-".concat(model.rangecode),
        className: "".concat((model === null || model === void 0 ? void 0 : (ref9 = model.ui) === null || ref9 === void 0 ? void 0 : ref9.hidden) ? " hidden " : "", " ").concat(checkedColour, " relative group min-h-[240px] h-full w-full flex flex-col justify-between cursor-pointer px-5 py-4 pb-3 border border-base"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between flex-row-reverse",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "input-".concat(model.rangecode),
                        type: "checkbox",
                        className: "  rounded border-base text-base-text w-5 h-5 ml-6 mt-1 focus:border-blue focus:ring focus:ring-offset-0 focus:ring-blue group-checked:border-base ".concat(type !== "brochure" ? " invisible " : ""),
                        checked: isChecked,
                        onChange: (e)=>{
                            checkedModel(e.target.checked && model.rangecode);
                            if (!model.hold && type !== "brochure") {
                                setModel(model);
                                (0,helpers_tracking/* updateDatalayer */.WX)("model", {
                                    name: model.name,
                                    id: model.image.id
                                });
                            }
                        },
                        "data-gt-componentgroup": helpers/* tracking.componentGroup */.UO.componentGroup(),
                        "data-gt-componentname": helpers/* tracking.componentName */.UO.componentName(),
                        "data-gt-name": "componentevent",
                        "data-gt-action": "model-grid-click-model",
                        "data-gt-label": model.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(model.hold && type !== "brochure" ? "opacity-50" : "", " ").concat(isChecked ? "opacity-50" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-lg font-medium",
                                children: model.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {})
                        ]
                    })
                ]
            }),
            isTestDrive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: brand === "lexus" ? model.all_day_test_drive === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-3 right-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lexus24hour, {})
                }) : null : model.all_day_test_drive === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-3 right-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(toyota24hour, {})
                }) : null
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        type: "image/webp",
                        srcSet: imgWebp
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: img,
                        loading: "lazy",
                        alt: model.name,
                        className: "mt-5 mb-3 ".concat(holdClasses, " ").concat(checkedClasses)
                    })
                ]
            }),
            isChecked && type === "brochure" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 h-full w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " ".concat(brand === "toyota" ? "h-full flex md:mt-[75px] mt-[30px] md:justify-start justify-center flex-1 flex-col md:flex-col items-center px-5 md:pb-0 space-y-4 md:space-y-0 md:space-x-4" : "h-full flex md:mt-[75px] mt-[30px] md:justify-start justify-center flex-1 flex-col md:flex-col items-center px-5 md:pb-0 space-y-4 md:space-y-0 md:space-x-4"),
                    children: [
                        (model === null || model === void 0 ? void 0 : model.brochure_hold) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "test-base text-lg text-center py-4 w-2/3",
                            children: "This brochure is being updated"
                        }),
                        !(model === null || model === void 0 ? void 0 : model.isEmailHidden) && !model.brochure_hold && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* CTA */.MV, {
                            className: "w-full justify-center !mx-4 !my-2",
                            onClick: ()=>setModel(model),
                            "data-gt-componentgroup": helpers/* tracking.componentGroup */.UO.componentGroup(),
                            "data-gt-componentname": helpers/* tracking.componentName */.UO.componentName(),
                            "data-gt-name": "componentevent",
                            "data-gt-action": "model-grid-click-cta",
                            "data-gt-label": "Email",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mr-2 pointer-events-none",
                                    children: "Email"
                                }),
                                brand !== "lexus" && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "14",
                                    height: "9",
                                    viewBox: "0 0 14 9",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "mt-[2px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M0.599609 0.9C0.599609 0.402944 1.00255 0 1.49961 0H12.4996C12.9967 0 13.3996 0.402943 13.3996 0.9V7.9C13.3996 8.39706 12.9967 8.8 12.4996 8.8H1.49961C1.00255 8.8 0.599609 8.39706 0.599609 7.9V0.9ZM1.39961 7.43431V1.40007L4.85687 3.97705L1.39961 7.43431ZM5.78245 3.61716C5.81548 3.65018 5.84152 3.68754 5.86058 3.72741L6.89844 4.50101L11.8637 0.8H1.93319L5.56202 3.50487C5.64272 3.51755 5.72027 3.55498 5.78245 3.61716ZM12.5996 1.24924L9.05638 3.89031L12.5996 7.43353V1.24924ZM8.40817 4.37347L7.13786 5.32034C7.06589 5.37399 6.98179 5.3998 6.89844 5.39966C6.81509 5.3998 6.73099 5.37399 6.65902 5.32034L5.50508 4.46022L1.96529 8H12.0347L8.40817 4.37347Z",
                                        fill: "currentColor"
                                    })
                                })
                            ]
                        }),
                        !model.brochure_hold && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: model.url,
                            className: "".concat(brand === "lexus" ? "font-semibold text-secondary text-sm" : "", "\n                ").concat((model === null || model === void 0 ? void 0 : model.isEmailHidden) || model.brochure_hold ? "md:!mt-14" : "", "\n                w-full text-center underline !mx-4 !my-2 "),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "data-gt-name": "downloadevent",
                            "data-gt-action": "download",
                            "data-gt-label": model.url,
                            onClick: ()=>(0,helpers_tracking/* formEvent */.Be)({
                                    name: "brochure-downloads",
                                    step: "download",
                                    conversion: 1,
                                    variant: ""
                                }),
                            children: [
                                "Download",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(external, {
                                    className: "ml-[5px] inline"
                                })
                            ]
                        }),
                        model.pricelist_url && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "".concat(brand === "lexus" ? "font-semibold text-secondary text-sm" : "", " w-full text-center  underline !mx-4 !my-2 "),
                            href: model.pricelist_url,
                            "data-gt-name": "componentevent",
                            target: "_blank",
                            "data-gt-componentgroup": helpers/* tracking.componentGroup */.UO.componentGroup(),
                            "data-gt-componentname": helpers/* tracking.componentName */.UO.componentName(),
                            "data-gt-action": "model-grid-click-cta",
                            "data-gt-label": "price list view",
                            rel: "noreferrer",
                            children: [
                                "View Price List",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(external, {
                                    className: "ml-[5px] inline"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ModelGrid_card = (card_Card);

;// CONCATENATED MODULE: ./src/components/form/fields/ModelGrid/counter.tsx

const Counter = (param)=>{
    let { total  } = param;
    const vehicle = total === 1 ? "vehicle" : "vehicles";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "flex basis-1/2 md:basis-1/3 order-2 md:order-1 text-lg",
        children: [
            total,
            " ",
            vehicle,
            " available"
        ]
    });
};
/* harmony default export */ var counter = (Counter);

;// CONCATENATED MODULE: ./src/components/form/fields/ModelGrid/filter.tsx
/* eslint-disable */ 




const Filter = (param)=>{
    let { models , filtredModelsCallBack , showFilter  } = param;
    const filterQueryString = (0,contexts/* useFilter */.L0)();
    const modelString = (0,contexts/* useModel */.tT)();
    const brand = (0,contexts/* useBrand */.DY)();
    const CMS_FEATURED_LIST = models.map((model)=>model.filters.featured ? model.filters.featured : []);
    (0,react.useEffect)(()=>{
        modelsUpdate(filtredModels, flatFilterValues);
    }, [
        modelString
    ]);
    const [isFilterOpen, openFilter] = (0,react.useState)(false);
    const [flatFilterValues, setFlatFilterValues] = (0,react.useState)([]);
    const [filterView, setFiltersView] = (0,react.useState)({});
    const [filtredModels, setFiltredModels] = (0,react.useState)(models);
    (0,react.useEffect)(()=>{
        let { Categories , Fuel , Featured  } = filterQueryString;
        Categories = Categories.split(",");
        Fuel = Fuel.split(",");
        Featured = Featured.split(",");
        let availableFilters = [
            ...constants/* CATEGORIES_ORDER */.kf,
            ...constants/* FUEL_ORDER */._H
        ];
        CMS_FEATURED_LIST.forEach((subarray)=>{
            const nonNullValues = subarray.filter((element)=>element !== null);
            if (nonNullValues.length > 0) {
                availableFilters.push(...nonNullValues.map((value)=>value.toString()));
            }
        });
        let preSelectedFilters = [
            ...Categories,
            ...Fuel,
            ...Featured
        ];
        preSelectedFilters = availableFilters.filter((query)=>{
            if (typeof query === "string" && query.trim() !== "") {
                return preSelectedFilters.filter((pre)=>query.toLowerCase().includes(pre.toLowerCase()) && pre).length > 0;
            } else {
                return false;
            }
        });
        if (preSelectedFilters.length > 0) {
            setFlatFilterValues(preSelectedFilters);
        }
    }, [
        filterQueryString
    ]);
    (0,react.useEffect)(()=>{
        filterViewUpdate(filtredModels, flatFilterValues);
        filtredModelsCallBack(filtredModels);
    }, [
        filtredModels
    ]);
    (0,react.useEffect)(()=>{
        modelsUpdate(filtredModels, flatFilterValues);
    }, [
        flatFilterValues
    ]);
    const flatFilterUpdate = (select)=>{
        let newFlatFilterValues = [
            ...flatFilterValues
        ];
        if (newFlatFilterValues.includes(select)) {
            const index = newFlatFilterValues.indexOf(select);
            newFlatFilterValues.splice(index, 1);
        } else {
            newFlatFilterValues = [
                ...newFlatFilterValues,
                select
            ];
        }
        setFlatFilterValues(newFlatFilterValues);
    };
    const filterViewUpdate = function() {
        let models = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], select = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        let fuel = getValuesAndCount("fuel", models);
        let categories = getValuesAndCount("categories", models);
        categories = Object.entries(categories.value).map((item)=>{
            const isIncluded = select.includes(item[0]);
            return {
                filter: item[0],
                count: item[1],
                isSelected: !select.length ? false : isIncluded ? !item[2] : item[2]
            };
        });
        fuel = Object.entries(fuel.value).map((item)=>{
            const isIncluded = select.includes(item[0]);
            return {
                filter: item[0],
                count: item[1],
                isSelected: !select.length ? false : isIncluded ? !item[2] : item[2]
            };
        });
        const totalCount = models.filter((model)=>{
            var ref;
            return !(model === null || model === void 0 ? void 0 : (ref = model.ui) === null || ref === void 0 ? void 0 : ref.hidden);
        }).length;
        setFiltersView({
            filters: [
                {
                    key: "categories",
                    value: categories
                },
                {
                    key: "fuel",
                    value: fuel
                }
            ],
            totalCount
        });
    };
    const modelsUpdate = function(models) {
        let select = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        const filtred = models.map((model)=>{
            var ref;
            const flat = [
                ...model.filters.categories || [],
                ...model.filters.fuel || [],
                ...model.filters.featured || []
            ];
            const contains = flat.some((element)=>{
                return select.includes(element);
            });
            return {
                ...model,
                ui: {
                    hidden: modelString === model.name || model.rangecode === modelString ? false : !select.length ? false : !contains,
                    isSelected: model === null || model === void 0 ? void 0 : (ref = model.ui) === null || ref === void 0 ? void 0 : ref.isSelected
                }
            };
        });
        setFiltredModels(filtred);
    };
    const getValuesAndCount = (key, models)=>{
        let lock = [];
        if (key.toLowerCase() === "categories" && constants/* CATEGORIES_ORDER.includes */.kf.includes(flatFilterValues[0])) lock = constants/* CATEGORIES_ORDER */.kf;
        if (key.toLowerCase() === "fuel" && constants/* FUEL_ORDER.includes */._H.includes(flatFilterValues[0])) lock = constants/* FUEL_ORDER */._H;
        // locked count
        let locked = models.filter((model)=>model.filters);
        locked = locked.map((e)=>e.filters[key]);
        locked = locked.map((e)=>Object.values(e));
        locked = locked.flat(2);
        // exclude non locked group
        locked = locked.filter((element)=>{
            return lock.includes(element);
        });
        locked = locked.reduce((values, value)=>({
                ...values,
                [value]: (values[value] || 0) + 1
            }), []);
        // only filtred elements count
        let unique = models.filter((model)=>{
            var ref;
            return !(model === null || model === void 0 ? void 0 : (ref = model.ui) === null || ref === void 0 ? void 0 : ref.hidden);
        });
        unique = unique.map((e)=>e.filters[key]);
        unique = unique.map((e)=>Object.values(e));
        unique = unique.flat(2);
        unique = unique.reduce((values, value)=>({
                ...values,
                [value]: (values[value] || 0) + 1
            }), []);
        // full elemnts list with 0 count
        let filters = models.map((e)=>e.filters[key]);
        let initial = filters.map((e)=>Object.values(e));
        initial = initial.flat(2);
        initial = [
            ...new Set(initial)
        ];
        // convert arry to object
        initial = initial.reduce((acc, curr)=>(acc[curr] = 0, acc), {});
        unique = {
            ...initial,
            ...unique,
            ...locked
        };
        return {
            key,
            value: unique
        };
    };
    const buildFilterLabel = ()=>{
        const len = flatFilterValues.length;
        const labels = "".concat(flatFilterValues[0]).concat(flatFilterValues[1] ? ", " + flatFilterValues[1] : "").concat(len > 2 ? ", +" + (len - 2) : " ", " ");
        return labels;
    };
    const FilterContainer = ()=>{
        return isFilterOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "opacity-30 bg-base w-[100%] h-[100%] fixed left-0 z-10 top-0 ",
                    onClick: ()=>{
                        openFilter(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fixed lg:absolute text-base-text left-[0] right-[0] overflow-y-scroll px-[24px] py-[16px]  lg:max-w-[375px] w-[100%] m-auto lg:h-auto h-[100%]   ".concat(brand === "lexus" ? "" : " lg:rounded-[10px] ", "  bg-white text-center  top-0 lg:top-[65px] lg:z-[10] z-[11]   "),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " flex justify-between border-b-2 border-primary pb-[18px] ",
                            children: [
                                !flatFilterValues.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: " ".concat(brand === "lexus" ? "   w-[100%]  uppercase   py-[15px] justify-center " : " leading-[40px]  justify-between ", "  flex "),
                                    onClick: ()=>{
                                        openFilter(false);
                                    },
                                    "data-gt-componentgroup": helpers/* tracking.componentGroup */.UO.componentGroup(),
                                    "data-gt-componentname": helpers/* tracking.componentName */.UO.componentName(),
                                    "data-gt-name": "componentevent",
                                    "data-gt-action": "filter-click-cta",
                                    "data-gt-label": "close filter",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 1.5,
                                            stroke: "currentColor",
                                            className: "w-6 h-6 m-auto ml-0 mr-[5px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: " ".concat(brand === "lexus" ? "font-medium  " : "", " "),
                                            children: "Back"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: "#",
                                    className: "".concat(brand === "lexus" ? " w-[100%] " : "", " flex    justify-center items-center leading-[40px]"),
                                    onClick: ()=>{
                                        setFlatFilterValues([]);
                                    },
                                    "data-gt-componentgroup": helpers/* tracking.componentGroup */.UO.componentGroup(),
                                    "data-gt-componentname": helpers/* tracking.componentName */.UO.componentName(),
                                    "data-gt-name": "componentevent",
                                    "data-gt-action": "filter-click-cta",
                                    "data-gt-label": "clear filter",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 1.5,
                                            stroke: "currentColor",
                                            className: "w-6 h-6 m-auto ml-0 mr-[5px] font-medium",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M6 18L18 6M6 6l12 12"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: " ".concat(brand === "lexus" ? "uppercase text-ellipsis overflow-hidden whitespace-nowrap " : "", " font-medium"),
                                            children: [
                                                "Clear",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: " ".concat(brand === "lexus" ? "uppercase " : "", " font-medium"),
                                                    children: [
                                                        " ",
                                                        flatFilterValues.length
                                                    ]
                                                }),
                                                " ",
                                                "filter",
                                                flatFilterValues.length > 1 ? "s" : ""
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "".concat(brand === "lexus" ? "bg-blue w-[100%] w-[100%] font-medium  py-[15px] ml-[4px] uppercase" : "leading-[40px] bg-base hover:bg-base-hover active:bg-base-hover focus:bg-base-hover", " text-white px-[24px]"),
                                    onClick: ()=>{
                                        openFilter(false);
                                    },
                                    "data-gt-componentgroup": helpers/* tracking.componentGroup */.UO.componentGroup(),
                                    "data-gt-componentname": helpers/* tracking.componentName */.UO.componentName(),
                                    "data-gt-name": "componentevent",
                                    "data-gt-action": "filter-click-cta",
                                    "data-gt-label": "see results",
                                    children: [
                                        "See ",
                                        filterView.totalCount,
                                        " ",
                                        filterView.totalCount === 1 ? "result" : "results"
                                    ]
                                })
                            ]
                        }),
                        filterView.filters.map((category, i)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " ".concat(brand === "lexus" ? " uppercase py-[15px] font-medium" : " leading-[40px] text-[#a8aaac] capitalize", "  text-left  pt-[20px]"),
                                        children: (category === null || category === void 0 ? void 0 : category.key.toLowerCase()) === "categories" ? "Category" : category === null || category === void 0 ? void 0 : category.key
                                    }),
                                    category.value.map((filters, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: " ".concat(brand === "lexus" ? "uppercase py-[15px] " : " ", "  inline-flex items-center cursor-pointer w-[100%] leading-[45px]"),
                                            htmlFor: filters.filter,
                                            children: [
                                                filters.isSelcted,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    disabled: filters.count === 0,
                                                    value: filters.filter,
                                                    id: filters.filter,
                                                    className: "rounded border-base text-base-text focus:border-blue focus:ring focus:ring-offset-0 focus:ring-blue category-checked:border-base",
                                                    type: "checkbox",
                                                    checked: filters.isSelected,
                                                    onChange: (e)=>{
                                                        flatFilterUpdate(filters.filter);
                                                    },
                                                    "data-gt-componentgroup": helpers/* tracking.componentGroup */.UO.componentGroup(),
                                                    "data-gt-componentname": helpers/* tracking.componentName */.UO.componentName(),
                                                    "data-gt-name": "componentevent",
                                                    "data-gt-action": "checkbox-input-interaction",
                                                    "data-gt-label": filters.filter
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "ml-4 ",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: " ".concat(filters.count === 0 ? " text-[#a8a9ac]" : "", " ").concat(brand === "lexus" ? "leading-[50px] " : " "),
                                                            children: filters.filter
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: " pl-[14px]",
                                                            children: filters.count
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, i))
                                ]
                            }, i);
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(showFilter === false ? "hidden" : (filterQueryString === null || filterQueryString === void 0 ? void 0 : filterQueryString.Featured) === "" ? "flex justify-end md:justify-center basis-1/2 md:basis-1/3 order-3 md:order-2 text-sm md:relative" : "hidden"),
        "data-gt-name": "componentevent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "".concat(brand === "lexus" ? "leading-[20px]" : "", " ").concat(isFilterOpen ? "z-[11]" : "z-[9]", "  flex justify-center items-center px-[16px]  ").concat(brand === "lexus" ? "border-base" : "border-primary", " border-2 rounded-full ").concat(!flatFilterValues.length ? "bg-white p-[9px]" : "p-[4.52px]  bg-base text-white border-black", "  "),
                onClick: ()=>{
                    openFilter((state)=>!state);
                },
                "data-gt-componentgroup": helpers/* tracking.componentGroup */.UO.componentGroup(),
                "data-gt-componentname": helpers/* tracking.componentName */.UO.componentName(),
                "data-gt-action": "filter-open-filter",
                "data-gt-label": "Type of vehicle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pointer-events-none",
                        children: !flatFilterValues.length ? "Type of vehicle" : buildFilterLabel()
                    }),
                    !flatFilterValues.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: 1.5,
                        stroke: "currentColor",
                        className: "w-[17px] h-[17px] ml-3 pointer-events-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M12 4.5v15m7.5-7.5h-15"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        className: "m-auto m-[5px] p[5px]",
                        onClick: (e)=>{
                            e.stopPropagation();
                            openFilter(false);
                            setFlatFilterValues([]);
                        },
                        "data-gt-action": "click-cta",
                        "data-gt-label": "set-filter",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            strokeWidth: 1.5,
                            stroke: "currentColor",
                            className: "w-5 h-5 pointer-events-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                d: "M6 18L18 6M6 6l12 12"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterContainer, {})
        ]
    });
};
/* harmony default export */ var filter = (Filter);

;// CONCATENATED MODULE: ./src/components/form/fields/ModelGrid/index.tsx







const ModelGrid = (param)=>{
    let { models , showFilter , setModel , pricelist , type =""  } = param;
    const [filtredModels, setFiltredModels] = (0,react.useState)(models);
    const [selectedModel, selectModel] = (0,react.useState)(false);
    const [isClient, setIsClient] = (0,react.useState)(false);
    const total = filtredModels.filter((model)=>{
        var ref;
        return !(model === null || model === void 0 ? void 0 : (ref = model.ui) === null || ref === void 0 ? void 0 : ref.hidden);
    }).length;
    const brand = (0,contexts/* useBrand */.DY)();
    (0,react.useEffect)(()=>{
        setIsClient(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            pricelist && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex basis-full mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CTA */.MV, {
                    href: pricelist,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "data-gt-name": "ctaevent",
                    "data-gt-action": "click-cta",
                    "data-gt-label": "View Pricelists",
                    children: brand === "lexus" ? "Download Pricelist" : "View Pricelists"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row flex-wrap pb-4 justify-between items-center md:justify-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(counter, {
                        total: total
                    }),
                    isClient && /*#__PURE__*/ (0,jsx_runtime.jsx)(filter, {
                        showFilter: showFilter,
                        models: models,
                        filtredModelsCallBack: (vehicles)=>{
                            setFiltredModels(vehicles);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 gap-4 py-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4",
                children: isClient && filtredModels.map((model, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ModelGrid_card, {
                        type: type,
                        model: model,
                        checkedModel: (vehicle)=>selectModel(vehicle),
                        isChecked: selectedModel && selectedModel === model.rangecode,
                        setModel: setModel
                    }, model.rangecode + i))
            })
        ]
    });
};
/* harmony default export */ var fields_ModelGrid = (ModelGrid);

;// CONCATENATED MODULE: ./src/components/form/fields/Models.tsx




const Models = (param)=>{
    let { helper , optional , models , service , manufacturer , ...rest } = param;
    const brand = (0,contexts_useBrand/* useBrand */.D)();
    const name = "model";
    const label = "Model";
    const options = models.map((model)=>{
        return {
            label: model.name,
            value: model.d4t4.id
        };
    });
    const handleChange = (e)=>{
        const selectedModel = models.filter((model)=>{
            return e.target.value === model.d4t4.id;
        });
        if (selectedModel.length > 0) {
            (0,helpers_tracking/* updateDatalayer */.WX)("model", {
                name: selectedModel[0].name,
                id: selectedModel[0].image.id,
                brand,
                service,
                manufacturer
            });
        } else {
            (0,helpers_tracking/* updateDatalayer */.WX)("model", false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* SelectInput */.lq, {
        name: name,
        label: label,
        options: options,
        helper: helper,
        optional: optional,
        extraOnChange: handleChange,
        ...rest
    });
};
/* harmony default export */ var fields_Models = (Models);

// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 51 modules
var react_select_esm = __webpack_require__(57520);
;// CONCATENATED MODULE: ./src/components/form/baseInputs/react-select.tsx






const ReactSelect = (param)=>{
    let { name , label , options , helper , isChild , optional , isMulti =false , extraOnChange , ...rest } = param;
    const { getFieldState , formState , control  } = (0,index_esm/* useFormContext */.Gc)();
    const { error , isTouched , isDirty  } = getFieldState(name, formState);
    const [placeholder, setPlaceholder] = (0,react.useState)("Please select");
    const styles = {
        control: (baseStyles)=>({
                ...baseStyles,
                borderColor: "#6b728",
                borderRadius: "0",
                minHeight: "48px"
            }),
        input: (baseStyles)=>({
                ...baseStyles,
                "input:focus": {
                    boxShadow: "none"
                }
            })
    };
    // className={`block w-full p-[0.7rem] pr-16 ${
    //   error && 'border-red'
    // } ${!error && isTouched && isDirty && 'border-green'}`}
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: isChild ? "-mt-6 items-start" : "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2",
        "data-gt-name": "componentevent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:col-span-2 lg:col-span-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "block",
                        htmlFor: name,
                        children: [
                            label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-base mb-1",
                                children: [
                                    label,
                                    " ",
                                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs lowercase whitespace-nowrap",
                                        children: "(optional)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                        name: name,
                                        control: control,
                                        render: (param)=>/*#__PURE__*/ {
                                            let { field  } = param;
                                            return (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                                                // unstyled
                                                blurInputOnSelect: true,
                                                isMulti: isMulti,
                                                isClearable: false,
                                                id: name,
                                                placeholder: placeholder,
                                                styles: styles,
                                                options: options,
                                                "aria-invalid": error ? "true" : "false",
                                                "data-gt-action": "select-input-interaction",
                                                "data-gt-label": name,
                                                components: {
                                                    IndicatorSeparator: ()=>null
                                                },
                                                onChange: (e)=>{
                                                    if (Array.isArray(e)) {
                                                        const optionsArray = e.map((option)=>option.value).join(", ");
                                                        field.onChange(optionsArray);
                                                    } else if (e && e.value && e.label) {
                                                        field.onChange(e.value);
                                                        setPlaceholder(e.value);
                                                    }
                                                    if (extraOnChange) extraOnChange(e);
                                                },
                                                onBlur: (e)=>{
                                                    field.onBlur(e);
                                                },
                                                value: field.value ? options.find((option)=>option.value === field.value) : null,
                                                ...rest
                                            });
                                        }
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning/* default */.Z, {
                                        className: "absolute inset-y-0 right-10 top-4 h-4 pointer-events-none text-red"
                                    }),
                                    !error && isTouched && isDirty && /*#__PURE__*/ (0,jsx_runtime.jsx)(tick/* default */.Z, {
                                        className: "absolute inset-y-0 right-10 top-4 h-4 pointer-events-none text-green"
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            }),
            !isChild && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 md:mt-7 flex items-center md:min-h-[48px]",
                children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-tiny leading-5",
                    children: helper
                })
            })
        ]
    });
};
/* harmony default export */ var react_select = (ReactSelect);

;// CONCATENATED MODULE: ./src/components/form/fields/MultiSelectModels.tsx




const MultiSelectModels = (param)=>{
    let { models , ...rest } = param;
    const name = "model";
    const label = "Models of interest";
    const brand = (0,contexts_useBrand/* useBrand */.D)();
    const options = models.map((model)=>{
        return {
            label: model.name,
            value: model.d4t4.id
        };
    });
    const handleChange = (e)=>{
        const model = e[0] || [];
        if (model.length > 0) {
            (0,helpers_tracking/* updateDatalayer */.WX)("model", {
                name: model === null || model === void 0 ? void 0 : model.name,
                id: model === null || model === void 0 ? void 0 : model.value,
                brand
            });
        } else {
            (0,helpers_tracking/* updateDatalayer */.WX)("model", false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select, {
        isMulti: true,
        name: name,
        label: label,
        options: options,
        extraOnChange: handleChange,
        ...rest
    });
};
/* harmony default export */ var fields_MultiSelectModels = (MultiSelectModels);

;// CONCATENATED MODULE: ./src/components/form/fields/Occupation.tsx


const Occupation = (param)=>{
    let { options , inputName , ...rest } = param;
    const name = inputName || "occupation";
    const label = "Occupation";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select, {
        name: name,
        label: label,
        options: options,
        ...rest
    });
};
/* harmony default export */ var fields_Occupation = (Occupation);

;// CONCATENATED MODULE: ./src/components/form/fields/PartEx.tsx



const PartEx = (param)=>{
    let { optional , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "font-medium my-5",
                children: [
                    "Do you have a vehicle to part exchange? ",
                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs font-normal lowercase whitespace-nowrap",
                        children: "(optional)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-btn-container flex mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: "part_ex",
                        label: "Yes",
                        value: true,
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: "part_ex",
                        label: "No",
                        value: false,
                        ...rest
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_PartEx = (PartEx);

;// CONCATENATED MODULE: ./src/components/form/fields/PaymentConsent.tsx


const PaymentConsent = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* CheckboxInput */.I0, {
            name: "terms",
            value: "true",
            children: "I have read and understand the terms above"
        })
    });
};
/* harmony default export */ var fields_PaymentConsent = (PaymentConsent);

;// CONCATENATED MODULE: ./src/components/form/fields/PaymentDuration.tsx



const PaymentDuration = (param)=>{
    let { ...rest } = param;
    const label = "How many months payment break would you like to activate?";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-medium my-5",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-btn-container flex mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        errorDisabled: true,
                        name: "months",
                        label: "1 month",
                        value: 1,
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        errorDisabled: true,
                        name: "months",
                        label: "2 months",
                        value: 2,
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        errorDisabled: true,
                        name: "months",
                        label: "3 months",
                        value: 3,
                        ...rest
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_PaymentDuration = (PaymentDuration);

;// CONCATENATED MODULE: ./src/components/form/fields/Postcode.tsx


const Postcode = (param)=>{
    let { name: inputName , label: inputLabel , helper , ...rest } = param;
    const name = inputName || "postcode";
    const label = inputLabel || "Postcode";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_Postcode = (Postcode);

;// CONCATENATED MODULE: ./src/components/form/fields/PreferenceTerms.tsx


const PreferenceTerms = (param)=>{
    let { preferenceType  } = param;
    const brand = (0,contexts/* useBrand */.DY)();
    const privacyLink = brand === "lexus" ? "https://www.lexus.co.uk/customer-data/privacy-policy" : "https://www.toyota.co.uk/footer/privacy-policy";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "my-8",
        "data-gt-componentname": "terms",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                preferenceType,
                " is committed to protecting the privacy and security of personal information. We will use, store and share personal information for the purpose of providing and performing our products or services. Information about our use and handling of personal information, your data protection rights and how to contact us is provided in our",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "underline whitespace-nowrap",
                    href: privacyLink,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "data-gt-name": "ctaevent",
                    "data-gt-action": "terms-click-link",
                    "data-gt-label": privacyLink,
                    children: "privacy notice"
                }),
                "."
            ]
        })
    });
};
/* harmony default export */ var fields_PreferenceTerms = (PreferenceTerms);

;// CONCATENATED MODULE: ./src/components/form/fields/PrivateOrCompanyCar.tsx




const PrivateOrCompanyCar = (param)=>{
    let { optional , ...rest } = param;
    const { formState , getFieldState  } = (0,index_esm/* useFormContext */.Gc)();
    const { error  } = getFieldState("pvt_company_car", formState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "font-medium mt-5 mb-1",
                children: [
                    "Who is this vehicle for?",
                    " ",
                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs lowercase whitespace-nowrap",
                        children: "(optional)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-btn-container flex gap-2 flex-col mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: "pvt_company_car",
                        label: "Myself",
                        value: "Private",
                        errorDisabled: true,
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: "pvt_company_car",
                        label: "Myself (Company Vehicle)",
                        value: "Company",
                        errorDisabled: true,
                        ...rest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: "pvt_company_car",
                        label: "Fleet & Business",
                        value: "Fleet",
                        errorDisabled: true,
                        ...rest
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-red text-tiny mt-1",
                        role: "alert",
                        children: error.message
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_PrivateOrCompanyCar = (PrivateOrCompanyCar);

;// CONCATENATED MODULE: ./src/components/form/fields/RetentionCertificate.tsx


const RetentionCertificate = (param)=>{
    let { helper , ...rest } = param;
    const name = "retention_id";
    const label = "Retention certificate";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var fields_RetentionCertificate = (RetentionCertificate);

;// CONCATENATED MODULE: ./src/components/form/fields/ShowroomTerms.tsx



const ShowroomTerms = (param)=>{
    let { ...rest } = param;
    const brand = useBrand();
    const privacyLink = brand === "lexus" ? "https://www.lexus.co.uk/customer-data/privacy-policy" : "https://www.toyota.co.uk/footer/privacy-policy";
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-8",
        "data-gt-componentname": "showroom-terms",
        children: [
            /*#__PURE__*/ _jsx("h5", {
                children: "CHECK: have you read/sent the data compliancy message to the customer?"
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: "mb-8",
                children: [
                    "To fulfil this request we need to send your information to your local retailer. Can you confirm you are happy for us to do this? If you would like to find out more about how we process your data please visit our",
                    /*#__PURE__*/ _jsx("a", {
                        className: "underline",
                        href: privacyLink,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-gt-name": "ctaevent",
                        "data-gt-action": "click-link",
                        "data-gt-label": privacyLink,
                        children: "privacy notice"
                    }),
                    "for details."
                ]
            }),
            /*#__PURE__*/ _jsx(CheckboxInput, {
                name: "iscustomeraware",
                ...rest,
                children: "The customer is aware that their data is being transferred to the Centre"
            })
        ]
    });
};
/* harmony default export */ var fields_ShowroomTerms = ((/* unused pure expression or super */ null && (ShowroomTerms)));

;// CONCATENATED MODULE: ./src/components/form/fields/Tel.tsx


const Tel = (param)=>{
    let { helper , optional , ...rest } = param;
    const name = "tel";
    const label = "Phone";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TelInput */.RT, {
        name: name,
        label: label,
        helper: helper,
        optional: optional,
        ...rest
    });
};
/* harmony default export */ var fields_Tel = (Tel);

;// CONCATENATED MODULE: ./src/components/form/fields/TextInput.tsx

/* harmony default export */ var TextInput = (baseInputs/* TextInput */.oi);

;// CONCATENATED MODULE: ./src/components/form/fields/TGBCommonID.tsx


const TGBCommonId = (param)=>{
    let { helper , ...rest } = param;
    const name = "agent";
    const label = "TGB Common ID";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: name,
        label: label,
        helper: helper,
        ...rest
    });
};
/* harmony default export */ var TGBCommonID = (TGBCommonId);

;// CONCATENATED MODULE: ./src/components/form/fields/Title.tsx


const Title = (param)=>{
    let { helper , optional , ...rest } = param;
    const name = "title";
    const label = "Title";
    const options = [
        {
            label: "Mr",
            value: "Mr"
        },
        {
            label: "Mrs",
            value: "Mrs"
        },
        {
            label: "Miss",
            value: "Miss"
        },
        {
            label: "Ms",
            value: "Ms"
        },
        {
            label: "Mx",
            value: "Mx"
        },
        {
            label: "Doctor",
            value: "Doctor"
        },
        {
            label: "Professor",
            value: "Professor"
        },
        {
            label: "Reverend",
            value: "Reverend"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* SelectInput */.lq, {
        name: name,
        label: label,
        options: options,
        helper: helper,
        optional: optional,
        ...rest
    });
};
/* harmony default export */ var fields_Title = (Title);

;// CONCATENATED MODULE: ./src/components/form/fields/UnsubscribeTerms.tsx



const UnsubscribeTerms = ()=>{
    const brand = (0,contexts/* useBrand */.DY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: "mt-8 mb-4",
            children: [
                "Please note this does not unsubscribe you from any",
                " ",
                (0,dist_es2015/* upperCaseFirst */.l)(brand),
                " dealership databases as they operate as independent legal entities. Please contact any ",
                (0,dist_es2015/* upperCaseFirst */.l)(brand),
                " ",
                brand === "lexus" ? "Centre" : "dealerships",
                " you may have contacted previously to unsubscribe directly."
            ]
        })
    });
};
/* harmony default export */ var fields_UnsubscribeTerms = (UnsubscribeTerms);

;// CONCATENATED MODULE: ./src/components/form/fields/UsedCarCard.tsx




const UsedCarCard = (param)=>{
    let { vehicle , dealer , vrn  } = param;
    const brand = (0,contexts_useBrand/* useBrand */.D)();
    const [showAddress, setShowAddress] = (0,react.useState)(false);
    const handleClick = ()=>{
        setShowAddress(!showAddress);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-8 md:mb-4",
        "data-gt-componentname": "used-car-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "border px-3 py-4 border-base-hover md:col-span-2 lg:col-span-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-xl",
                    children: vehicle || "".concat((0,dist_es2015/* upperCaseFirst */.l)(brand), " used vehicle")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    className: "text-lg",
                    children: vrn
                }),
                dealer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                    className: "not-italic text-md mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            onClick: handleClick,
                            className: "cursor-pointer hover:underline inline-block",
                            "data-gt-name": "componentevent",
                            "data-gt-action": "click-address",
                            "data-gt-label": showAddress ? "open-address" : "close-address",
                            children: [
                                dealer.name,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    strokeWidth: 1.5,
                                    stroke: "currentColor",
                                    className: "w-4 h-4 inline-block ml-2 ".concat(showAddress ? "rotate-180" : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(showAddress ? "" : "hidden", " mt-2"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: dealer.defaultAddress.addressLine1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: dealer.defaultAddress.addressLine2
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: dealer.defaultAddress.city
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: dealer.defaultAddress.region
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: dealer.defaultAddress.zip
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var fields_UsedCarCard = (UsedCarCard);

;// CONCATENATED MODULE: ./src/components/form/fields/VehicleRegNo.tsx


const VehicleRegNo = (param)=>{
    let { helper , optional , name , label , ...rest } = param;
    const defaultName = name || "reg_num";
    const inputLabel = label || "Vehicle registration number";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* TextInput */.oi, {
        name: defaultName,
        label: inputLabel,
        helper: helper,
        optional: optional,
        uppercase: true,
        ...rest
    });
};
/* harmony default export */ var fields_VehicleRegNo = (VehicleRegNo);

;// CONCATENATED MODULE: ./src/components/form/fields/YesNo.tsx



const YesNo = (param)=>{
    let { label , name  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-medium my-5",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-btn-container flex mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: name,
                        label: "Yes",
                        value: true,
                        errorDisabled: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* RadioButton */.EU, {
                        name: name,
                        label: "No",
                        value: false,
                        errorDisabled: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fields_YesNo = (YesNo);

;// CONCATENATED MODULE: ./src/components/form/fields/index.ts
































































/***/ }),

/***/ 76817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ layout_FormStep; },
  "n": function() { return /* reexport */ layout_FormWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/contexts/useBrand.tsx
var useBrand = __webpack_require__(25765);
// EXTERNAL MODULE: ./src/utils/helpers/tracking.ts + 1 modules
var helpers_tracking = __webpack_require__(68379);
// EXTERNAL MODULE: ./node_modules/marked/lib/marked.esm.js
var marked_esm = __webpack_require__(61006);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./src/components/form/layout/FormStep.tsx





const FormStep = (param)=>{
    let { title , subtitle , active , user , tracking , step , children , noContainer =false , noPadding =false  } = param;
    const brand = (0,useBrand/* useBrand */.D)();
    (0,react.useEffect)(()=>{
        if (active && tracking && user) {
            (0,helpers_tracking/* formEvent */.Be)(tracking, brand);
        }
    }, [
        step
    ]);
    if (!active) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col grow text-base-text ".concat(!noContainer ? "container my-8 md:my-10 lg:my-[60px]" : "", " ").concat(noPadding ? "container mb-8 md:mb-10 lg:mb-[60px]" : ""),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-xl md:text-2xl lg:text-3xl mb-3 !leading-snug ".concat(subtitle ? "" : "mb-8 md:mb-10 lg:mb-10"),
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(brand === "lexus" ? "text-lg" : "text-md", " pb-8 md:pb-10 !normal-case last:[&>p]:mb-0 [&>p]:mb-3 [&>p>a]:underline"),
                dangerouslySetInnerHTML: {
                    __html: marked_esm/* marked.parse */.TU.parse(subtitle, {
                        mangle: false,
                        headerIds: false
                    })
                }
            }),
            children
        ]
    });
};
/* harmony default export */ var layout_FormStep = (FormStep);

;// CONCATENATED MODULE: ./src/components/form/layout/FormWrapper.tsx

const FormWrapper = (param)=>{
    let { children , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        ...rest,
        children: children
    });
};
/* harmony default export */ var layout_FormWrapper = (FormWrapper);

;// CONCATENATED MODULE: ./src/components/form/layout/index.ts





/***/ }),

/***/ 67958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$w": function() { return /* binding */ TITLES; },
/* harmony export */   "Ez": function() { return /* binding */ TYPE_OF_ENQUIRIES_OTSO_VALUES; },
/* harmony export */   "Fd": function() { return /* binding */ TYPE_OF_ENQUIRIES_OTSO; },
/* harmony export */   "GA": function() { return /* binding */ TYPE_OF_ENQUIRIES_CANS; },
/* harmony export */   "IG": function() { return /* binding */ LEXUS_TAKUMI_DESIGN_LBX; },
/* harmony export */   "J_": function() { return /* binding */ TYPE_OF_ENQUIRIES_GENERAL; },
/* harmony export */   "Jv": function() { return /* binding */ TYPE_OF_ENQUIRIES_OLSO; },
/* harmony export */   "M1": function() { return /* binding */ LEXUS_PREM_LBX; },
/* harmony export */   "Po": function() { return /* binding */ FLEET_SIZE; },
/* harmony export */   "Ry": function() { return /* binding */ TYPE_OF_ENQUIRIES_TOYOTA; },
/* harmony export */   "TU": function() { return /* binding */ LEXUS_TAKUMI_LBX; },
/* harmony export */   "_H": function() { return /* binding */ FUEL_ORDER; },
/* harmony export */   "c9": function() { return /* binding */ ERROR_MESSAGE; },
/* harmony export */   "cU": function() { return /* binding */ TYPE_OF_ENQUIRIES_FINANCE; },
/* harmony export */   "eA": function() { return /* binding */ TYPE_OF_ENQUIRIES_TOYOTA_VALUES; },
/* harmony export */   "eK": function() { return /* binding */ LEXUS_GRADE_LBX; },
/* harmony export */   "eS": function() { return /* binding */ LEXUS_PREM_PLUS_DESIGN_LBX; },
/* harmony export */   "fV": function() { return /* binding */ TYPE_OF_ENQUIRIES_MULTIMEDIA; },
/* harmony export */   "fq": function() { return /* binding */ TYPE_OF_ENQUIRIES_CALLBACK; },
/* harmony export */   "gI": function() { return /* binding */ TYPE_OF_ENQUIRIES_OLSO_VALUES; },
/* harmony export */   "kf": function() { return /* binding */ CATEGORIES_ORDER; },
/* harmony export */   "pP": function() { return /* binding */ TYPE_OF_ENQUIRIES_LEXUS_VALUES; },
/* harmony export */   "pk": function() { return /* binding */ TYPE_OF_ENQUIRIES_ROADSIDE; },
/* harmony export */   "tD": function() { return /* binding */ TYPE_OF_ENQUIRIES_LEXUS; },
/* harmony export */   "vp": function() { return /* binding */ LEXUS_ORIGINAL_LBX; },
/* harmony export */   "w7": function() { return /* binding */ LEXUS_PREM_PLUS_LBX; },
/* harmony export */   "ye": function() { return /* binding */ LEXUS_URBAN_LBX; },
/* harmony export */   "yu": function() { return /* binding */ TIMES; }
/* harmony export */ });
/* unused harmony export MODEL_LIST_CANS */
const ERROR_MESSAGE = "Sorry, an error has occurred and your request could not be processed. Please try again later.";
const CATEGORIES_ORDER = [
    "Small Cars",
    "Family Cars",
    "SUV & 4x4",
    "Sports",
    "Commercial"
];
const FUEL_ORDER = [
    "Hybrid",
    "Plug-in Hybrid",
    "All-Electric",
    "Hydrogen Fuel Cell",
    "Petrol",
    "Diesel"
];
const TIMES = [
    {
        label: "9:00",
        value: "9:00"
    },
    {
        label: "10:00",
        value: "10:00"
    },
    {
        label: "11:00",
        value: "11:00"
    },
    {
        label: "12:00",
        value: "12:00"
    },
    {
        label: "13:00",
        value: "13:00"
    },
    {
        label: "14:00",
        value: "14:00"
    },
    {
        label: "15:00",
        value: "15:00"
    },
    {
        label: "16:00",
        value: "16:00"
    }
];
const TITLES = [
    {
        label: "Mr",
        value: "Mr"
    },
    {
        label: "Mrs",
        value: "Mrs"
    },
    {
        label: "Miss",
        value: "Miss"
    },
    {
        label: "Ms",
        value: "Ms"
    },
    {
        label: "Mx",
        value: "Mx"
    },
    {
        label: "Doctor",
        value: "Doctor"
    },
    {
        label: "Professor",
        value: "Professor"
    },
    {
        label: "Reverend",
        value: "Reverend"
    }
];
const FLEET_SIZE = [
    {
        label: " 0 - 25",
        value: "0 - 25"
    },
    {
        label: "25 - 250",
        value: "25 - 250"
    },
    {
        label: "250+",
        value: "250+"
    }
];
const TYPE_OF_ENQUIRIES_TOYOTA = [
    {
        label: "New vehicle",
        value: "new_car"
    },
    {
        label: "Used vehicle",
        value: "used_car"
    },
    {
        label: "Motability",
        value: "motability"
    },
    {
        label: "Business Fleet Enquiry",
        value: "fleet_business"
    },
    {
        label: "Servicing and MOT",
        value: "servicing"
    },
    {
        label: "Parts And accessories",
        value: "parts"
    },
    {
        label: "Repair",
        value: "repair"
    },
    {
        label: "Selling my Toyota",
        value: "selling"
    },
    {
        label: "Something else",
        value: "notlisted_new"
    }
];
const TYPE_OF_ENQUIRIES_TOYOTA_VALUES = {
    new_car: {
        type: "NV",
        type_of_enquiry: "A new Toyota",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "New Vehicle Sale",
        pvt_company_car: "I"
    },
    used_car: {
        type: "UV",
        type_of_enquiry: "A used vehicle",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "Used Vehicle Sale",
        pvt_company_car: "I"
    },
    motability: {
        type: "MA",
        type_of_enquiry: "Motability enquiry",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "Motability",
        pvt_company_car: "I"
    },
    fleet_business: {
        type: "NF",
        type_of_enquiry: "A new company vehicle",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "New Vehicle Sale - Fleet",
        pvt_company_car: "B"
    },
    servicing: {
        type: "SE",
        type_of_enquiry: "Servicing and MOT",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "Service & MOT Enquiry",
        pvt_company_car: "I"
    },
    parts: {
        type: "AC",
        type_of_enquiry: "New parts or accessories",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "Parts & Accessories",
        pvt_company_car: "I"
    },
    repair: {
        type: "RP",
        type_of_enquiry: "Booking my vehicle in for a repair",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "Repair",
        pvt_company_car: "I"
    },
    selling: {
        type: "ST",
        type_of_enquiry: "Selling my current Toyota",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "Selling my current Toyota",
        pvt_company_car: "I"
    },
    notlisted_new: {
        type: "CU",
        type_of_enquiry: "Something not listed above, related to a new vehicle",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "General Enquiry",
        pvt_company_car: "I"
    }
};
const TYPE_OF_ENQUIRIES_LEXUS = [
    {
        label: "New Car",
        value: "new_car"
    },
    {
        label: "Used Car",
        value: "used_car"
    },
    {
        label: "Motability",
        value: "motability"
    },
    {
        label: "Car Service & MOT",
        value: "servicing"
    },
    {
        label: "My Vehicle",
        value: "notlisted_current"
    },
    {
        label: "Parts & Accessories",
        value: "parts"
    },
    {
        label: "Repair",
        value: "repair"
    },
    {
        label: "Fleet Business",
        value: "fleet_business"
    },
    {
        label: "Other Sales Enquiries",
        value: "notlisted_new"
    }
];
const TYPE_OF_ENQUIRIES_LEXUS_VALUES = {
    new_car: {
        type: "NV",
        type_of_enquiry: "New Car",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "New Vehicle Sale",
        pvt_company_car: "I"
    },
    used_car: {
        type: "UV",
        type_of_enquiry: "Used Car",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "Used Vehicle Sale",
        pvt_company_car: "I"
    },
    motability: {
        type: "MA",
        type_of_enquiry: "Motability enquiry",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "Motability",
        pvt_company_car: "I"
    },
    servicing: {
        type: "SE",
        type_of_enquiry: "Car Service & MOT",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "Service & MOT Enquiry",
        pvt_company_car: "I"
    },
    notlisted_current: {
        type: "AS",
        type_of_enquiry: "My Vehicle",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "After Sales Enquiry",
        pvt_company_car: "I"
    },
    parts: {
        type: "AC",
        type_of_enquiry: "Parts & Accessories",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "Parts & Accessories",
        pvt_company_car: "I"
    },
    repair: {
        type: "RP",
        type_of_enquiry: "Repair",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "Repair",
        pvt_company_car: "I"
    },
    fleet_business: {
        type: "NF",
        type_of_enquiry: "Fleet Business",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "New Vehicle Sale - Fleet",
        pvt_company_car: "B"
    },
    notlisted_new: {
        type: "CU",
        type_of_enquiry: "Other Sales Enquiries",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "General Enquiry",
        pvt_company_car: "I"
    }
};
const TYPE_OF_ENQUIRIES_OTSO = [
    {
        label: "Servicing and MOT",
        value: "servicing"
    },
    {
        label: "Servicing and MOT for my company vehicle",
        value: "fleet_servicing"
    },
    {
        label: "New parts or accessories",
        value: "parts"
    },
    {
        label: "Booking my vehicle in for a repair",
        value: "repair"
    },
    {
        label: "Something not listed above, related to my current vehicle",
        value: "notlisted_current"
    }
];
const TYPE_OF_ENQUIRIES_OTSO_VALUES = {
    servicing: {
        type: "SE",
        type_of_enquiry: "Servicing and MOT",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "Service & MOT Enquiry",
        pvt_company_car: "I"
    },
    fleet_servicing: {
        type: "SF",
        type_of_enquiry: "Servicing and MOT for my company vehicle",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "Service & MOT Enquiry - Fleet",
        pvt_company_car: "B"
    },
    parts: {
        type: "AC",
        type_of_enquiry: "New parts or accessories",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "Parts & Accessories",
        pvt_company_car: "I"
    },
    repair: {
        type: "RP",
        type_of_enquiry: "Booking my vehicle in for a repair",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "Repair",
        pvt_company_car: "I"
    },
    notlisted_current: {
        type: "AS",
        type_of_enquiry: "Something not listed above, related to my current vehicle",
        subject: "From a visitor to your Toyota Website: via the contact us form",
        enquiry_description: "After Sales Enquiry",
        pvt_company_car: "I"
    }
};
const TYPE_OF_ENQUIRIES_OLSO = [
    {
        label: "Car Service & MOT",
        value: "servicing"
    },
    {
        label: "My Vehicle",
        value: "notlisted_current"
    },
    {
        label: "Parts & Accessories",
        value: "parts"
    },
    {
        label: "Repair",
        value: "repair"
    }
];
const TYPE_OF_ENQUIRIES_OLSO_VALUES = {
    servicing: {
        type: "SE",
        type_of_enquiry: "Car Service & MOT",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "Service & MOT Enquiry",
        pvt_company_car: "I"
    },
    notlisted_current: {
        type: "AS",
        type_of_enquiry: "My Vehicle",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "After Sales Enquiry",
        pvt_company_car: "I"
    },
    parts: {
        type: "AC",
        type_of_enquiry: "Parts & Accessories",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "Parts & Accessories",
        pvt_company_car: "I"
    },
    repair: {
        type: "RP",
        type_of_enquiry: "Repair",
        subject: "From a visitor to your Lexus Website: via the contact us form",
        enquiry_description: "Repair",
        pvt_company_car: "I"
    }
};
const TYPE_OF_ENQUIRIES_CALLBACK = [
    {
        label: "New Car sales",
        value: "New Car sales"
    },
    {
        label: "Used Car sales",
        value: "Used Car sales"
    },
    {
        label: "Service",
        value: "Service"
    },
    {
        label: "Parts and Accessories",
        value: "Parts and Accessories"
    },
    {
        label: "Finance offers",
        value: "Finance offers"
    },
    {
        label: "Other",
        value: "Other"
    }
];
const TYPE_OF_ENQUIRIES_GENERAL = [
    {
        label: "Enquiry about my vehicle",
        value: "general_enquiry:1"
    },
    {
        label: "Enquiry about my Servicing, Parts or Accessories",
        value: "general_enquiry:2"
    },
    {
        label: "Help with my Toyota™",
        value: "general_enquiry:3"
    },
    {
        label: "Other enquiry",
        value: "general_enquiry:4"
    }
];
const TYPE_OF_ENQUIRIES_ROADSIDE = [
    {
        label: "General Enquiry about Toyota Roadside Assistance (Club Toyota)",
        value: "TRA:1"
    },
    {
        label: "Enquiry about renewal or cancellation of Toyota Roadside Assistance",
        value: "TRA:2"
    }
];
const TYPE_OF_ENQUIRIES_MULTIMEDIA = [
    {
        label: "Account",
        value: "multimedia:1"
    },
    {
        label: "Service & Maintenance",
        value: "multimedia:2"
    },
    {
        label: "Connected Services",
        value: "multimedia:3"
    },
    {
        label: "Connected Insurance",
        value: "multimedia:4"
    },
    {
        label: "Remote Services",
        value: "multimedia:5"
    },
    {
        label: "Standard Services",
        value: "multimedia:6"
    },
    {
        label: "Charging Network",
        value: "multimedia:7"
    },
    {
        label: "Digital Key",
        value: "multimedia:8"
    },
    {
        label: "Home Charge",
        value: "multimedia:9"
    },
    {
        label: "Multimedia",
        value: "multimedia:10"
    },
    {
        label: "Subscriptions",
        value: "multimedia:11"
    },
    {
        label: "Remote Climate",
        value: "multimedia:12"
    }
];
const TYPE_OF_ENQUIRIES_FINANCE = [
    {
        label: "Arrange Collection of My Vehicle",
        value: "Arrange Collection of My Vehicle"
    },
    {
        label: "Settlement Request",
        value: "Settlement Request"
    },
    {
        label: "Invoice Enquiry",
        value: "Invoice Enquiry"
    },
    {
        label: "Request Copy of Your Finance Agreement",
        value: "Request Copy of Your Finance Agreement"
    },
    {
        label: "Difficulty Paying",
        value: "Difficulty Paying"
    },
    {
        label: "Address and Contact Details Change",
        value: "Address and Contact Details Change"
    },
    {
        label: "Bank Details Change",
        value: "Bank Details Change"
    },
    {
        label: "Name Change",
        value: "Name Change"
    },
    {
        label: "Re-finance Enquiry",
        value: "Re-finance Enquiry"
    },
    {
        label: "Family Bereavement",
        value: "Family Bereavement"
    },
    {
        label: "Complaint",
        value: "Complaint"
    },
    {
        label: "Payment Protection Insurance (PPI)",
        value: "Payment Protection Insurance (PPI)"
    },
    {
        label: "General Enquiry",
        value: "General Enquiry"
    }
];
const TYPE_OF_ENQUIRIES_CANS = [
    {
        label: "Sales General Enquiry",
        value: "Sales General Enquiry"
    },
    {
        label: "Aftersales General Enquiry",
        value: "Aftersales General Enquiry"
    },
    {
        label: "New Vehicle Enquiry",
        value: "New Vehicle Enquiry"
    },
    {
        label: "Used Vehicle Enquiry",
        value: "Used Vehicle Enquiry"
    },
    {
        label: "Finance/Leasing",
        value: "Finance/Leasing"
    },
    {
        label: "Fleet/Business Enquiry",
        value: "Fleet/Business Enquiry"
    },
    {
        label: "Part Exchange",
        value: "Part Exchange"
    },
    {
        label: "Service & MOT",
        value: "Service & MOT"
    },
    {
        label: "Parts & Accessories",
        value: "Parts & Accessories"
    },
    {
        label: "Repair",
        value: "Repair"
    }
];
const MODEL_LIST_CANS = [
    {
        label: "AYGO",
        value: "AYGO"
    },
    {
        label: "All New Yaris",
        value: "All New Yaris"
    },
    {
        label: "GR Yaris",
        value: "GR Yaris"
    },
    {
        label: "Corolla",
        value: "Corolla"
    },
    {
        label: "Corolla Touring Sports",
        value: "Corolla Touring Sports"
    },
    {
        label: "Corolla Saloon",
        value: "Corolla Saloon"
    },
    {
        label: "Camry",
        value: "Camry"
    },
    {
        label: "Toyota C-HR",
        value: "Toyota C-HR"
    },
    {
        label: "RAV4",
        value: "RAV4"
    },
    {
        label: "Toyota GR Supra",
        value: "Toyota GR Supra"
    },
    {
        label: "Prius",
        value: "Prius"
    },
    {
        label: "Prius Plug-in",
        value: "Prius Plug-in"
    },
    {
        label: "Land Cruiser",
        value: "Land Cruiser"
    },
    {
        label: "New Hilux",
        value: "New Hilux"
    },
    {
        label: "All New Highlander",
        value: "All New Highlander"
    },
    {
        label: "PROACE",
        value: "PROACE"
    },
    {
        label: "New PROACE City",
        value: "New PROACE City"
    },
    {
        label: "PROACE VERSO",
        value: "PROACE VERSO"
    }
];
const LEXUS_GRADE_LBX = [
    {
        label: "Urban",
        value: "Urban"
    },
    {
        label: "Premium",
        value: "Premium"
    },
    {
        label: "Premium Plus",
        value: "Premium Plus"
    },
    {
        label: "Premium Plus Design",
        value: "Premium Plus Design"
    },
    {
        label: "Takumi",
        value: "Takumi"
    },
    {
        label: "Takumi Design",
        value: "Takumi Design"
    },
    {
        label: "Original Edition",
        value: "Original Edition"
    }
];
const LEXUS_URBAN_LBX = [
    {
        label: "Sonic White",
        value: "Sonic White"
    },
    {
        label: "Silver Metallic",
        value: "Silver Metallic"
    },
    {
        label: "Cement Grey",
        value: "Cement Grey"
    },
    {
        label: "Sonic Grey",
        value: "Sonic Grey"
    },
    {
        label: "Metallic Red",
        value: "Metallic Red"
    },
    {
        label: "Solid Yellow",
        value: "Solid Yellow"
    },
    {
        label: "Metallic Blue",
        value: "Metallic Blue"
    },
    {
        label: "Eclipse Black",
        value: "Eclipse Black"
    }
];
const LEXUS_PREM_LBX = [
    {
        label: "Sonic White",
        value: "Sonic White"
    },
    {
        label: "Silver Metallic",
        value: "Silver Metallic"
    },
    {
        label: "Cement Grey",
        value: "Cement Grey"
    },
    {
        label: "Sonic Grey",
        value: "Sonic Grey"
    },
    {
        label: "Metallic Red",
        value: "Metallic Red"
    },
    {
        label: "Solid Yellow",
        value: "Solid Yellow"
    },
    {
        label: "Metallic Blue",
        value: "Metallic Blue"
    },
    {
        label: "Eclipse Black",
        value: "Eclipse Black"
    }
];
const LEXUS_PREM_PLUS_LBX = [
    {
        label: "Sonic White",
        value: "Sonic White"
    },
    {
        label: "Silver Metallic",
        value: "Silver Metallic"
    },
    {
        label: "Cement Grey",
        value: "Cement Grey"
    },
    {
        label: "Sonic Grey",
        value: "Sonic Grey"
    },
    {
        label: "Metallic Red",
        value: "Metallic Red"
    },
    {
        label: "Solid Yellow",
        value: "Solid Yellow"
    },
    {
        label: "Metallic Blue",
        value: "Metallic Blue"
    },
    {
        label: "Eclipse Black",
        value: "Eclipse Black"
    }
];
const LEXUS_PREM_PLUS_DESIGN_LBX = [
    {
        label: "Sonic White Bi-tone",
        value: "Sonic White Bi-tone"
    },
    {
        label: "Silver Metallic Bi-tone",
        value: "Silver Metallic Bi-tone"
    },
    {
        label: "Cement Grey Bi-tone",
        value: "Cement Grey Bi-tone"
    },
    {
        label: "Sonic Grey Bi-tone",
        value: "Sonic Grey Bi-tone"
    },
    {
        label: "Ruby Red Bi-tone",
        value: "Ruby Red Bi-tone"
    },
    {
        label: "Solid Yellow Bi-tone",
        value: "Solid Yellow Bi-tone"
    },
    {
        label: "Metallic Blue Bi-tone",
        value: "Metallic Blue Bi-tone"
    }
];
const LEXUS_TAKUMI_LBX = [
    {
        label: "Sonic White",
        value: "Sonic White"
    },
    {
        label: "Silver Metallic",
        value: "Silver Metallic"
    },
    {
        label: "Cement Grey",
        value: "Cement Grey"
    },
    {
        label: "Sonic Grey",
        value: "Sonic Grey"
    },
    {
        label: "Metallic Red",
        value: "Metallic Red"
    },
    {
        label: "Solid Yellow",
        value: "Solid Yellow"
    },
    {
        label: "Metallic Blue",
        value: "Metallic Blue"
    },
    {
        label: "Eclipse Black",
        value: "Eclipse Black"
    }
];
const LEXUS_TAKUMI_DESIGN_LBX = [
    {
        label: "Sonic White Bi-tone",
        value: "Sonic White Bi-tone"
    },
    {
        label: "Silver Metallic Bi-tone",
        value: "Silver Metallic Bi-tone"
    },
    {
        label: "Cement Grey Bi-tone",
        value: "Cement Grey Bi-tone"
    },
    {
        label: "Sonic Grey Bi-tone",
        value: "Sonic Grey Bi-tone"
    },
    {
        label: "Ruby Red Bi-tone",
        value: "Ruby Red Bi-tone"
    },
    {
        label: "Solid Yellow Bi-tone",
        value: "Solid Yellow Bi-tone"
    },
    {
        label: "Metallic Blue Bi-tone",
        value: "Metallic Blue Bi-tone"
    }
];
const LEXUS_ORIGINAL_LBX = [
    {
        label: "Sonic Copper Bi-Tone",
        value: "Sonic Copper Bi-Tone"
    }
];


/***/ }),

/***/ 73705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p8": function() { return /* reexport */ AccessFlexSchema; },
  "Gi": function() { return /* reexport */ AccessFlexSchema2; },
  "t1": function() { return /* reexport */ brochure; },
  "r2": function() { return /* reexport */ contact_us_dealer; },
  "CV": function() { return /* reexport */ contact_us; },
  "PM": function() { return /* reexport */ discretionary_commission; },
  "GB": function() { return /* reexport */ ask_your_ev_question; },
  "oJ": function() { return /* reexport */ fleet_callback; },
  "cO": function() { return /* reexport */ newsletter_fleet; },
  "Jf": function() { return /* reexport */ get_a_quote; },
  "C9": function() { return /* reexport */ golf_masterclass_locations; },
  "KT": function() { return /* reexport */ golf_masterclass; },
  "j2": function() { return /* reexport */ gr_yaris_lottery; },
  "_L": function() { return /* reexport */ internal_cans; },
  "AG": function() { return /* reexport */ kinto_get_a_quote; },
  "BU": function() { return /* reexport */ change_number_plate; },
  "TQ": function() { return /* reexport */ kinto_contact_us; },
  "zL": function() { return /* reexport */ existing; },
  "AP": function() { return /* reexport */ fleet_exchange; },
  "ww": function() { return /* reexport */ service_booking_new; },
  "$m": function() { return /* reexport */ online; },
  "XI": function() { return /* reexport */ postal; },
  "Dg": function() { return /* reexport */ kinto_request_a_callback; },
  "yK": function() { return /* reexport */ used_cars; },
  "bR": function() { return /* reexport */ kmi; },
  "c0": function() { return /* reexport */ marketing_preferences; },
  "cZ": function() { return /* reexport */ newsletter; },
  "i4": function() { return /* reexport */ parts_accessories; },
  "uB": function() { return /* reexport */ power_of_choice; },
  "Um": function() { return /* reexport */ pre_approval; },
  "EM": function() { return /* reexport */ cms; },
  "Bs": function() { return /* reexport */ rcc_preferences; },
  "TT": function() { return /* reexport */ request_a_callback; },
  "Bi": function() { return /* reexport */ reserve_lbx; },
  "WI": function() { return /* reexport */ reserve; },
  "AV": function() { return /* reexport */ stock_car_enquiry_schema; },
  "m4": function() { return /* reexport */ test_drive; },
  "E_": function() { return /* reexport */ toyota_thon; },
  "Lf": function() { return /* reexport */ uber; },
  "b$": function() { return /* reexport */ unsubscribe; },
  "Xr": function() { return /* reexport */ used_car_enquiry; },
  "oK": function() { return /* reexport */ video_consultation; }
});

// UNUSED EXPORTS: DunlopPrizeDrawSchema, PrizeDrawSchema, SolusSchema, ToyotaChrSchema

// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatISO/index.js
var formatISO = __webpack_require__(38281);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isFuture/index.js
var isFuture = __webpack_require__(70151);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(39284);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(38797);
;// CONCATENATED MODULE: ./src/utils/schemas/accessflex.ts


const AccessFlexSchema = (0,es.object)().shape({
    contract_ref: (0,es.string)().required("Please enter your agreement number").matches(/^[0-9]{12}$/, "Please enter a valid agreement number, e.g. 000030103010").max(12, "Agreement number must be at most 12 characters").trim(),
    reg_num: (0,es.string)().required("Please enter your registration").matches(/^[a-zA-Z0-9]{1,4}\s?[a-zA-Z0-9]{1,3}$/, "Please enter a valid registration").trim(),
    last_name: (0,es.string)().required("Surname is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "Surname can only contain letters and basic punctuation").min(2, "Surname must be at least 2 characters").max(30, "Surname must be at most 30 characters").trim(),
    dob: (0,es.string)().required("Please enter your date of birth").transform((value)=>{
        if (value) {
            const parts = value.split("/");
            const formattedDate = new Date(parts[2], parts[1] - 1, parts[0]);
            return (0,formatISO/* default */.Z)(formattedDate, {
                representation: "date"
            });
        }
        return value;
    }).test("is-future", "Date of birth cannot be in the future", (value)=>!(0,isFuture/* default */.Z)((0,parseISO["default"])(value))),
    postcode: (0,es.string)().required("Please enter your post code").matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Please enter a valid post code").max(25).trim()
});
const AccessFlexSchema2 = (0,es.object)().shape({
    months: (0,es.number)().required("Please select a payment break length"),
    terms: (0,es.boolean)().oneOf([
        true
    ], "Please confirm you have read and understood the terms")
});


;// CONCATENATED MODULE: ./src/utils/schemas/ask-your-ev-question.ts

const EvQuestionSchema = (0,es.object)().shape({
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    notes: (0,es.string)().required("Please ask your question").max(250).trim(),
    is_lexus: (0,es.boolean)(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var ask_your_ev_question = (EvQuestionSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/brochure.ts

const BrochureSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    model: (0,es.string)().required().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    }),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    response_code: (0,es.string)().uppercase().trim(),
    dealer: (0,es.string)(),
    dealername: (0,es.string)(),
    is_lexus: (0,es.boolean)()
});
/* harmony default export */ var brochure = (BrochureSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/contact-us.ts

const ContactUsSchema = (0,es.object)().shape({
    form_name: (0,es.string)().required(),
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    month: (0,es.string)().when("form_name", {
        is: (value)=>[
                "financial-services"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/0[1-9]|1[0-2]/, "Month is required")
    }),
    day: (0,es.string)().when("form_name", {
        is: (value)=>[
                "financial-services"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/^(?:^0[1-9]|[1-2][0-9]|30|31)$/, "Day is required")
    }).when("month", {
        is: (value)=>[
                "04",
                "06",
                "09",
                "11"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/^(?:^0[1-9]|[1-2][0-9]|30)$/, "Day is invalid").required("Day is required")
    }).when("month", {
        is: (value)=>[
                "02"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/^(?:^0[1-9]|1[0-9]|2[0-8]|29)$/, "Day is invalid").required("Day is required")
    }).when("month", {
        is: (value)=>[
                "01, 03, 05, 07, 08, 10, 12"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/^(?:^0[1-9]|[1-2][0-9]|30|31)$/, "Day is invalid").required("Day is required")
    }),
    year: (0,es.string)().when("form_name", {
        is: (value)=>[
                "financial-services"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/^(192[4-9]|19[3-9]\d|200[0-5])$/, "Year is required")
    }),
    agreement_or_reg_num: (0,es.string)().when("form_name", {
        is: (value)=>[
                "financial-services"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/(^[a-zA-Z0-9]{1,4}\s?[a-zA-Z0-9]{1,3}$)|(^[\w]{1,12}$)/, "Please insert a valid Agreement number or Vehicle registration")
    }),
    urn: (0,es.string)().when("form_name", {
        is: (value)=>[
                "roadside-assistance"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/^[\d]{1,10}$/, "Membership number is required")
    }),
    type_of_enquiry: (0,es.string)().when("form_name", {
        is: (value)=>![
                "fleet-services"
            ].includes(value),
        then: (rule)=>rule.required("Type of enquiry is required").trim()
    }),
    address_line1: (0,es.string)().trim(),
    address_line2: (0,es.string)().trim(),
    town: (0,es.string)().trim(),
    county: (0,es.string)().trim(),
    postcode: (0,es.string)().when("form_name", {
        is: (value)=>[
                "financial-services",
                "fleet-services"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode").required("Postcode is required")
    }),
    tel: (0,es.string)().when("form_name", {
        is: (value)=>[
                "financial-services",
                "fleet-services"
            ].includes(value),
        then: (rule)=>rule.required("Please enter a telephone number").matches(/^\d{7,11}$/, {
                message: "Please enter a valid telephone number",
                excludeEmptyString: true
            }).trim()
    }),
    mobile_number: (0,es.string)().trim(),
    additional_info: (0,es.string)().trim(),
    company_name: (0,es.string)().when("form_name", {
        is: (value)=>[
                "fleet-services"
            ].includes(value),
        then: (rule)=>rule.required("Company name is required").trim()
    }),
    enquiry_description: (0,es.string)().when("form_name", {
        is: (value)=>[
                !"fleet-services"
            ].includes(value),
        then: (rule)=>rule.required().trim()
    }),
    dealer_name: (0,es.string)().trim(),
    dealer_id: (0,es.string)().trim(),
    reg_num: (0,es.string)().when("form_name", {
        is: (value)=>[
                "roadside-assistance",
                "multimedia"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/, "Registration number is invalid")
    }),
    fleet_type: (0,es.string)().trim(),
    is_lexus: (0,es.boolean)()
});
/* harmony default export */ var contact_us = (ContactUsSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/contact-us-dealer.ts

const ContactUsDealerSchema = (0,es.object)().shape({
    title: (0,es.string)().trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    dealer: (0,es.string)().required("Please select an option"),
    type_dropdown: (0,es.string)().required("Please select an option"),
    reg_num: (0,es.string)().when("type_dropdown", {
        is: (value)=>[
                "servicing",
                "notlisted_current",
                "parts",
                "repair"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/, {
                message: "Registration number is invalid",
                excludeEmptyString: true
            })
    }),
    model: (0,es.string)().when([
        "type_dropdown"
    ], {
        is: (type)=>type === "new_car",
        then: (rule)=>rule.required("Please select a model")
    }),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var contact_us_dealer = (ContactUsDealerSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/discretionary-commission.ts


const DiscretionaryCommissionSchema = (0,es.object)().shape({
    full_name: (0,es.string)().required("Full name is required").matches(/^[A-Za-z-.,'` ]{1,255}$/, "Full name can only contain letters and basic punctuation").min(2, "Full name must be at least 2 characters").max(255, "Full name must be at most 255 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    dob: (0,es.string)().required("Please enter your date of birth").transform((value)=>{
        if (value) {
            const parts = value.split("/");
            const formattedDate = new Date(parts[2], parts[1] - 1, parts[0]);
            return (0,formatISO/* default */.Z)(formattedDate, {
                representation: "date"
            });
        }
        return value;
    }).test("is-future", "Date of birth cannot be in the future", (value)=>!(0,isFuture/* default */.Z)(value)),
    address_line1: (0,es.string)().required("Address Line 1 is required").trim(),
    address_line2: (0,es.string)().trim(),
    town: (0,es.string)().required("Town is required").trim(),
    county: (0,es.string)().trim(),
    postcode: (0,es.string)().required("Postcode is required").trim().matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode"),
    same_address: (0,es.boolean)().required(),
    prev_address_line1: (0,es.string)().when("same_address", {
        is: (value)=>[
                false
            ].includes(value),
        then: (rule)=>rule.trim().required("Previous Address Line 1 is required")
    }),
    prev_address_line2: (0,es.string)().trim(),
    prev_town: (0,es.string)().when("same_address", {
        is: (value)=>[
                false
            ].includes(value),
        then: (rule)=>rule.trim().required("Previous Town is required")
    }),
    prev_county: (0,es.string)().trim(),
    prev_postcode: (0,es.string)().when("same_address", {
        is: (value)=>[
                false
            ].includes(value),
        then: (rule)=>rule.required("Previous Postcode is required").trim().matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode")
    }),
    reg_num: (0,es.string)().trim(),
    vehicle: (0,es.string)().trim(),
    bought: (0,es.string)().transform((value)=>{
        if (value) {
            const parts = value.split("/");
            const formattedDate = new Date(parts[2], parts[1] - 1, parts[0]);
            return (0,formatISO/* default */.Z)(formattedDate, {
                representation: "date"
            });
        }
        return value;
    }).test("is-future", "Date of birth cannot be in the future", (value)=>!(0,isFuture/* default */.Z)(value)),
    agreement_or_reg_num: (0,es.string)().trim(),
    dealer: (0,es.string)().trim(),
    accept: (0,es.boolean)().oneOf([
        true
    ], "Please confirm you have read, understood and give consent to be emailed")
});
/* harmony default export */ var discretionary_commission = (DiscretionaryCommissionSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/fleet-callback.ts

const FleetCallbackSchema = (0,es.object)().shape({
    title: (0,es.string)().max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    company_name: (0,es.string)().matches(/^[A-Za-z-.,'` ]{0,100}$/, "Company name can only contain letters and basic punctuation").required("Company name is required").max(100, "Company name must be at most 100 characters").trim(),
    company_type: (0,es.string)().required("Please select a number of vehicles").nullable(),
    email: (0,es.string)().required("Email is required").matches(/^([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/, "Email must be a valid email address").max(100).trim(),
    tel: (0,es.string)().required("Phone number is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    postcode: (0,es.string)().required("Postcode is required").matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode").trim(),
    message: (0,es.string)().required("Reason for contact is required").trim(),
    consent: (0,es.boolean)()
});
/* harmony default export */ var fleet_callback = (FleetCallbackSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/get-a-quote.ts

const GetAQuoteSchema = (0,es.object)().shape({
    name: (0,es.string)(),
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    is_lexus: (0,es.boolean)(),
    response_code: (0,es.string)().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var get_a_quote = (GetAQuoteSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/gr-yaris-lottery.ts

const GrYarisLotterySchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    house_number: (0,es.string)().trim(),
    address_line1: (0,es.string)().trim(),
    address_line2: (0,es.string)().trim(),
    town: (0,es.string)().trim(),
    county: (0,es.string)().trim(),
    postcode: (0,es.string)().trim().matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode").required("Postcode is required"),
    time_of_contact: (0,es.string)().trim().required("Please select an option").trim(),
    purchase_interest: (0,es.string)().trim().required("Please select an option").trim(),
    is_lexus: (0,es.boolean)(),
    response_code: (0,es.string)().required().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)(),
        profile: (0,es.boolean)()
    })
});
/* harmony default export */ var gr_yaris_lottery = (GrYarisLotterySchema);

;// CONCATENATED MODULE: ./src/utils/schemas/internal-cans.ts

const InternalCansSchema = (0,es.object)().shape({
    agent: (0,es.string)().required("TGB Common ID is required").matches(/^(?!\s*$)[-a-zA-Z\-.,'\s]+$/, "TGB Common ID can only contain letters and basic punctuation").trim(),
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    customer_cans_consent: (0,es.string)().oneOf([
        "yes"
    ], "Please make the customer aware that their data is being transferred to the Centre"),
    model: (0,es.string)().required("Model is required"),
    type_of_enquiry: (0,es.string)().required("Type of Enquiry is required"),
    current_car_make: (0,es.string)().when("type_of_enquiry", {
        is: (value)=>[
                "Part Exchange"
            ].includes(value),
        then: (rule)=>rule.trim().required("Current Car Make is required")
    }),
    current_car_model: (0,es.string)().when("type_of_enquiry", {
        is: (value)=>[
                "Part Exchange"
            ].includes(value),
        then: (rule)=>rule.trim().required("Current Car Model is required")
    }),
    current_car_reg: (0,es.string)().when("type_of_enquiry", {
        is: (value)=>[
                "Part Exchange"
            ].includes(value),
        then: (rule)=>rule.trim().matches(/(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/, "Current Car Registration is invalid").required("Current Car Registration is required")
    }),
    dealer: (0,es.string)().required("Please select an option"),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    }),
    is_lexus: (0,es.boolean)(),
    user: (0,es.boolean)()
});
/* harmony default export */ var internal_cans = (InternalCansSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kinto/change-number-plate.ts

const KintoChangeNumberPlateSchema = (0,es.object)().shape({
    reg_num: (0,es.string)().required("Current registration number is required").matches(/(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/, "Current registration number is invalid").trim(),
    private_reg_num: (0,es.string)().required("Private registration number is required").matches(/(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/, "Private registration number is invalid").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone number is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    company_name: (0,es.string)().matches(/^[A-Za-z0-9-.,'` ]{0,50}$/, "Company name can only contain letters and basic punctuation").max(50, "Company name must be at most 50 characters").trim(),
    retention_id: (0,es.string)().required("Retention certificate is required").max(50, "Retention certificate must be at most 50 characters").trim(),
    retention_postcode: (0,es.string)().required("Postcode is required").matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode").trim(),
    consent: (0,es.boolean)()
});
/* harmony default export */ var change_number_plate = (KintoChangeNumberPlateSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kinto/contact-us.ts

const KintoContactUsSchema = (0,es.object)().shape({
    enquiry: (0,es.string)().required("Please select your type of enquiry"),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    company_name: (0,es.string)().matches(/^[A-Za-z0-9-.,'` ]{0,50}$/, "Company name can only contain letters and basic punctuation").when("enquiry", {
        is: (value)=>![
                "New Customer"
            ].includes(value),
        then: (rule)=>rule.required("Company name is required").max(50, "Company name must be at most 50 characters").trim()
    }),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone number is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    reg_num: (0,es.string)().trim().matches(/(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/, {
        message: "Registration number is invalid",
        excludeEmptyString: true
    }),
    fleet_size: (0,es.string)().when("enquiry", {
        is: (value)=>[
                "New Customer"
            ].includes(value),
        then: (rule)=>rule.trim().required("Fleet size is required")
    }),
    job_title: (0,es.string)().trim(),
    notes: (0,es.string)().required("Please fill in how we can help").trim(),
    consent: (0,es.boolean)()
});
/* harmony default export */ var kinto_contact_us = (KintoContactUsSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kinto/fleet-exchange.ts

const KintoFleetExchangeSchema = (0,es.object)().shape({
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    company_name: (0,es.string)().matches(/^[A-Za-z0-9-.,'` ]{0,50}$/, "Company name can only contain letters and basic punctuation").max(50, "Company name must be at most 50 characters").trim(),
    consent: (0,es.boolean)()
});
/* harmony default export */ var fleet_exchange = (KintoFleetExchangeSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kinto/get-a-quote.ts

const KintoBchRequestACallbackSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(30, "First name must be at most 30 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(30, "Last name must be at most 30 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    company_name: (0,es.string)().trim(),
    brand: (0,es.string)().required().trim(),
    model: (0,es.string)().required("Please select a model").trim(),
    dealer: (0,es.string)().trim(),
    consent: (0,es.boolean)(),
    response_code: (0,es.string)().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    is_lexus: (0,es.boolean)(),
    utm_source: (0,es.string)(),
    utm_medium: (0,es.string)(),
    utm_campaign: (0,es.string)(),
    utm_content: (0,es.string)(),
    utm_term: (0,es.string)(),
    utm_placement: (0,es.string)(),
    utm_id: (0,es.string)()
});
/* harmony default export */ var kinto_get_a_quote = (KintoBchRequestACallbackSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kinto/remove-number-plate/online.ts

const KintoRemoveNumberPlateOnlineSchema = (0,es.object)().shape({
    private_reg_num: (0,es.string)().required("Private (cherished) registration number is required").matches(/(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/, "Private (cherished) registration number is invalid").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone number is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    company_name: (0,es.string)().matches(/^[A-Za-z0-9-.,'` ]{0,50}$/, "Company name can only contain letters and basic punctuation").max(50, "Company name must be at most 50 characters").trim(),
    address_line1: (0,es.string)().required("Address Line 1 is required").trim(),
    address_line2: (0,es.string)().trim(),
    town: (0,es.string)().required("Town/City is required").trim(),
    county: (0,es.string)().trim(),
    postcode: (0,es.string)().required("Postcode is required").matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode").trim(),
    consent: (0,es.boolean)()
});
/* harmony default export */ var online = (KintoRemoveNumberPlateOnlineSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kinto/remove-number-plate/postal.ts

const KintoRemoveNumberPlatePostalSchema = (0,es.object)().shape({
    private_reg_num: (0,es.string)().required("Private (cherished) registration number is required").matches(/(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/, "Private (cherished) registration number is invalid").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone number is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    company_name: (0,es.string)().matches(/^[A-Za-z0-9-.,'` ]{0,50}$/, "Company name can only contain letters and basic punctuation").max(50, "Company name must be at most 50 characters").trim(),
    grantee_first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    grantee_last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    grantee_address_line1: (0,es.string)().required("Address Line 1 is required").trim(),
    grantee_address_line2: (0,es.string)().trim(),
    grantee_town: (0,es.string)().required("Town/City is required").trim(),
    grantee_county: (0,es.string)().trim(),
    grantee_postcode: (0,es.string)().required("Postcode is required").matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode").trim(),
    nominee_first_name: (0,es.string)().matches(/^[A-Za-z-.,'` ]{1,50}$/, {
        message: "First name can only contain letters and basic punctuation",
        excludeEmptyString: true
    }).trim(),
    nominee_last_name: (0,es.string)().matches(/^[A-Za-z-.,'` ]{1,50}$/, {
        message: "Last name can only contain letters and basic punctuation",
        excludeEmptyString: true
    }).trim(),
    consent: (0,es.boolean)()
});
/* harmony default export */ var postal = (KintoRemoveNumberPlatePostalSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kinto/service-booking/existing.ts

const KintoExistingServiceBookingSchema = (0,es.object)().shape({
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    company_name: (0,es.string)().matches(/^[A-Za-z0-9-.,'` ]{0,50}$/, "Company name can only contain letters and basic punctuation").required("Company name is required").max(50, "Company name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone number is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    booking_ref: (0,es.string)().required("Booking reference number is required").trim(),
    notes: (0,es.string)().required("Please fill in how we can help").trim(),
    consent: (0,es.boolean)()
});
/* harmony default export */ var existing = (KintoExistingServiceBookingSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kinto/service-booking/new.ts

const KintoNewServiceBookingSchema = (0,es.object)().shape({
    reg_num: (0,es.string)().required("Vehicle registration number is required").matches(/(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/, "Vehicle registration number is invalid").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters"),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone number is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    office_tel: (0,es.string)().matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    address_line1: (0,es.string)().required("Address Line 1 is required").trim(),
    address_line2: (0,es.string)().trim(),
    town: (0,es.string)().required("Town/City is required").trim(),
    county: (0,es.string)().trim(),
    postcode: (0,es.string)().required("Postcode is required").matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode").trim(),
    notes: (0,es.string)().required("Please tell us what work is required").trim(),
    date_input: (0,es.date)().required("Please select a date"),
    servicing_dates_unavailable: (0,es.string)().trim(),
    mileage: (0,es.number)().transform((value)=>Number.isNaN(value) ? undefined : value).nullable().required("Mileage is required"),
    additional_requirements: (0,es.string)().required("Please select an option").trim(),
    consent: (0,es.boolean)()
});
/* harmony default export */ var service_booking_new = (KintoNewServiceBookingSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kinto/used-cars.ts

const KintoUsedCarsSchema = (0,es.object)().shape({
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone number is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    type_of_enquiry: (0,es.string)().required("Please select an enquiry type").trim(),
    reg_number: (0,es.string)().matches(/^(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}[A-Z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)|^$/, "Please enter a valid UK vehicle registration number").uppercase().trim(),
    mileage: (0,es.string)(),
    notes: (0,es.string)().required("Please ask a question").trim(),
    consent: (0,es.boolean)()
});
/* harmony default export */ var used_cars = (KintoUsedCarsSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kinto-request-a-callback.ts

const KintoRequestACallbackSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(30, "First name must be at most 30 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(30, "Last name must be at most 30 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    company_name: (0,es.string)().trim(),
    model: (0,es.string)().required("Please select a model").trim(),
    dealer: (0,es.string)().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    }),
    response_code: (0,es.string)().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    is_lexus: (0,es.boolean)(),
    utm_source: (0,es.string)(),
    utm_medium: (0,es.string)(),
    utm_campaign: (0,es.string)(),
    utm_content: (0,es.string)(),
    utm_term: (0,es.string)(),
    utm_placement: (0,es.string)(),
    utm_id: (0,es.string)()
});
/* harmony default export */ var kinto_request_a_callback = (KintoRequestACallbackSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/kmi.ts
const KmiSchema = [
    {
        id: "title",
        validationType: "string",
        field: "Title",
        validations: [
            {
                type: "required",
                params: [
                    "Title is required"
                ]
            }
        ]
    },
    {
        id: "first_name",
        validationType: "string",
        field: "FirstName",
        validations: [
            {
                type: "required",
                params: [
                    "First name is required"
                ]
            },
            {
                type: "min",
                params: [
                    2,
                    "First name must be at least 2 characters"
                ]
            },
            {
                type: "max",
                params: [
                    50,
                    "First name must be at most 50 characters"
                ]
            },
            {
                type: "matches",
                params: [
                    /^[A-Za-z-.,'` ]{1,50}$/,
                    "First name can only contain letters and basic punctuation"
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "last_name",
        validationType: "string",
        field: "LastName",
        validations: [
            {
                type: "required",
                params: [
                    "Last name is required"
                ]
            },
            {
                type: "min",
                params: [
                    2,
                    "Last name must be at least 2 characters"
                ]
            },
            {
                type: "max",
                params: [
                    50,
                    "Last name must be at most 50 characters"
                ]
            },
            {
                type: "matches",
                params: [
                    /^[A-Za-z-.,'` ]{1,50}$/,
                    "First name can only contain letters and basic punctuation"
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "email",
        validationType: "string",
        field: "Email",
        validations: [
            {
                type: "required",
                params: [
                    "Email is required"
                ]
            },
            {
                type: "matches",
                params: [
                    /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
                    "Email must be a valid email address"
                ]
            },
            {
                type: "max",
                params: [
                    255
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "tel",
        validationType: "string",
        field: "Tel",
        validations: [
            {
                type: "required",
                params: [
                    "Phone is required"
                ]
            },
            {
                type: "matches",
                params: [
                    /^\d{7,11}$/,
                    {
                        message: "Please enter a valid telephone number",
                        excludeEmptyString: true
                    }
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "tel_optional",
        validationType: "string",
        field: "Tel_optional",
        validations: [
            {
                type: "matches",
                params: [
                    /^\d{7,11}$/,
                    {
                        message: "Please enter a valid telephone number",
                        excludeEmptyString: true
                    }
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "model",
        field: "Models",
        validationType: "string",
        validations: [
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "dealer",
        field: "Dealer",
        validationType: "string",
        validations: [
            {
                type: "when",
                params: [
                    "pvt_company_car",
                    {
                        is: (value)=>[
                                "Private",
                                "Company"
                            ].includes(value),
                        then: (schema)=>schema.required("Dealer is required")
                    }
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "postcode",
        field: "Postcode",
        validationType: "string",
        validations: [
            {
                type: "when",
                params: [
                    "pvt_company_car",
                    {
                        is: (value)=>[
                                "Fleet"
                            ].includes(value),
                        then: (schema)=>schema.required("Postcode is required")
                    }
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "pvt_company_car",
        validationType: "string",
        field: "PrivateOrCompanyCar",
        validations: [
            {
                type: "trim",
                params: []
            },
            {
                type: "required",
                params: [
                    "Please select an option"
                ]
            },
            {
                type: "nullable",
                params: []
            }
        ]
    },
    {
        id: "notes",
        validationType: "string",
        field: "ContactMirai",
        validations: [
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "response_code",
        validationType: "string",
        validations: [
            {
                type: "uppercase",
                params: []
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "campaign_code",
        validationType: "string",
        validations: [
            {
                type: "uppercase",
                params: []
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "campaign_response_code",
        validationType: "string",
        validations: [
            {
                type: "uppercase",
                params: []
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "is_dealer",
        validationType: "boolean",
        validations: []
    },
    {
        id: "is_lexus",
        validationType: "boolean",
        validations: []
    }
];
/* harmony default export */ var kmi = (KmiSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/marketing-preferences.ts

const MarketingPreferencesSchema = (0,es.object)().shape({
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    is_lexus: (0,es.boolean)(),
    response_code: (0,es.string)().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    communication_relevantoffers: (0,es.boolean)().required(),
    contact_phone: (0,es.boolean)().required(),
    contact_email: (0,es.boolean)().required(),
    contact_sms: (0,es.boolean)().required(),
    contact_post: (0,es.boolean)().required(),
    agreement_or_reg_num: (0,es.string)().required("Agreement / Proposal Number  is required").matches(/^[\w]{1,12}$/, "Please enter your agreement / proposal number")
});
/* harmony default export */ var marketing_preferences = (MarketingPreferencesSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/newsletter.ts

const NewsletterSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(30, "First name must be at most 30 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(30, "Last name must be at most 30 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    response_code: (0,es.string)().uppercase().trim(),
    model: (0,es.string)().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    toyota_owner: (0,es.boolean)().required(),
    reg_number: (0,es.string)().matches(/^(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}[A-Z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)|^$/, "Please enter a valid UK Vehicle Registration Number").trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var newsletter = (NewsletterSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/newsletter-fleet.ts

const FleetNewsletterSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    company_name: (0,es.string)().matches(/^[A-Za-z-.,'` ]{0,100}$/, "Company name can only contain letters and basic punctuation").max(100, "Company name must be at most 100 characters").required("Company name is required").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/, "Email must be a valid email address").max(100).trim(),
    postcode: (0,es.string)().required("Postcode is required").matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode").trim(),
    consent: (0,es.boolean)()
});
/* harmony default export */ var newsletter_fleet = (FleetNewsletterSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/parts-accessories.ts

const PartsAccessoriesSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    notes: (0,es.string)().trim(),
    is_lexus: (0,es.boolean)(),
    response_code: (0,es.string)().required().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    }),
    dealer_name: (0,es.string)(),
    dealer: (0,es.string)().required("Please select an option")
});
/* harmony default export */ var parts_accessories = (PartsAccessoriesSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/power-of-choice.ts

const PowerOfChoiceSchema = (0,es.object)().shape({
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    dealer: (0,es.string)().required("Please select an option"),
    model: (0,es.string)().required("Please select a Model of interest"),
    is_owner: (0,es.boolean)().required(),
    is_lexus: (0,es.boolean)(),
    response_code: (0,es.string)().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var power_of_choice = (PowerOfChoiceSchema);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isDate/index.js
var isDate = __webpack_require__(72561);
;// CONCATENATED MODULE: ./src/utils/schemas/pre-approval.ts


const addPrefix = (obj, prefix)=>{
    const newObj = {};
    Object.keys(obj).forEach((key)=>{
        newObj["".concat(prefix).concat(key)] = obj[key];
    });
    return newObj;
};
const addressValidation = (prefix, formStep, total)=>{
    const address = {
        address_line1: (0,es.string)().when([
            "step",
            "total_addresses"
        ], {
            is: (step, total_addresses)=>step === formStep && total_addresses >= total,
            then: (0,es.string)().required("Address line 1 is required").matches(/^[a-zA-Z0-9 @&.,~_-]{1,60}$/, "Address line 1 can only contain letters and basic punctuation").max(60, "Address line 1 must be at most 60 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        address_line2: (0,es.string)().when([
            "step",
            "total_addresses"
        ], {
            is: (step, total_addresses)=>step === formStep && total_addresses >= total,
            then: (0,es.string)().matches(/^[a-zA-Z0-9 @&.,~_-]{0,40}$/, "Address line 2 can only contain letters and basic punctuation").max(40, "Address line 2 must be at most 40 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        town: (0,es.string)().when([
            "step",
            "total_addresses"
        ], {
            is: (step, total_addresses)=>step === formStep && total_addresses >= total,
            then: (0,es.string)().required("Town is required").matches(/^[a-zA-Z0-9 @&.,~_-]{1,40}$/, "Town can only contain letters and basic punctuation").max(40, "Town must be at most 40 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        county: (0,es.string)().when([
            "step",
            "total_addresses"
        ], {
            is: (step, total_addresses)=>step === formStep && total_addresses >= total,
            then: (0,es.string)().matches(/^[a-zA-Z0-9 @&.,~_-]{0,40}$/, "County can only contain letters and basic punctuation").max(40, "County must be at most 40 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        postcode: (0,es.string)().when([
            "step",
            "total_addresses"
        ], {
            is: (step, total_addresses)=>step === formStep && total_addresses >= total,
            then: (0,es.string)().required("Postcode is required").matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Please enter a valid postcode").max(8, "Postcode must be at most 8 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        years: (0,es.string)().when([
            "step",
            "total_addresses"
        ], {
            is: (step, total_addresses)=>step === formStep && total_addresses >= total,
            then: (0,es.string)().required("Years is required").matches(/^[0-9]{1,2}$/, "Years must be a number").test("years", "Years must be at least 0", (value)=>{
                return parseInt(value, 10) >= 0;
            }).test("years", "Years must be at most 99", (value)=>{
                return parseInt(value, 10) <= 99;
            }).max(2, "Years must be at most 2 characters"),
            otherwise: (0,es.string)().trim()
        }),
        months: (0,es.string)().when([
            "step",
            "total_addresses"
        ], {
            is: (step, total_addresses)=>step === formStep && total_addresses >= total,
            then: (0,es.string)().required("Months is required").matches(/^[0-9]{1,2}$/, "Months must be a number").test("months", "Months must be at least 0", (value)=>{
                return parseInt(value, 10) >= 0;
            }).test("months", "Months must be at most 11", (value)=>{
                return parseInt(value, 10) <= 11;
            }).max(2, "Months must be at most 2 characters"),
            otherwise: (0,es.string)().trim()
        })
    };
    return addPrefix(address, prefix);
};
const employerValidation = (prefix, formStep, total)=>{
    const employer = {
        employment_type: (0,es.string)().when([
            "step",
            "total_employers"
        ], {
            is: (step, total_employers)=>step === formStep && total_employers >= total,
            then: (0,es.string)().required("Employment type is required").trim(),
            otherwise: (0,es.string)().trim()
        }),
        employment_status: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().required("Employment status is required").trim(),
            otherwise: (0,es.string)().trim()
        }),
        occupation: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().required("Occupation is required").trim(),
            otherwise: (0,es.string)().trim()
        }),
        job_title: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().required("Job title is required").matches(/^[a-zA-Z0-9 @&.,~_-]{1,40}$/, "Job title can only contain letters and basic punctuation").max(40, "Job title must be at most 40 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        employer: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().required("Employer is required").matches(/^[a-zA-Z0-9 @&.,~_-]{1,40}$/, "Employer can only contain letters and basic punctuation").max(40, "Employer must be at most 40 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        employer_address_line1: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().required("Address line 1 is required").matches(/^[a-zA-Z0-9 @&.,~_-]{1,60}$/, "Address line 1 can only contain letters and basic punctuation").max(60, "Address line 1 must be at most 60 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        employer_address_line2: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().matches(/^[a-zA-Z0-9 @&.,~_-]{0,40}$/, "Address line 2 can only contain letters and basic punctuation").max(40, "Address line 2 must be at most 40 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        employer_town: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().required("Town is required").matches(/^[a-zA-Z0-9 @&.,~_-]{1,40}$/, "Town can only contain letters and basic punctuation").max(40, "Town must be at most 40 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        employer_county: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().matches(/^[a-zA-Z0-9 @&.,~_-]{0,40}$/, "County can only contain letters and basic punctuation").max(40, "County must be at most 40 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        employer_postcode: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().required("Postcode is required").matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Please enter a valid postcode").max(8, "Postcode must be at most 8 characters").trim(),
            otherwise: (0,es.string)().trim()
        }),
        employer_years: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().required("Years is required").matches(/^[0-9]{1,2}$/, "Years must be a number").test("years", "Years must be at least 0", (value)=>{
                return parseInt(value, 10) >= 0;
            }).test("years", "Years must be at most 99", (value)=>{
                return parseInt(value, 10) <= 99;
            }).max(2, "Years must be at most 2 characters"),
            otherwise: (0,es.string)().trim()
        }),
        employer_months: (0,es.string)().when([
            "step",
            "total_employers",
            "".concat(prefix, "employment_type")
        ], {
            is: (step, total_employers, employment_type)=>step === formStep && total_employers >= total && [
                    "1",
                    "3",
                    "5"
                ].some((value)=>employment_type.includes(value)),
            then: (0,es.string)().required("Months is required").matches(/^[0-9]{1,2}$/, "Months must be a number").test("months", "Months must be at least 0", (value)=>{
                return parseInt(value, 10) >= 0;
            }).test("months", "Months must be at most 11", (value)=>{
                return parseInt(value, 10) <= 11;
            }).max(2, "Months must be at most 2 characters"),
            otherwise: (0,es.string)().trim()
        })
    };
    return addPrefix(employer, prefix);
};
const PreApprovalSchema = (0,es.object)().shape({
    step: (0,es.number)(),
    dealer: (0,es.number)(),
    dealer_name: (0,es.string)().trim(),
    title: (0,es.string)().when("step", {
        is: 2,
        then: (0,es.string)().required("Title is required").trim(),
        otherwise: (0,es.string)().trim()
    }),
    first_name: (0,es.string)().when("step", {
        is: 2,
        then: (0,es.string)().required("First name is required").matches(/^[a-zA-Z0-9 @&.,~_-]{1,40}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(40, "First name must be at most 40 characters").trim(),
        otherwise: (0,es.string)().trim()
    }),
    last_name: (0,es.string)().when("step", {
        is: 2,
        then: (0,es.string)().required("Last name is required").matches(/^[a-zA-Z0-9 @&.,~_-]{1,30}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(30, "Last name must be at most 30 characters").trim(),
        otherwise: (0,es.string)().trim()
    }),
    email: (0,es.string)().when("step", {
        is: 2,
        then: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(60, "Email must be at most 60 characters").transform((value)=>value.replace("&", "")).trim(),
        otherwise: (0,es.string)().trim()
    }),
    tel: (0,es.string)().when("step", {
        is: 2,
        then: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
            message: "Please enter a valid mobile phone number",
            excludeEmptyString: true
        }).trim(),
        otherwise: (0,es.string)().trim()
    }),
    home_tel: (0,es.string)().when("step", {
        is: 2,
        then: (0,es.string)().matches(/^\d{7,11}$/, {
            message: "Please enter a valid home phone number",
            excludeEmptyString: true
        }).trim(),
        otherwise: (0,es.string)().trim()
    }),
    dob: (0,es.string)().when("step", {
        is: 2,
        then: (0,es.string)().required("Please enter your date of birth").test("is-future", "Date of birth cannot be in the future", (value)=>!(0,isFuture/* default */.Z)((0,parseISO["default"])(value))).test("is-date", "Please enter a valid date of birth", (value)=>(0,isDate["default"])((0,parseISO["default"])(value))).test("is-adult", "You must be at least 18 years old", (value)=>{
            const dob = (0,parseISO["default"])(value);
            const now = new Date();
            const age = now.getFullYear() - dob.getFullYear();
            return age >= 18;
        }).test("is-not-too-old", "You must be at most 99 years old", (value)=>{
            const dob = (0,parseISO["default"])(value);
            const now = new Date();
            const age = now.getFullYear() - dob.getFullYear();
            return age <= 99;
        }).transform((value)=>{
            if (value) {
                const parts = value.split("/");
                const formattedDate = new Date(parts[2], parts[1] - 1, parts[0]);
                return (0,formatISO/* default */.Z)(formattedDate, {
                    representation: "date"
                });
            }
            return value;
        }),
        otherwise: (0,es.string)().trim()
    }),
    gender: (0,es.string)().when("step", {
        is: 2,
        then: (0,es.string)().required("Please select a gender").trim(),
        otherwise: (0,es.string)().trim()
    }),
    marital: (0,es.string)().when("step", {
        is: 2,
        then: (0,es.string)().required("Please select a marital status").trim(),
        otherwise: (0,es.string)().trim()
    }),
    residence: (0,es.string)().when("step", {
        is: 2,
        then: (0,es.string)().required("Please select a residential status").trim(),
        otherwise: (0,es.string)().trim()
    }),
    ...addressValidation("", 3, 1),
    ...addressValidation("second_", 3, 2),
    ...addressValidation("third_", 3, 3),
    ...employerValidation("", 4, 1),
    ...employerValidation("second_", 4, 2),
    privacy_notice: (0,es.string)().when("step", {
        is: 5,
        then: (0,es.string)().required("Please accept the privacy notice").trim(),
        otherwise: (0,es.string)().trim()
    }),
    my_toyota: (0,es.string)().trim(),
    communication_reminders: (0,es.string)().when("step", {
        is: 5,
        then: (0,es.string)().required("Please accept communication reminders").trim(),
        otherwise: (0,es.string)().trim()
    }),
    communication_relevantoffers: (0,es.string)().when("step", {
        is: 5,
        then: (0,es.string)().required("Please accept communication reminders").trim(),
        otherwise: (0,es.string)().trim()
    }),
    communication_surveys: (0,es.string)().when("step", {
        is: 5,
        then: (0,es.string)().required("Please accept communication reminders").trim(),
        otherwise: (0,es.string)().trim()
    }),
    communication_events: (0,es.string)().when("step", {
        is: 5,
        then: (0,es.string)().required("Please accept communication reminders").trim(),
        otherwise: (0,es.string)().trim()
    }),
    contact_phone: (0,es.string)().when("step", {
        is: 5,
        then: (0,es.string)().required("Please accept communication reminders").trim(),
        otherwise: (0,es.string)().trim()
    }),
    contact_email: (0,es.string)().when("step", {
        is: 5,
        then: (0,es.string)().required("Please accept communication reminders").trim(),
        otherwise: (0,es.string)().trim()
    }),
    contact_sms: (0,es.string)().when("step", {
        is: 5,
        then: (0,es.string)().required("Please accept communication reminders").trim(),
        otherwise: (0,es.string)().trim()
    }),
    contact_post: (0,es.string)().when("step", {
        is: 5,
        then: (0,es.string)().required("Please accept communication reminders").trim(),
        otherwise: (0,es.string)().trim()
    }),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var pre_approval = (PreApprovalSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/prize-draw/index.ts

const PrizeDrawSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    is_lexus: (0,es.boolean)(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var prize_draw = ((/* unused pure expression or super */ null && (PrizeDrawSchema)));

;// CONCATENATED MODULE: ./src/utils/schemas/prize-draw/cms.ts
const PrizeDrawCmsSchema = [
    {
        id: "title",
        validationType: "string",
        field: "Title",
        validations: [
            {
                type: "required",
                params: [
                    "Title is required"
                ]
            }
        ]
    },
    {
        id: "first_name",
        validationType: "string",
        field: "FirstName",
        validations: [
            {
                type: "required",
                params: [
                    "First name is required"
                ]
            },
            {
                type: "min",
                params: [
                    2,
                    "First name must be at least 2 characters"
                ]
            },
            {
                type: "max",
                params: [
                    50,
                    "First name must be at most 50 characters"
                ]
            },
            {
                type: "matches",
                params: [
                    /^[A-Za-z-.,'` ]{1,50}$/,
                    "First name can only contain letters and basic punctuation"
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "last_name",
        validationType: "string",
        field: "LastName",
        validations: [
            {
                type: "required",
                params: [
                    "Last name is required"
                ]
            },
            {
                type: "min",
                params: [
                    2,
                    "Last name must be at least 2 characters"
                ]
            },
            {
                type: "max",
                params: [
                    50,
                    "Last name must be at most 50 characters"
                ]
            },
            {
                type: "matches",
                params: [
                    /^[A-Za-z-.,'` ]{1,50}$/,
                    "First name can only contain letters and basic punctuation"
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "email",
        validationType: "string",
        field: "Email",
        validations: [
            {
                type: "required",
                params: [
                    "Email is required"
                ]
            },
            {
                type: "matches",
                params: [
                    /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
                    "Email must be a valid email address"
                ]
            },
            {
                type: "max",
                params: [
                    255
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "tel",
        validationType: "string",
        field: "Tel",
        validations: [
            {
                type: "required",
                params: [
                    "Phone is required"
                ]
            },
            {
                type: "matches",
                params: [
                    /^\d{7,11}$/,
                    {
                        message: "Please enter a valid telephone number",
                        excludeEmptyString: true
                    }
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "tel_optional",
        validationType: "string",
        field: "Tel_optional",
        validations: [
            {
                type: "matches",
                params: [
                    /^\d{7,11}$/,
                    {
                        message: "Please enter a valid telephone number",
                        excludeEmptyString: true
                    }
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "preference",
        validationType: "string",
        field: "DropDown",
        validations: [
            {
                type: "required",
                params: [
                    "Please select an option"
                ]
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "response_code",
        validationType: "string",
        validations: [
            {
                type: "uppercase",
                params: []
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "campaign_code",
        validationType: "string",
        validations: [
            {
                type: "uppercase",
                params: []
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "campaign_response_code",
        validationType: "string",
        validations: [
            {
                type: "uppercase",
                params: []
            },
            {
                type: "trim",
                params: []
            }
        ]
    },
    {
        id: "is_lexus",
        validationType: "boolean",
        validations: []
    }
];
/* harmony default export */ var cms = (PrizeDrawCmsSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/prize-draw/dunlop-limited-edition-racket.ts

const DunlopPrizeDrawSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    is_lexus: (0,es.boolean)(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var dunlop_limited_edition_racket = ((/* unused pure expression or super */ null && (DunlopPrizeDrawSchema)));

;// CONCATENATED MODULE: ./src/utils/schemas/prize-draw/golf-masterclass.ts

const GolfPrizeDrawSchema = (0,es.object)().shape({
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    tel: (0,es.string)().required("Phone number is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    house_number: (0,es.string)().trim(),
    address_line1: (0,es.string)().trim(),
    address_line2: (0,es.string)().trim(),
    town: (0,es.string)().trim(),
    county: (0,es.string)().trim(),
    postcode: (0,es.string)().trim().matches(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/, "Postcode must be a valid UK postcode").required("Postcode is required"),
    preference: (0,es.string)().trim().required("Please select an option").trim(),
    plus_one: (0,es.string)().required(),
    handicap: (0,es.string)().trim().required("Your handicap is required. If you don't have one, please enter unknown"),
    is_lexus: (0,es.boolean)(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var golf_masterclass = (GolfPrizeDrawSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/prize-draw/golf-masterclass-locations.ts

const GolfLocationsPrizeDrawSchema = (0,es.object)().shape({
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    tel: (0,es.string)().required("Phone number is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    plus_one: (0,es.boolean)().required(),
    dietary_requirements: (0,es.string)().trim(),
    guest_first_name: (0,es.string)().when("plus_one", {
        is: (value)=>[
                true
            ].includes(value),
        then: (rule)=>rule.required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim()
    }),
    guest_last_name: (0,es.string)().when("plus_one", {
        is: (value)=>[
                true
            ].includes(value),
        then: (rule)=>rule.required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim()
    }),
    guest_driving: (0,es.string)().when("plus_one", {
        is: (value)=>[
                true
            ].includes(value),
        then: (rule)=>rule.required()
    }),
    guest_reg: (0,es.string)().trim(),
    guest_vehicle_make: (0,es.string)().trim(),
    guest_vehicle_model: (0,es.string)().trim(),
    guest_dietary_requirements: (0,es.string)().trim(),
    is_lexus: (0,es.boolean)(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)(),
        profile: (0,es.boolean)()
    })
});
/* harmony default export */ var golf_masterclass_locations = (GolfLocationsPrizeDrawSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/prize-draw/solus.ts

const SolusSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    tel: (0,es.string)().matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    preference: (0,es.string)().trim().required("Please select an option").trim(),
    is_lexus: (0,es.boolean)(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var solus = ((/* unused pure expression or super */ null && (SolusSchema)));

;// CONCATENATED MODULE: ./src/utils/schemas/rcc-preferences.ts

const RccPreferencesSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    is_lexus: (0,es.boolean)(),
    response_code: (0,es.string)().required().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var rcc_preferences = (RccPreferencesSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/request-a-callback.ts

const RequestACallbackSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    is_lexus: (0,es.boolean)(),
    dealer: (0,es.string)().required("Please select an option"),
    type_of_enquiry: (0,es.string)().required("Please select what you're interested in"),
    response_code: (0,es.string)().required().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var request_a_callback = (RequestACallbackSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/reserve.ts

const ReserveSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(30, "First name must be at most 30 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(30, "Last name must be at most 30 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    response_code: (0,es.string)().uppercase().trim(),
    model: (0,es.string)().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    dealer: (0,es.number)(),
    dealer_name: (0,es.string)().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var reserve = (ReserveSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/reserve-lbx.ts

const ReserveLbxSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(30, "First name must be at most 30 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(30, "Last name must be at most 30 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    grade: (0,es.string)().required("Please select an option").trim(),
    colours: (0,es.string)().required("Please select an option").trim(),
    response_code: (0,es.string)().uppercase().trim(),
    model: (0,es.string)().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    dealer: (0,es.number)(),
    dealer_name: (0,es.string)().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var reserve_lbx = (ReserveLbxSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/stock-car-enquiry-schema.ts

const StockCarEnquirySchema = (0,es.object)().shape({
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    notes: (0,es.string)(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    dealer: (0,es.string)(),
    model: (0,es.string)(),
    is_lexus: (0,es.boolean)(),
    response_code: (0,es.string)().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var stock_car_enquiry_schema = (StockCarEnquirySchema);

;// CONCATENATED MODULE: ./src/utils/schemas/test-drive.ts

const TestDriveSchema = (0,es.object)().shape({
    title: (0,es.string)().trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    model: (0,es.string)().required().trim(),
    date: (0,es.string)().trim(),
    time: (0,es.string)().trim(),
    notes: (0,es.string)().trim(),
    testdrive_type: (0,es.string)().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    }),
    response_code: (0,es.string)().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    crm_response_source: (0,es.string)().trim(),
    is_dealer: (0,es.boolean)(),
    dealer: (0,es.number)(),
    dealer_name: (0,es.string)().trim(),
    is_lexus: (0,es.boolean)()
});
/* harmony default export */ var test_drive = (TestDriveSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/toyota-chr.ts

const ToyotaChrSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").min(1, "Title must be at least 2 characters").max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(30, "First name must be at most 30 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,30}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(30, "Last name must be at most 30 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    type: (0,es.string)(),
    notes: (0,es.string)(),
    grade: (0,es.string)().required("Please select an option").trim(),
    powertrain: (0,es.string)().required("Please select an option").trim(),
    model: (0,es.string)().required("Please select an option").trim(),
    response_code: (0,es.string)().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    dealer: (0,es.number)(),
    dealer_name: (0,es.string)().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var toyota_chr = ((/* unused pure expression or super */ null && (ToyotaChrSchema)));

;// CONCATENATED MODULE: ./src/utils/schemas/toyota-thon.ts

const ToyotaThonSchema = (0,es.object)().shape({
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    dealer: (0,es.string)().required("Please select an option"),
    model: (0,es.string)().required("Please select a Model of interest"),
    is_owner: (0,es.boolean)().required(),
    part_exchange: (0,es.boolean)().required(),
    is_lexus: (0,es.boolean)(),
    response_code: (0,es.string)().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    })
});
/* harmony default export */ var toyota_thon = (ToyotaThonSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/uber.ts

const UberOfferSchema = (0,es.object)().shape({
    title: (0,es.string)().max(10, "Title must be at most 10 characters").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/, "Email must be a valid email address").max(100).trim(),
    tel: (0,es.string)().required("Phone is required").matches(/^[+?\d ]{0,11}$/, "Phone number must be a valid phone number").max(11, "Phone number must be at most 11 characters").trim(),
    consent: (0,es.boolean)(),
    address_line1: (0,es.string)().required("Address line 1 is required").max(100, "Address line 1 must be at most 100 characters").trim(),
    address_line2: (0,es.string)().max(100, "Address line 2 must be at most 100 characters").trim(),
    town: (0,es.string)().required("Town/City is required").max(50, "Town must be at most 50 characters").trim(),
    county: (0,es.string)().max(50, "County must be at most 50 characters").trim(),
    postcode: (0,es.string)().required("Postcode is required").max(20, "Postcode must be at most 20 characters").trim()
});
/* harmony default export */ var uber = (UberOfferSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/unsubscribe.ts

const UnsubscribeSchema = (0,es.object)().shape({
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    is_lexus: (0,es.boolean)(),
    response_code: (0,es.string)().required().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim()
});
/* harmony default export */ var unsubscribe = (UnsubscribeSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/used-car-enquiry.ts

const UsedCarSchema = (0,es.object)().shape({
    title: (0,es.string)().required("Title is required").trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    reg_number: (0,es.string)().matches(/^(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}[A-Z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)|^$/, "Please enter a valid UK vehicle registration number").uppercase().trim(),
    mileage: (0,es.string)(),
    notes: (0,es.string)().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    }),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    is_lexus: (0,es.string)(),
    is_cans: (0,es.boolean)()
});
/* harmony default export */ var used_car_enquiry = (UsedCarSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/video-consultation.ts

const VideoConsultationSchema = (0,es.object)().shape({
    title: (0,es.string)().trim(),
    first_name: (0,es.string)().required("First name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "First name can only contain letters and basic punctuation").min(2, "First name must be at least 2 characters").max(50, "First name must be at most 50 characters").trim(),
    last_name: (0,es.string)().required("Last name is required").matches(/^[A-Za-z-.,'` ]{1,50}$/, "Last name can only contain letters and basic punctuation").min(2, "Last name must be at least 2 characters").max(50, "Last name must be at most 50 characters").trim(),
    email: (0,es.string)().required("Email is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/, "Email must be a valid email address").max(255).trim(),
    tel: (0,es.string)().matches(/^\d{7,11}$/, {
        message: "Please enter a valid telephone number",
        excludeEmptyString: true
    }).trim(),
    model: (0,es.string)().required("Model is a required field").trim(),
    date_input: (0,es.string)().required("Date and time are required").trim(),
    time: (0,es.string)().required("").trim(),
    notes: (0,es.string)().trim(),
    type: (0,es.string)().trim(),
    consent: (0,es.object)({
        user: (0,es.boolean)()
    }),
    response_code: (0,es.string)().uppercase().trim(),
    campaign_response_code: (0,es.string)().uppercase().trim(),
    campaign_code: (0,es.string)().uppercase().trim(),
    crm_response_source: (0,es.string)().trim(),
    dealer_name: (0,es.string)(),
    is_dealer: (0,es.boolean)(),
    dealer: (0,es.string)().required("Please select an option"),
    is_lexus: (0,es.boolean)()
});
/* harmony default export */ var video_consultation = (VideoConsultationSchema);

;// CONCATENATED MODULE: ./src/utils/schemas/index.ts
















































/***/ })

}]);